/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_AwardDocument_AwardDocument } from '../models/Wealthlane_AwardService_AwardDocument_AwardDocument';
import type { Wealthlane_AwardService_Commission_Commission } from '../models/Wealthlane_AwardService_Commission_Commission';
import type { Wealthlane_AwardService_CommissionSchedule_CommissionSchedule } from '../models/Wealthlane_AwardService_CommissionSchedule_CommissionSchedule';
import type { Wealthlane_AwardService_Company_Company } from '../models/Wealthlane_AwardService_Company_Company';
import type { Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess } from '../models/Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess';
import type { Wealthlane_AwardService_DefaultSettlementConfiguration_DefaultSettlementConfiguration } from '../models/Wealthlane_AwardService_DefaultSettlementConfiguration_DefaultSettlementConfiguration';
import type { Wealthlane_AwardService_DefaultVestingTemplate_DefaultVestingTemplate } from '../models/Wealthlane_AwardService_DefaultVestingTemplate_DefaultVestingTemplate';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingTrancheDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingTrancheDto';
import type { Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration } from '../models/Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration';
import type { Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod } from '../models/Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod';
import type { Wealthlane_AwardService_EsppAwards_EsppParticipant } from '../models/Wealthlane_AwardService_EsppAwards_EsppParticipant';
import type { Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchaseItem } from '../models/Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchaseItem';
import type { Wealthlane_AwardService_EstimatePerformanceTracking_EstimatePerformanceTracking } from '../models/Wealthlane_AwardService_EstimatePerformanceTracking_EstimatePerformanceTracking';
import type { Wealthlane_AwardService_FairValue_FairValue } from '../models/Wealthlane_AwardService_FairValue_FairValue';
import type { Wealthlane_AwardService_Grant_Grant } from '../models/Wealthlane_AwardService_Grant_Grant';
import type { Wealthlane_AwardService_GrantDocument_GrantDocument } from '../models/Wealthlane_AwardService_GrantDocument_GrantDocument';
import type { Wealthlane_AwardService_GrantTermsAndConditions_GrantTermsAndConditions } from '../models/Wealthlane_AwardService_GrantTermsAndConditions_GrantTermsAndConditions';
import type { Wealthlane_AwardService_OptionAwards_OptionAwards } from '../models/Wealthlane_AwardService_OptionAwards_OptionAwards';
import type { Wealthlane_AwardService_OptionExercise_OptionExercise } from '../models/Wealthlane_AwardService_OptionExercise_OptionExercise';
import type { Wealthlane_AwardService_ParticipantAwardTermination_ParticipantAwardTermination } from '../models/Wealthlane_AwardService_ParticipantAwardTermination_ParticipantAwardTermination';
import type { Wealthlane_AwardService_ParticipantTermination_ParticipantTermination } from '../models/Wealthlane_AwardService_ParticipantTermination_ParticipantTermination';
import type { Wealthlane_AwardService_PerformanceEvaluation_PerformanceEvaluation } from '../models/Wealthlane_AwardService_PerformanceEvaluation_PerformanceEvaluation';
import type { Wealthlane_AwardService_PerformanceRule_PerformanceRule } from '../models/Wealthlane_AwardService_PerformanceRule_PerformanceRule';
import type { Wealthlane_AwardService_PerformanceRuleApproval_PerformanceRuleApproval } from '../models/Wealthlane_AwardService_PerformanceRuleApproval_PerformanceRuleApproval';
import type { Wealthlane_AwardService_Plan_Plan } from '../models/Wealthlane_AwardService_Plan_Plan';
import type { Wealthlane_AwardService_PlanApproval_PlanApproval } from '../models/Wealthlane_AwardService_PlanApproval_PlanApproval';
import type { Wealthlane_AwardService_PlanDocument_PlanDocument } from '../models/Wealthlane_AwardService_PlanDocument_PlanDocument';
import type { Wealthlane_AwardService_PlanGrantDocumentDetail_PlanGrantDocumentDetails } from '../models/Wealthlane_AwardService_PlanGrantDocumentDetail_PlanGrantDocumentDetails';
import type { Wealthlane_AwardService_PlanPlanTypeCategory_PlanPlanTypeCategory } from '../models/Wealthlane_AwardService_PlanPlanTypeCategory_PlanPlanTypeCategory';
import type { Wealthlane_AwardService_PSUAward_PSUAward } from '../models/Wealthlane_AwardService_PSUAward_PSUAward';
import type { Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate } from '../models/Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate';
import type { Wealthlane_AwardService_RSUAward_RSUAward } from '../models/Wealthlane_AwardService_RSUAward_RSUAward';
import type { Wealthlane_AwardService_RSUAwardApproval_RSUAwardApproval } from '../models/Wealthlane_AwardService_RSUAwardApproval_RSUAwardApproval';
import type { Wealthlane_AwardService_RSUAwardEmailNotificationLog_RSUAwardEmailNotificationLog } from '../models/Wealthlane_AwardService_RSUAwardEmailNotificationLog_RSUAwardEmailNotificationLog';
import type { Wealthlane_AwardService_RSUAwardSignupToken_RSUAwardSignupToken } from '../models/Wealthlane_AwardService_RSUAwardSignupToken_RSUAwardSignupToken';
import type { Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate } from '../models/Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate';
import type { Wealthlane_AwardService_TADRSInstruction_TADRSInstruction } from '../models/Wealthlane_AwardService_TADRSInstruction_TADRSInstruction';
import type { Wealthlane_AwardService_TaxInput_TaxInput } from '../models/Wealthlane_AwardService_TaxInput_TaxInput';
import type { Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward } from '../models/Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward';
import type { Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest } from '../models/Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest';
import type { Wealthlane_AwardService_Transaction_Transaction } from '../models/Wealthlane_AwardService_Transaction_Transaction';
import type { Wealthlane_AwardService_VestingTemplate_VestingTemplate } from '../models/Wealthlane_AwardService_VestingTemplate_VestingTemplate';
import type { Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo } from '../models/Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RsuAwardImportService {
  /**
   * @param taskId
   * @param tenantId
   * @param userId
   * @param sessionId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postApiAwardApiAppRsuAwardImportBackgroundImport(
    taskId?: string,
    tenantId?: string,
    userId?: string,
    sessionId?: string,
    requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/rsu-award-import/background-import',
      query: {
        taskId: taskId,
        tenantId: tenantId,
        userId: userId,
        sessionId: sessionId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param companyId
   * @param companyName
   * @param companyIsEnabled
   * @param companyCommissionOwningCompanyName
   * @param companyCommissionOwningCompanyIsEnabled
   * @param companyCommissionBrokerCompanyName
   * @param companyCommissionBrokerCompanyIsEnabled
   * @param participantId
   * @param participantFirstName
   * @param participantLastName
   * @param participantEmployeeId
   * @param participantEmail
   * @param grantId
   * @param grantPlanUniquePlanNo
   * @param grantPlanName
   * @param grantPlanCompanyId
   * @param grantPlanNumberOfSharesAuthorized
   * @param grantPlanNumberOfSharesAvailable
   * @param grantPlanPlanApprovalStatus
   * @param grantPlanIsEnabled
   * @param grantPlanPlanEffectiveDate
   * @param grantPlanBoardApprovalDate
   * @param grantPlanShareHolderApprovalDate
   * @param grantPlanPlanTerm
   * @param grantPlanEvergreenPlan
   * @param grantPlanDividendEligibility
   * @param grantPlanPoolPoolName
   * @param grantPlanPoolNumberOfSharesAuthorised
   * @param grantPlanPoolNumberOfSharesAvailable
   * @param grantPlanPoolNumberOfSharesUnAvailable
   * @param grantPlanPoolHasExternalPoolRefrence
   * @param grantPoolPoolName
   * @param grantPoolNumberOfSharesAuthorised
   * @param grantPoolNumberOfSharesAvailable
   * @param grantPoolNumberOfSharesUnAvailable
   * @param grantPoolHasExternalPoolRefrence
   * @param grantPlanTypeName
   * @param grantPlanTypeIsEnabled
   * @param grantPlanTypePlanTypeCategoryName
   * @param grantPlanTypePlanTypeCategoryIsEnabled
   * @param grantCompanyName
   * @param grantCompanyIsEnabled
   * @param grantCompanyCommissionOwningCompanyName
   * @param grantCompanyCommissionOwningCompanyIsEnabled
   * @param grantCompanyCommissionBrokerCompanyName
   * @param grantCompanyCommissionBrokerCompanyIsEnabled
   * @param grantVestingTemplateCompanyName
   * @param grantVestingTemplateCompanyIsEnabled
   * @param grantVestingTemplateCompanyCommissionOwningCompanyName
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsEnabled
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyName
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsEnabled
   * @param grantPerformanceRuleCompanyId
   * @param grantGrantAgreementDocumentGrantDocumentName
   * @param grantGrantNoticeDocumentGrantDocumentName
   * @param grantTermsAndConditionDocumentGrantDocumentName
   * @param grantTermsAndConditionTextGrantDocumentName
   * @param vestingStartDate
   * @param grantIssueDate
   * @param vestingTemplateId
   * @param vestingTemplateCompanyName
   * @param vestingTemplateCompanyIsEnabled
   * @param vestingTemplateCompanyCommissionOwningCompanyName
   * @param vestingTemplateCompanyCommissionOwningCompanyIsEnabled
   * @param vestingTemplateCompanyCommissionBrokerCompanyName
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsEnabled
   * @param planId
   * @param planUniquePlanNo
   * @param planName
   * @param planCompanyId
   * @param planNumberOfSharesAuthorized
   * @param planNumberOfSharesAvailable
   * @param planPlanApprovalStatus
   * @param planIsEnabled
   * @param planPlanEffectiveDate
   * @param planBoardApprovalDate
   * @param planShareHolderApprovalDate
   * @param planPlanTerm
   * @param planEvergreenPlan
   * @param planDividendEligibility
   * @param planPoolPoolName
   * @param planPoolNumberOfSharesAuthorised
   * @param planPoolNumberOfSharesAvailable
   * @param planPoolNumberOfSharesUnAvailable
   * @param planPoolHasExternalPoolRefrence
   * @param poolPoolName
   * @param poolNumberOfSharesAuthorised
   * @param poolNumberOfSharesAvailable
   * @param poolNumberOfSharesUnAvailable
   * @param poolHasExternalPoolRefrence
   * @param grantQuantity
   * @param grantNumber
   * @param grantPrice
   * @param marketValueAtGrant
   * @param approvalStatus
   * @param isEnabled
   * @param id
   * @param tenantId
   * @param companyId
   * @param companyTenantId
   * @param companyCreatorId
   * @param companyCreationTime
   * @param companyLastModifierId
   * @param companyLastModificationTime
   * @param companyIsDeleted
   * @param companyDeleterId
   * @param companyDeletionTime
   * @param companyTicker
   * @param companyIsoCalculationSortingTypeId
   * @param companyIsoCalculationSortingTypeId
   * @param companyIsoCalculationSortingTypeSystemName
   * @param companyIsoCalculationSortingTypeDisplayName
   * @param companyIsoCalculationSortingTypeExtraProperties
   * @param companyIsoCalculationSortingTypeConcurrencyStamp
   * @param companyIsEmailEnableToParticipant
   * @param companyCommissionId
   * @param companyDtcParticipantId
   * @param companyIntendedShareRegistrationTypeId
   * @param companyIntendedShareRegistrationTypeSystemName
   * @param companyIntendedShareRegistrationTypeDisplayName
   * @param companyIntendedShareRegistrationTypeLastModificationTime
   * @param companyIntendedShareRegistrationTypeLastModifierId
   * @param companyIntendedShareRegistrationTypeCreationTime
   * @param companyIntendedShareRegistrationTypeCreatorId
   * @param companyIntendedShareRegistrationTypeExtraProperties
   * @param companyIntendedShareRegistrationTypeConcurrencyStamp
   * @param companyIntendedShareRegistrationTypeId
   * @param companyTransactionAcquisitionTypeId
   * @param companyTransactionAcquisitionTypeSystemName
   * @param companyTransactionAcquisitionTypeDisplayName
   * @param companyTransactionAcquisitionTypeLastModificationTime
   * @param companyTransactionAcquisitionTypeLastModifierId
   * @param companyTransactionAcquisitionTypeCreationTime
   * @param companyTransactionAcquisitionTypeCreatorId
   * @param companyTransactionAcquisitionTypeExtraProperties
   * @param companyTransactionAcquisitionTypeConcurrencyStamp
   * @param companyTransactionAcquisitionTypeId
   * @param companyPriceThreshold
   * @param companyIsPartBRequired
   * @param companyIsPartCRequired
   * @param companyCommissionOwningCompanyId
   * @param companyCommissionOwningCompanyId
   * @param companyCommissionOwningCompanyTenantId
   * @param companyCommissionOwningCompanyCreatorId
   * @param companyCommissionOwningCompanyCreationTime
   * @param companyCommissionOwningCompanyLastModifierId
   * @param companyCommissionOwningCompanyLastModificationTime
   * @param companyCommissionOwningCompanyIsDeleted
   * @param companyCommissionOwningCompanyDeleterId
   * @param companyCommissionOwningCompanyDeletionTime
   * @param companyCommissionOwningCompanyTicker
   * @param companyCommissionOwningCompanyIsoCalculationSortingTypeId
   * @param companyCommissionOwningCompanyIsoCalculationSortingTypeId
   * @param companyCommissionOwningCompanyIsoCalculationSortingTypeSystemName
   * @param companyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName
   * @param companyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties
   * @param companyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param companyCommissionOwningCompanyIsEmailEnableToParticipant
   * @param companyCommissionOwningCompanyCommissionId
   * @param companyCommissionOwningCompanyDtcParticipantId
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeId
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param companyCommissionOwningCompanyIntendedShareRegistrationTypeId
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeId
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeSystemName
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param companyCommissionOwningCompanyTransactionAcquisitionTypeId
   * @param companyCommissionOwningCompanyPriceThreshold
   * @param companyCommissionOwningCompanyIsPartBRequired
   * @param companyCommissionOwningCompanyIsPartCRequired
   * @param companyCommissionOwningCompanyCommission
   * @param companyCommissionOwningCompanyCustomerApprovalProcesses
   * @param companyCommissionOwningCompanyVestingTemplates
   * @param companyCommissionOwningCompanyRsuAward
   * @param companyCommissionOwningCompanyOwnedCommissions
   * @param companyCommissionOwningCompanyBrokeredCommissions
   * @param companyCommissionOwningCompanyCommissionSchedules
   * @param companyCommissionOwningCompanyRsuAwardVestingDate
   * @param companyCommissionOwningCompanyElectionWindowConfigurations
   * @param companyCommissionOwningCompanyOptionAwards
   * @param companyCommissionOwningCompanyTradePreClearanceRequests
   * @param companyCommissionOwningCompanyTradePreClearanceParticipantAwards
   * @param companyCommissionOwningCompanyPsuAward
   * @param companyCommissionOwningCompanyPsuAwardVestingDate
   * @param companyCommissionOwningCompanyExtraProperties
   * @param companyCommissionOwningCompanyConcurrencyStamp
   * @param companyCommissionBrokerCompanyId
   * @param companyCommissionBrokerCompanyId
   * @param companyCommissionBrokerCompanyTenantId
   * @param companyCommissionBrokerCompanyCreatorId
   * @param companyCommissionBrokerCompanyCreationTime
   * @param companyCommissionBrokerCompanyLastModifierId
   * @param companyCommissionBrokerCompanyLastModificationTime
   * @param companyCommissionBrokerCompanyIsDeleted
   * @param companyCommissionBrokerCompanyDeleterId
   * @param companyCommissionBrokerCompanyDeletionTime
   * @param companyCommissionBrokerCompanyTicker
   * @param companyCommissionBrokerCompanyIsoCalculationSortingTypeId
   * @param companyCommissionBrokerCompanyIsoCalculationSortingTypeId
   * @param companyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName
   * @param companyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName
   * @param companyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties
   * @param companyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param companyCommissionBrokerCompanyIsEmailEnableToParticipant
   * @param companyCommissionBrokerCompanyCommissionId
   * @param companyCommissionBrokerCompanyDtcParticipantId
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeId
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param companyCommissionBrokerCompanyIntendedShareRegistrationTypeId
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeId
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param companyCommissionBrokerCompanyTransactionAcquisitionTypeId
   * @param companyCommissionBrokerCompanyPriceThreshold
   * @param companyCommissionBrokerCompanyIsPartBRequired
   * @param companyCommissionBrokerCompanyIsPartCRequired
   * @param companyCommissionBrokerCompanyCommission
   * @param companyCommissionBrokerCompanyCustomerApprovalProcesses
   * @param companyCommissionBrokerCompanyVestingTemplates
   * @param companyCommissionBrokerCompanyRsuAward
   * @param companyCommissionBrokerCompanyOwnedCommissions
   * @param companyCommissionBrokerCompanyBrokeredCommissions
   * @param companyCommissionBrokerCompanyCommissionSchedules
   * @param companyCommissionBrokerCompanyRsuAwardVestingDate
   * @param companyCommissionBrokerCompanyElectionWindowConfigurations
   * @param companyCommissionBrokerCompanyOptionAwards
   * @param companyCommissionBrokerCompanyTradePreClearanceRequests
   * @param companyCommissionBrokerCompanyTradePreClearanceParticipantAwards
   * @param companyCommissionBrokerCompanyPsuAward
   * @param companyCommissionBrokerCompanyPsuAwardVestingDate
   * @param companyCommissionBrokerCompanyExtraProperties
   * @param companyCommissionBrokerCompanyConcurrencyStamp
   * @param companyCommissionName
   * @param companyCommissionDescription
   * @param companyCommissionBaseRate
   * @param companyCommissionMaxAmount
   * @param companyCommissionCommissionSchedules
   * @param companyCommissionCompany
   * @param companyCommissionIsDeleted
   * @param companyCommissionDeleterId
   * @param companyCommissionDeletionTime
   * @param companyCommissionLastModificationTime
   * @param companyCommissionLastModifierId
   * @param companyCommissionCreationTime
   * @param companyCommissionCreatorId
   * @param companyCommissionId
   * @param companyCustomerApprovalProcesses
   * @param companyVestingTemplates
   * @param companyRsuAward
   * @param companyOwnedCommissions
   * @param companyBrokeredCommissions
   * @param companyCommissionSchedules
   * @param companyRsuAwardVestingDate
   * @param companyElectionWindowConfigurations
   * @param companyOptionAwards
   * @param companyTradePreClearanceRequests
   * @param companyTradePreClearanceParticipantAwards
   * @param companyPsuAward
   * @param companyPsuAwardVestingDate
   * @param companyExtraProperties
   * @param companyConcurrencyStamp
   * @param participantId
   * @param participantTenantId
   * @param participantCompanyId
   * @param participantPayrollId
   * @param participantMiddleName
   * @param participantDateOfBirth
   * @param participantGender
   * @param participantMaritalStatus
   * @param participantCountryOfLegalResidency
   * @param participantAddressLine1
   * @param participantParticipantApprovalStatus
   * @param participantStatusName
   * @param participantCreatorId
   * @param participantCreationDateTime
   * @param participantHireDate
   * @param participantAbpUserId
   * @param participantIsOnBoarded
   * @param participantJobTitle
   * @param participantDepartment
   * @param participantEmployeeStatus
   * @param participantIsTaxCertificationVerified
   * @param participantEmployeeType
   * @param participantCostCentre
   * @param participantIsTradePreClearanced
   * @param participantIsBlackout
   * @param participantHomeStateAbbreviation
   * @param participantWorkStateAbbreviation
   * @param participantAccountId
   * @param participantIsEmailSend
   * @param participantIsSection16
   * @param participantIsRule144
   * @param participantFullName
   * @param participantTerminationRuleSetId
   * @param participantSettlementTypeId
   * @param participantRsuAwards
   * @param participantOptionAwards
   * @param participantPsuAwards
   * @param participantTradePreClearanceRequests
   * @param participantOptionExercises
   * @param participantPspParticipantId
   * @param participantEsppPurchaseItems
   * @param participantParticipantTerminations
   * @param participantTaxInputs
   * @param participantEsppParticipants
   * @param participantTransactions
   * @param participantTadrsInstructions
   * @param participantTerminationRuleSetId
   * @param participantTerminationRuleSetTenantId
   * @param participantTerminationRuleSetExtraProperties
   * @param participantTerminationRuleSetConcurrencyStamp
   * @param participantSettlementTypeId
   * @param participantSettlementTypeSystemName
   * @param participantSettlementTypeDisplayName
   * @param participantSettlementTypeIsCashSellType
   * @param participantSettlementTypeExtraProperties
   * @param participantSettlementTypeConcurrencyStamp
   * @param participantExtraProperties
   * @param participantConcurrencyStamp
   * @param grantTenantId
   * @param grantCompanyId
   * @param grantUniqueGrantNo
   * @param grantPlanId
   * @param grantPoolId
   * @param grantPlanTypeId
   * @param grantName
   * @param grantIssueDate
   * @param grantIsEnabled
   * @param grantApprovedDate
   * @param grantVestingTemplateId
   * @param grantPerformanceRuleId
   * @param grantApprovalRequired
   * @param grantGrantAgreementDocumentId
   * @param grantGrantNoticeDocumentId
   * @param grantAgreementStatement
   * @param grantAgreementStatementStatus
   * @param grantTermsAndConditionDocumentId
   * @param grantTermsAndConditionTextId
   * @param grantTerminationRuleSetId
   * @param grantSettlementTypeId
   * @param grantPlanTenantId
   * @param grantPlanEligibleShareClass
   * @param grantPlanDescription
   * @param grantPlanEvergreenCriteria
   * @param grantPlanDeathExpirationOption
   * @param grantPlanDisablityExpirationOption
   * @param grantPlanRetirementExpirationOption
   * @param grantPlanVolutaryTerminationOption
   * @param grantPlanInvolutaryTerminationOption
   * @param grantPlanOptionExpirationDate
   * @param grantPlanNumberOfSharesUnAvailable
   * @param grantPlanPlanExpiryDate
   * @param grantPlanWithACause
   * @param grantPlanTerminationRuleSetId
   * @param grantPlanPoolId
   * @param grantPlanPoolTenantId
   * @param grantPlanPoolCompanyId
   * @param grantPlanPoolDescription
   * @param grantPlanPoolExternalPoolName
   * @param grantPlanPoolExternalPoolReferenceId
   * @param grantPlanPoolTransactions
   * @param grantPlanPoolRsuAwards
   * @param grantPlanPoolPsuAwards
   * @param grantPlanPoolOptionAwards
   * @param grantPlanPoolGrants
   * @param grantPlanPoolPlans
   * @param grantPlanPoolIsDeleted
   * @param grantPlanPoolDeleterId
   * @param grantPlanPoolDeletionTime
   * @param grantPlanPoolLastModificationTime
   * @param grantPlanPoolLastModifierId
   * @param grantPlanPoolCreationTime
   * @param grantPlanPoolCreatorId
   * @param grantPlanPoolExtraProperties
   * @param grantPlanPoolConcurrencyStamp
   * @param grantPlanPoolId
   * @param grantPlanAllowEditPlanRelatedDocuments
   * @param grantPlanPlanDocuments
   * @param grantPlanRsuAwards
   * @param grantPlanPsuAwards
   * @param grantPlanGrants
   * @param grantPlanOptionAwards
   * @param grantPlanTradePreClearanceRequests
   * @param grantPlanEsppOfferingPeriods
   * @param grantPlanPlanApprovals
   * @param grantPlanPlanPlanTypeCategories
   * @param grantPlanTerminationRuleSetId
   * @param grantPlanTerminationRuleSetTenantId
   * @param grantPlanTerminationRuleSetExtraProperties
   * @param grantPlanTerminationRuleSetConcurrencyStamp
   * @param grantPlanIsDeleted
   * @param grantPlanDeleterId
   * @param grantPlanDeletionTime
   * @param grantPlanLastModificationTime
   * @param grantPlanLastModifierId
   * @param grantPlanCreationTime
   * @param grantPlanCreatorId
   * @param grantPlanExtraProperties
   * @param grantPlanConcurrencyStamp
   * @param grantPlanId
   * @param grantPoolTenantId
   * @param grantPoolCompanyId
   * @param grantPoolDescription
   * @param grantPoolExternalPoolName
   * @param grantPoolExternalPoolReferenceId
   * @param grantPoolTransactions
   * @param grantPoolRsuAwards
   * @param grantPoolPsuAwards
   * @param grantPoolOptionAwards
   * @param grantPoolGrants
   * @param grantPoolPlans
   * @param grantPoolIsDeleted
   * @param grantPoolDeleterId
   * @param grantPoolDeletionTime
   * @param grantPoolLastModificationTime
   * @param grantPoolLastModifierId
   * @param grantPoolCreationTime
   * @param grantPoolCreatorId
   * @param grantPoolExtraProperties
   * @param grantPoolConcurrencyStamp
   * @param grantPoolId
   * @param grantPlanTypeId
   * @param grantPlanTypePlanTypeCategoryId
   * @param grantPlanTypePlanTypeCategoryId
   * @param grantPlanTypePlanTypeCategoryElectionWindowConfigurations
   * @param grantPlanTypePlanTypeCategoryDefaultSettlementConfigurations
   * @param grantPlanTypePlanTypeCategoryPlanPlanTypeCategories
   * @param grantPlanTypePlanTypeCategoryExtraProperties
   * @param grantPlanTypePlanTypeCategoryConcurrencyStamp
   * @param grantPlanTypeOptionAwards
   * @param grantPlanTypeExtraProperties
   * @param grantPlanTypeConcurrencyStamp
   * @param grantCompanyId
   * @param grantCompanyTenantId
   * @param grantCompanyCreatorId
   * @param grantCompanyCreationTime
   * @param grantCompanyLastModifierId
   * @param grantCompanyLastModificationTime
   * @param grantCompanyIsDeleted
   * @param grantCompanyDeleterId
   * @param grantCompanyDeletionTime
   * @param grantCompanyTicker
   * @param grantCompanyIsoCalculationSortingTypeId
   * @param grantCompanyIsoCalculationSortingTypeId
   * @param grantCompanyIsoCalculationSortingTypeSystemName
   * @param grantCompanyIsoCalculationSortingTypeDisplayName
   * @param grantCompanyIsoCalculationSortingTypeExtraProperties
   * @param grantCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param grantCompanyIsEmailEnableToParticipant
   * @param grantCompanyCommissionId
   * @param grantCompanyDtcParticipantId
   * @param grantCompanyIntendedShareRegistrationTypeId
   * @param grantCompanyIntendedShareRegistrationTypeSystemName
   * @param grantCompanyIntendedShareRegistrationTypeDisplayName
   * @param grantCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param grantCompanyIntendedShareRegistrationTypeLastModifierId
   * @param grantCompanyIntendedShareRegistrationTypeCreationTime
   * @param grantCompanyIntendedShareRegistrationTypeCreatorId
   * @param grantCompanyIntendedShareRegistrationTypeExtraProperties
   * @param grantCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param grantCompanyIntendedShareRegistrationTypeId
   * @param grantCompanyTransactionAcquisitionTypeId
   * @param grantCompanyTransactionAcquisitionTypeSystemName
   * @param grantCompanyTransactionAcquisitionTypeDisplayName
   * @param grantCompanyTransactionAcquisitionTypeLastModificationTime
   * @param grantCompanyTransactionAcquisitionTypeLastModifierId
   * @param grantCompanyTransactionAcquisitionTypeCreationTime
   * @param grantCompanyTransactionAcquisitionTypeCreatorId
   * @param grantCompanyTransactionAcquisitionTypeExtraProperties
   * @param grantCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param grantCompanyTransactionAcquisitionTypeId
   * @param grantCompanyPriceThreshold
   * @param grantCompanyIsPartBRequired
   * @param grantCompanyIsPartCRequired
   * @param grantCompanyCommissionOwningCompanyId
   * @param grantCompanyCommissionOwningCompanyId
   * @param grantCompanyCommissionOwningCompanyTenantId
   * @param grantCompanyCommissionOwningCompanyCreatorId
   * @param grantCompanyCommissionOwningCompanyCreationTime
   * @param grantCompanyCommissionOwningCompanyLastModifierId
   * @param grantCompanyCommissionOwningCompanyLastModificationTime
   * @param grantCompanyCommissionOwningCompanyIsDeleted
   * @param grantCompanyCommissionOwningCompanyDeleterId
   * @param grantCompanyCommissionOwningCompanyDeletionTime
   * @param grantCompanyCommissionOwningCompanyTicker
   * @param grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeId
   * @param grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeId
   * @param grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName
   * @param grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName
   * @param grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties
   * @param grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param grantCompanyCommissionOwningCompanyIsEmailEnableToParticipant
   * @param grantCompanyCommissionOwningCompanyCommissionId
   * @param grantCompanyCommissionOwningCompanyDtcParticipantId
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeId
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeId
   * @param grantCompanyCommissionOwningCompanyPriceThreshold
   * @param grantCompanyCommissionOwningCompanyIsPartBRequired
   * @param grantCompanyCommissionOwningCompanyIsPartCRequired
   * @param grantCompanyCommissionOwningCompanyCommission
   * @param grantCompanyCommissionOwningCompanyCustomerApprovalProcesses
   * @param grantCompanyCommissionOwningCompanyVestingTemplates
   * @param grantCompanyCommissionOwningCompanyRsuAward
   * @param grantCompanyCommissionOwningCompanyOwnedCommissions
   * @param grantCompanyCommissionOwningCompanyBrokeredCommissions
   * @param grantCompanyCommissionOwningCompanyCommissionSchedules
   * @param grantCompanyCommissionOwningCompanyRsuAwardVestingDate
   * @param grantCompanyCommissionOwningCompanyElectionWindowConfigurations
   * @param grantCompanyCommissionOwningCompanyOptionAwards
   * @param grantCompanyCommissionOwningCompanyTradePreClearanceRequests
   * @param grantCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards
   * @param grantCompanyCommissionOwningCompanyPsuAward
   * @param grantCompanyCommissionOwningCompanyPsuAwardVestingDate
   * @param grantCompanyCommissionOwningCompanyExtraProperties
   * @param grantCompanyCommissionOwningCompanyConcurrencyStamp
   * @param grantCompanyCommissionBrokerCompanyId
   * @param grantCompanyCommissionBrokerCompanyId
   * @param grantCompanyCommissionBrokerCompanyTenantId
   * @param grantCompanyCommissionBrokerCompanyCreatorId
   * @param grantCompanyCommissionBrokerCompanyCreationTime
   * @param grantCompanyCommissionBrokerCompanyLastModifierId
   * @param grantCompanyCommissionBrokerCompanyLastModificationTime
   * @param grantCompanyCommissionBrokerCompanyIsDeleted
   * @param grantCompanyCommissionBrokerCompanyDeleterId
   * @param grantCompanyCommissionBrokerCompanyDeletionTime
   * @param grantCompanyCommissionBrokerCompanyTicker
   * @param grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId
   * @param grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId
   * @param grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName
   * @param grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName
   * @param grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties
   * @param grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param grantCompanyCommissionBrokerCompanyIsEmailEnableToParticipant
   * @param grantCompanyCommissionBrokerCompanyCommissionId
   * @param grantCompanyCommissionBrokerCompanyDtcParticipantId
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId
   * @param grantCompanyCommissionBrokerCompanyPriceThreshold
   * @param grantCompanyCommissionBrokerCompanyIsPartBRequired
   * @param grantCompanyCommissionBrokerCompanyIsPartCRequired
   * @param grantCompanyCommissionBrokerCompanyCommission
   * @param grantCompanyCommissionBrokerCompanyCustomerApprovalProcesses
   * @param grantCompanyCommissionBrokerCompanyVestingTemplates
   * @param grantCompanyCommissionBrokerCompanyRsuAward
   * @param grantCompanyCommissionBrokerCompanyOwnedCommissions
   * @param grantCompanyCommissionBrokerCompanyBrokeredCommissions
   * @param grantCompanyCommissionBrokerCompanyCommissionSchedules
   * @param grantCompanyCommissionBrokerCompanyRsuAwardVestingDate
   * @param grantCompanyCommissionBrokerCompanyElectionWindowConfigurations
   * @param grantCompanyCommissionBrokerCompanyOptionAwards
   * @param grantCompanyCommissionBrokerCompanyTradePreClearanceRequests
   * @param grantCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards
   * @param grantCompanyCommissionBrokerCompanyPsuAward
   * @param grantCompanyCommissionBrokerCompanyPsuAwardVestingDate
   * @param grantCompanyCommissionBrokerCompanyExtraProperties
   * @param grantCompanyCommissionBrokerCompanyConcurrencyStamp
   * @param grantCompanyCommissionName
   * @param grantCompanyCommissionDescription
   * @param grantCompanyCommissionBaseRate
   * @param grantCompanyCommissionMaxAmount
   * @param grantCompanyCommissionCommissionSchedules
   * @param grantCompanyCommissionCompany
   * @param grantCompanyCommissionIsDeleted
   * @param grantCompanyCommissionDeleterId
   * @param grantCompanyCommissionDeletionTime
   * @param grantCompanyCommissionLastModificationTime
   * @param grantCompanyCommissionLastModifierId
   * @param grantCompanyCommissionCreationTime
   * @param grantCompanyCommissionCreatorId
   * @param grantCompanyCommissionId
   * @param grantCompanyCustomerApprovalProcesses
   * @param grantCompanyVestingTemplates
   * @param grantCompanyRsuAward
   * @param grantCompanyOwnedCommissions
   * @param grantCompanyBrokeredCommissions
   * @param grantCompanyCommissionSchedules
   * @param grantCompanyRsuAwardVestingDate
   * @param grantCompanyElectionWindowConfigurations
   * @param grantCompanyOptionAwards
   * @param grantCompanyTradePreClearanceRequests
   * @param grantCompanyTradePreClearanceParticipantAwards
   * @param grantCompanyPsuAward
   * @param grantCompanyPsuAwardVestingDate
   * @param grantCompanyExtraProperties
   * @param grantCompanyConcurrencyStamp
   * @param grantVestingTemplateTenantId
   * @param grantVestingTemplateCompanyId
   * @param grantVestingTemplateName
   * @param grantVestingTemplateSummary
   * @param grantVestingTemplateVestingTypeId
   * @param grantVestingTemplateLengthInMonths
   * @param grantVestingTemplateAmountOneInPercentage
   * @param grantVestingTemplateVestsAfterInMonths
   * @param grantVestingTemplateAmountTwoInPercentage
   * @param grantVestingTemplateVestsInMonths
   * @param grantVestingTemplateIntervalInMonths
   * @param grantVestingTemplateIsEnabled
   * @param grantVestingTemplateIsDefaultVestingTemplate
   * @param grantVestingTemplatePeriodStartDate
   * @param grantVestingTemplateRoundingTypeId
   * @param grantVestingTemplateFractionalDecimalDigit
   * @param grantVestingTemplateVestAtEndOfMonth
   * @param grantVestingTemplateSpecificVestingInstruction
   * @param grantVestingTemplateLoadingTypeId
   * @param grantVestingTemplateEndOfTheMonthTypeId
   * @param grantVestingTemplateCompanyId
   * @param grantVestingTemplateCompanyTenantId
   * @param grantVestingTemplateCompanyCreatorId
   * @param grantVestingTemplateCompanyCreationTime
   * @param grantVestingTemplateCompanyLastModifierId
   * @param grantVestingTemplateCompanyLastModificationTime
   * @param grantVestingTemplateCompanyIsDeleted
   * @param grantVestingTemplateCompanyDeleterId
   * @param grantVestingTemplateCompanyDeletionTime
   * @param grantVestingTemplateCompanyTicker
   * @param grantVestingTemplateCompanyIsoCalculationSortingTypeId
   * @param grantVestingTemplateCompanyIsoCalculationSortingTypeId
   * @param grantVestingTemplateCompanyIsoCalculationSortingTypeSystemName
   * @param grantVestingTemplateCompanyIsoCalculationSortingTypeDisplayName
   * @param grantVestingTemplateCompanyIsoCalculationSortingTypeExtraProperties
   * @param grantVestingTemplateCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyIsEmailEnableToParticipant
   * @param grantVestingTemplateCompanyCommissionId
   * @param grantVestingTemplateCompanyDtcParticipantId
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeId
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeSystemName
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeDisplayName
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeLastModifierId
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeCreationTime
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeCreatorId
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeExtraProperties
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyIntendedShareRegistrationTypeId
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeId
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeSystemName
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeDisplayName
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeLastModificationTime
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeLastModifierId
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeCreationTime
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeCreatorId
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeExtraProperties
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyTransactionAcquisitionTypeId
   * @param grantVestingTemplateCompanyPriceThreshold
   * @param grantVestingTemplateCompanyIsPartBRequired
   * @param grantVestingTemplateCompanyIsPartCRequired
   * @param grantVestingTemplateCompanyCommissionOwningCompanyId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTenantId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyCreatorId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyCreationTime
   * @param grantVestingTemplateCompanyCommissionOwningCompanyLastModifierId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyLastModificationTime
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsDeleted
   * @param grantVestingTemplateCompanyCommissionOwningCompanyDeleterId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyDeletionTime
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTicker
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsEmailEnableToParticipant
   * @param grantVestingTemplateCompanyCommissionOwningCompanyCommissionId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyDtcParticipantId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId
   * @param grantVestingTemplateCompanyCommissionOwningCompanyPriceThreshold
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsPartBRequired
   * @param grantVestingTemplateCompanyCommissionOwningCompanyIsPartCRequired
   * @param grantVestingTemplateCompanyCommissionOwningCompanyCommission
   * @param grantVestingTemplateCompanyCommissionOwningCompanyCustomerApprovalProcesses
   * @param grantVestingTemplateCompanyCommissionOwningCompanyVestingTemplates
   * @param grantVestingTemplateCompanyCommissionOwningCompanyRsuAward
   * @param grantVestingTemplateCompanyCommissionOwningCompanyOwnedCommissions
   * @param grantVestingTemplateCompanyCommissionOwningCompanyBrokeredCommissions
   * @param grantVestingTemplateCompanyCommissionOwningCompanyCommissionSchedules
   * @param grantVestingTemplateCompanyCommissionOwningCompanyRsuAwardVestingDate
   * @param grantVestingTemplateCompanyCommissionOwningCompanyElectionWindowConfigurations
   * @param grantVestingTemplateCompanyCommissionOwningCompanyOptionAwards
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTradePreClearanceRequests
   * @param grantVestingTemplateCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards
   * @param grantVestingTemplateCompanyCommissionOwningCompanyPsuAward
   * @param grantVestingTemplateCompanyCommissionOwningCompanyPsuAwardVestingDate
   * @param grantVestingTemplateCompanyCommissionOwningCompanyExtraProperties
   * @param grantVestingTemplateCompanyCommissionOwningCompanyConcurrencyStamp
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTenantId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyCreatorId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyCreationTime
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyLastModifierId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyLastModificationTime
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsDeleted
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyDeleterId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyDeletionTime
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTicker
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsEmailEnableToParticipant
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyCommissionId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyDtcParticipantId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyPriceThreshold
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsPartBRequired
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyIsPartCRequired
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyCommission
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyCustomerApprovalProcesses
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyVestingTemplates
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyRsuAward
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyOwnedCommissions
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyBrokeredCommissions
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyCommissionSchedules
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyRsuAwardVestingDate
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyElectionWindowConfigurations
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyOptionAwards
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceRequests
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyPsuAward
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyPsuAwardVestingDate
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyExtraProperties
   * @param grantVestingTemplateCompanyCommissionBrokerCompanyConcurrencyStamp
   * @param grantVestingTemplateCompanyCommissionName
   * @param grantVestingTemplateCompanyCommissionDescription
   * @param grantVestingTemplateCompanyCommissionBaseRate
   * @param grantVestingTemplateCompanyCommissionMaxAmount
   * @param grantVestingTemplateCompanyCommissionCommissionSchedules
   * @param grantVestingTemplateCompanyCommissionCompany
   * @param grantVestingTemplateCompanyCommissionIsDeleted
   * @param grantVestingTemplateCompanyCommissionDeleterId
   * @param grantVestingTemplateCompanyCommissionDeletionTime
   * @param grantVestingTemplateCompanyCommissionLastModificationTime
   * @param grantVestingTemplateCompanyCommissionLastModifierId
   * @param grantVestingTemplateCompanyCommissionCreationTime
   * @param grantVestingTemplateCompanyCommissionCreatorId
   * @param grantVestingTemplateCompanyCommissionId
   * @param grantVestingTemplateCompanyCustomerApprovalProcesses
   * @param grantVestingTemplateCompanyVestingTemplates
   * @param grantVestingTemplateCompanyRsuAward
   * @param grantVestingTemplateCompanyOwnedCommissions
   * @param grantVestingTemplateCompanyBrokeredCommissions
   * @param grantVestingTemplateCompanyCommissionSchedules
   * @param grantVestingTemplateCompanyRsuAwardVestingDate
   * @param grantVestingTemplateCompanyElectionWindowConfigurations
   * @param grantVestingTemplateCompanyOptionAwards
   * @param grantVestingTemplateCompanyTradePreClearanceRequests
   * @param grantVestingTemplateCompanyTradePreClearanceParticipantAwards
   * @param grantVestingTemplateCompanyPsuAward
   * @param grantVestingTemplateCompanyPsuAwardVestingDate
   * @param grantVestingTemplateCompanyExtraProperties
   * @param grantVestingTemplateCompanyConcurrencyStamp
   * @param grantVestingTemplateVestingTypeName
   * @param grantVestingTemplateVestingTypeIsCliffVesting
   * @param grantVestingTemplateVestingTypeIsStepVesting
   * @param grantVestingTemplateVestingTypeIsHybridVesting
   * @param grantVestingTemplateVestingTypeIsCustomVesting
   * @param grantVestingTemplateVestingTypeIsSpecificVesting
   * @param grantVestingTemplateVestingTypeIsCustomVestingTranche
   * @param grantVestingTemplateVestingTypeIsEnabled
   * @param grantVestingTemplateVestingTypeVestingTemplates
   * @param grantVestingTemplateVestingTypeDefaultVestingTemplates
   * @param grantVestingTemplateVestingTypeIsDeleted
   * @param grantVestingTemplateVestingTypeDeleterId
   * @param grantVestingTemplateVestingTypeDeletionTime
   * @param grantVestingTemplateVestingTypeLastModificationTime
   * @param grantVestingTemplateVestingTypeLastModifierId
   * @param grantVestingTemplateVestingTypeCreationTime
   * @param grantVestingTemplateVestingTypeCreatorId
   * @param grantVestingTemplateVestingTypeExtraProperties
   * @param grantVestingTemplateVestingTypeConcurrencyStamp
   * @param grantVestingTemplateVestingTypeId
   * @param grantVestingTemplateRoundingTypeId
   * @param grantVestingTemplateRoundingTypeDisplayName
   * @param grantVestingTemplateRoundingTypeSystemName
   * @param grantVestingTemplateRoundingTypeVestingTemplates
   * @param grantVestingTemplateRoundingTypeDefaultVestingTemplates
   * @param grantVestingTemplateRoundingTypeExtraProperties
   * @param grantVestingTemplateRoundingTypeConcurrencyStamp
   * @param grantVestingTemplateRsuAwards
   * @param grantVestingTemplateGrants
   * @param grantVestingTemplateOptionAwards
   * @param grantVestingTemplatePsuAwards
   * @param grantVestingTemplateLoadingTypeSystemName
   * @param grantVestingTemplateLoadingTypeDisplayName
   * @param grantVestingTemplateLoadingTypeLastModificationTime
   * @param grantVestingTemplateLoadingTypeLastModifierId
   * @param grantVestingTemplateLoadingTypeCreationTime
   * @param grantVestingTemplateLoadingTypeCreatorId
   * @param grantVestingTemplateLoadingTypeExtraProperties
   * @param grantVestingTemplateLoadingTypeConcurrencyStamp
   * @param grantVestingTemplateLoadingTypeId
   * @param grantVestingTemplateEndOfTheMonthTypeSystemName
   * @param grantVestingTemplateEndOfTheMonthTypeDisplayName
   * @param grantVestingTemplateEndOfTheMonthTypeLastModificationTime
   * @param grantVestingTemplateEndOfTheMonthTypeLastModifierId
   * @param grantVestingTemplateEndOfTheMonthTypeCreationTime
   * @param grantVestingTemplateEndOfTheMonthTypeCreatorId
   * @param grantVestingTemplateEndOfTheMonthTypeExtraProperties
   * @param grantVestingTemplateEndOfTheMonthTypeConcurrencyStamp
   * @param grantVestingTemplateEndOfTheMonthTypeId
   * @param grantVestingTemplateIsDeleted
   * @param grantVestingTemplateDeleterId
   * @param grantVestingTemplateDeletionTime
   * @param grantVestingTemplateLastModificationTime
   * @param grantVestingTemplateLastModifierId
   * @param grantVestingTemplateCreationTime
   * @param grantVestingTemplateCreatorId
   * @param grantVestingTemplateExtraProperties
   * @param grantVestingTemplateConcurrencyStamp
   * @param grantVestingTemplateId
   * @param grantPerformanceRuleTenantId
   * @param grantPerformanceRuleRuleName
   * @param grantPerformanceRuleRuleTypeId
   * @param grantPerformanceRuleMinimumPercentage
   * @param grantPerformanceRuleMaximumPercentage
   * @param grantPerformanceRuleRuleDescription
   * @param grantPerformanceRuleRuleSummary
   * @param grantPerformanceRuleIsAvailable
   * @param grantPerformanceRuleShowRuleDisplayToParticipant
   * @param grantPerformanceRuleShowPerformanceTrackingToParticipant
   * @param grantPerformanceRuleEvaluationPeriodStartDate
   * @param grantPerformanceRuleEvaluationPeriodEndDate
   * @param grantPerformanceRuleApprovalStatusId
   * @param grantPerformanceRuleAvailableStatusId
   * @param grantPerformanceRuleEarnedStatusId
   * @param grantPerformanceRuleRuleTypeId
   * @param grantPerformanceRuleRuleTypeSystemName
   * @param grantPerformanceRuleRuleTypeDisplayName
   * @param grantPerformanceRuleRuleTypePerformanceRules
   * @param grantPerformanceRuleRuleTypeExtraProperties
   * @param grantPerformanceRuleRuleTypeConcurrencyStamp
   * @param grantPerformanceRuleApprovalStatusId
   * @param grantPerformanceRuleApprovalStatusSystemName
   * @param grantPerformanceRuleApprovalStatusDisplayName
   * @param grantPerformanceRuleApprovalStatusPerformanceRules
   * @param grantPerformanceRuleApprovalStatusExtraProperties
   * @param grantPerformanceRuleApprovalStatusConcurrencyStamp
   * @param grantPerformanceRuleEarnedStatusId
   * @param grantPerformanceRuleEarnedStatusSystemName
   * @param grantPerformanceRuleEarnedStatusDisplayName
   * @param grantPerformanceRuleEarnedStatusPerformanceRules
   * @param grantPerformanceRuleEarnedStatusExtraProperties
   * @param grantPerformanceRuleEarnedStatusConcurrencyStamp
   * @param grantPerformanceRuleAvailableStatusId
   * @param grantPerformanceRuleAvailableStatusSystemName
   * @param grantPerformanceRuleAvailableStatusDisplayName
   * @param grantPerformanceRuleAvailableStatusPerformanceRules
   * @param grantPerformanceRuleAvailableStatusExtraProperties
   * @param grantPerformanceRuleAvailableStatusConcurrencyStamp
   * @param grantPerformanceRulePerformanceEvaluations
   * @param grantPerformanceRuleEstimatePerformanceTracking
   * @param grantPerformanceRuleGrants
   * @param grantPerformanceRulePerformanceRuleApprovals
   * @param grantPerformanceRuleIsDeleted
   * @param grantPerformanceRuleDeleterId
   * @param grantPerformanceRuleDeletionTime
   * @param grantPerformanceRuleLastModificationTime
   * @param grantPerformanceRuleLastModifierId
   * @param grantPerformanceRuleCreationTime
   * @param grantPerformanceRuleCreatorId
   * @param grantPerformanceRuleExtraProperties
   * @param grantPerformanceRuleConcurrencyStamp
   * @param grantPerformanceRuleId
   * @param grantRsuAwards
   * @param grantGrantDocuments
   * @param grantPsuAwards
   * @param grantGrantAgreementDocumentTenantId
   * @param grantGrantAgreementDocumentPlanId
   * @param grantGrantAgreementDocumentDescription
   * @param grantGrantAgreementDocumentGrantDocumentType
   * @param grantGrantAgreementDocumentGrantTermsAndConditionText
   * @param grantGrantAgreementDocumentTnCDocumentEsppOfferingPeriods
   * @param grantGrantAgreementDocumentNoticeDocumentEsppOfferingPeriods
   * @param grantGrantAgreementDocumentAgreementDocumentEsppOfferingPeriods
   * @param grantGrantAgreementDocumentTnCDocumentTextEsppOfferingPeriods
   * @param grantGrantAgreementDocumentGrantAgreementDocuments
   * @param grantGrantAgreementDocumentGrantNoticeDocuments
   * @param grantGrantAgreementDocumentGrantTermsAndConditionDocuments
   * @param grantGrantAgreementDocumentGrantTermsAndConditionTexts
   * @param grantGrantAgreementDocumentPlanGrantDocumentDetails
   * @param grantGrantAgreementDocumentIsDeleted
   * @param grantGrantAgreementDocumentDeleterId
   * @param grantGrantAgreementDocumentDeletionTime
   * @param grantGrantAgreementDocumentLastModificationTime
   * @param grantGrantAgreementDocumentLastModifierId
   * @param grantGrantAgreementDocumentCreationTime
   * @param grantGrantAgreementDocumentCreatorId
   * @param grantGrantAgreementDocumentExtraProperties
   * @param grantGrantAgreementDocumentConcurrencyStamp
   * @param grantGrantAgreementDocumentId
   * @param grantGrantNoticeDocumentTenantId
   * @param grantGrantNoticeDocumentPlanId
   * @param grantGrantNoticeDocumentDescription
   * @param grantGrantNoticeDocumentGrantDocumentType
   * @param grantGrantNoticeDocumentGrantTermsAndConditionText
   * @param grantGrantNoticeDocumentTnCDocumentEsppOfferingPeriods
   * @param grantGrantNoticeDocumentNoticeDocumentEsppOfferingPeriods
   * @param grantGrantNoticeDocumentAgreementDocumentEsppOfferingPeriods
   * @param grantGrantNoticeDocumentTnCDocumentTextEsppOfferingPeriods
   * @param grantGrantNoticeDocumentGrantAgreementDocuments
   * @param grantGrantNoticeDocumentGrantNoticeDocuments
   * @param grantGrantNoticeDocumentGrantTermsAndConditionDocuments
   * @param grantGrantNoticeDocumentGrantTermsAndConditionTexts
   * @param grantGrantNoticeDocumentPlanGrantDocumentDetails
   * @param grantGrantNoticeDocumentIsDeleted
   * @param grantGrantNoticeDocumentDeleterId
   * @param grantGrantNoticeDocumentDeletionTime
   * @param grantGrantNoticeDocumentLastModificationTime
   * @param grantGrantNoticeDocumentLastModifierId
   * @param grantGrantNoticeDocumentCreationTime
   * @param grantGrantNoticeDocumentCreatorId
   * @param grantGrantNoticeDocumentExtraProperties
   * @param grantGrantNoticeDocumentConcurrencyStamp
   * @param grantGrantNoticeDocumentId
   * @param grantTermsAndConditionDocumentTenantId
   * @param grantTermsAndConditionDocumentPlanId
   * @param grantTermsAndConditionDocumentDescription
   * @param grantTermsAndConditionDocumentGrantDocumentType
   * @param grantTermsAndConditionDocumentGrantTermsAndConditionText
   * @param grantTermsAndConditionDocumentTnCDocumentEsppOfferingPeriods
   * @param grantTermsAndConditionDocumentNoticeDocumentEsppOfferingPeriods
   * @param grantTermsAndConditionDocumentAgreementDocumentEsppOfferingPeriods
   * @param grantTermsAndConditionDocumentTnCDocumentTextEsppOfferingPeriods
   * @param grantTermsAndConditionDocumentGrantAgreementDocuments
   * @param grantTermsAndConditionDocumentGrantNoticeDocuments
   * @param grantTermsAndConditionDocumentGrantTermsAndConditionDocuments
   * @param grantTermsAndConditionDocumentGrantTermsAndConditionTexts
   * @param grantTermsAndConditionDocumentPlanGrantDocumentDetails
   * @param grantTermsAndConditionDocumentIsDeleted
   * @param grantTermsAndConditionDocumentDeleterId
   * @param grantTermsAndConditionDocumentDeletionTime
   * @param grantTermsAndConditionDocumentLastModificationTime
   * @param grantTermsAndConditionDocumentLastModifierId
   * @param grantTermsAndConditionDocumentCreationTime
   * @param grantTermsAndConditionDocumentCreatorId
   * @param grantTermsAndConditionDocumentExtraProperties
   * @param grantTermsAndConditionDocumentConcurrencyStamp
   * @param grantTermsAndConditionDocumentId
   * @param grantTermsAndConditionTextTenantId
   * @param grantTermsAndConditionTextPlanId
   * @param grantTermsAndConditionTextDescription
   * @param grantTermsAndConditionTextGrantDocumentType
   * @param grantTermsAndConditionTextGrantTermsAndConditionText
   * @param grantTermsAndConditionTextTnCDocumentEsppOfferingPeriods
   * @param grantTermsAndConditionTextNoticeDocumentEsppOfferingPeriods
   * @param grantTermsAndConditionTextAgreementDocumentEsppOfferingPeriods
   * @param grantTermsAndConditionTextTnCDocumentTextEsppOfferingPeriods
   * @param grantTermsAndConditionTextGrantAgreementDocuments
   * @param grantTermsAndConditionTextGrantNoticeDocuments
   * @param grantTermsAndConditionTextGrantTermsAndConditionDocuments
   * @param grantTermsAndConditionTextGrantTermsAndConditionTexts
   * @param grantTermsAndConditionTextPlanGrantDocumentDetails
   * @param grantTermsAndConditionTextIsDeleted
   * @param grantTermsAndConditionTextDeleterId
   * @param grantTermsAndConditionTextDeletionTime
   * @param grantTermsAndConditionTextLastModificationTime
   * @param grantTermsAndConditionTextLastModifierId
   * @param grantTermsAndConditionTextCreationTime
   * @param grantTermsAndConditionTextCreatorId
   * @param grantTermsAndConditionTextExtraProperties
   * @param grantTermsAndConditionTextConcurrencyStamp
   * @param grantTermsAndConditionTextId
   * @param grantGrantTermsAndConditions
   * @param grantOptionAwards
   * @param grantTerminationRuleSetId
   * @param grantTerminationRuleSetTenantId
   * @param grantTerminationRuleSetExtraProperties
   * @param grantTerminationRuleSetConcurrencyStamp
   * @param grantSettlementTypeId
   * @param grantSettlementTypeSystemName
   * @param grantSettlementTypeDisplayName
   * @param grantSettlementTypeIsCashSellType
   * @param grantSettlementTypeExtraProperties
   * @param grantSettlementTypeConcurrencyStamp
   * @param grantIsDeleted
   * @param grantDeleterId
   * @param grantDeletionTime
   * @param grantLastModificationTime
   * @param grantLastModifierId
   * @param grantCreationTime
   * @param grantCreatorId
   * @param grantId
   * @param vestingTemplateTenantId
   * @param vestingTemplateCompanyId
   * @param vestingTemplateName
   * @param vestingTemplateSummary
   * @param vestingTemplateVestingTypeId
   * @param vestingTemplateLengthInMonths
   * @param vestingTemplateAmountOneInPercentage
   * @param vestingTemplateVestsAfterInMonths
   * @param vestingTemplateAmountTwoInPercentage
   * @param vestingTemplateVestsInMonths
   * @param vestingTemplateIntervalInMonths
   * @param vestingTemplateIsEnabled
   * @param vestingTemplateIsDefaultVestingTemplate
   * @param vestingTemplatePeriodStartDate
   * @param vestingTemplateRoundingTypeId
   * @param vestingTemplateFractionalDecimalDigit
   * @param vestingTemplateVestAtEndOfMonth
   * @param vestingTemplateSpecificVestingInstruction
   * @param vestingTemplateLoadingTypeId
   * @param vestingTemplateEndOfTheMonthTypeId
   * @param vestingTemplateCompanyId
   * @param vestingTemplateCompanyTenantId
   * @param vestingTemplateCompanyCreatorId
   * @param vestingTemplateCompanyCreationTime
   * @param vestingTemplateCompanyLastModifierId
   * @param vestingTemplateCompanyLastModificationTime
   * @param vestingTemplateCompanyIsDeleted
   * @param vestingTemplateCompanyDeleterId
   * @param vestingTemplateCompanyDeletionTime
   * @param vestingTemplateCompanyTicker
   * @param vestingTemplateCompanyIsoCalculationSortingTypeId
   * @param vestingTemplateCompanyIsoCalculationSortingTypeId
   * @param vestingTemplateCompanyIsoCalculationSortingTypeSystemName
   * @param vestingTemplateCompanyIsoCalculationSortingTypeDisplayName
   * @param vestingTemplateCompanyIsoCalculationSortingTypeExtraProperties
   * @param vestingTemplateCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param vestingTemplateCompanyIsEmailEnableToParticipant
   * @param vestingTemplateCompanyCommissionId
   * @param vestingTemplateCompanyDtcParticipantId
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeId
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeSystemName
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeDisplayName
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeLastModifierId
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeCreationTime
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeCreatorId
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeExtraProperties
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param vestingTemplateCompanyIntendedShareRegistrationTypeId
   * @param vestingTemplateCompanyTransactionAcquisitionTypeId
   * @param vestingTemplateCompanyTransactionAcquisitionTypeSystemName
   * @param vestingTemplateCompanyTransactionAcquisitionTypeDisplayName
   * @param vestingTemplateCompanyTransactionAcquisitionTypeLastModificationTime
   * @param vestingTemplateCompanyTransactionAcquisitionTypeLastModifierId
   * @param vestingTemplateCompanyTransactionAcquisitionTypeCreationTime
   * @param vestingTemplateCompanyTransactionAcquisitionTypeCreatorId
   * @param vestingTemplateCompanyTransactionAcquisitionTypeExtraProperties
   * @param vestingTemplateCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param vestingTemplateCompanyTransactionAcquisitionTypeId
   * @param vestingTemplateCompanyPriceThreshold
   * @param vestingTemplateCompanyIsPartBRequired
   * @param vestingTemplateCompanyIsPartCRequired
   * @param vestingTemplateCompanyCommissionOwningCompanyId
   * @param vestingTemplateCompanyCommissionOwningCompanyId
   * @param vestingTemplateCompanyCommissionOwningCompanyTenantId
   * @param vestingTemplateCompanyCommissionOwningCompanyCreatorId
   * @param vestingTemplateCompanyCommissionOwningCompanyCreationTime
   * @param vestingTemplateCompanyCommissionOwningCompanyLastModifierId
   * @param vestingTemplateCompanyCommissionOwningCompanyLastModificationTime
   * @param vestingTemplateCompanyCommissionOwningCompanyIsDeleted
   * @param vestingTemplateCompanyCommissionOwningCompanyDeleterId
   * @param vestingTemplateCompanyCommissionOwningCompanyDeletionTime
   * @param vestingTemplateCompanyCommissionOwningCompanyTicker
   * @param vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId
   * @param vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId
   * @param vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName
   * @param vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName
   * @param vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties
   * @param vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param vestingTemplateCompanyCommissionOwningCompanyIsEmailEnableToParticipant
   * @param vestingTemplateCompanyCommissionOwningCompanyCommissionId
   * @param vestingTemplateCompanyCommissionOwningCompanyDtcParticipantId
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId
   * @param vestingTemplateCompanyCommissionOwningCompanyPriceThreshold
   * @param vestingTemplateCompanyCommissionOwningCompanyIsPartBRequired
   * @param vestingTemplateCompanyCommissionOwningCompanyIsPartCRequired
   * @param vestingTemplateCompanyCommissionOwningCompanyCommission
   * @param vestingTemplateCompanyCommissionOwningCompanyCustomerApprovalProcesses
   * @param vestingTemplateCompanyCommissionOwningCompanyVestingTemplates
   * @param vestingTemplateCompanyCommissionOwningCompanyRsuAward
   * @param vestingTemplateCompanyCommissionOwningCompanyOwnedCommissions
   * @param vestingTemplateCompanyCommissionOwningCompanyBrokeredCommissions
   * @param vestingTemplateCompanyCommissionOwningCompanyCommissionSchedules
   * @param vestingTemplateCompanyCommissionOwningCompanyRsuAwardVestingDate
   * @param vestingTemplateCompanyCommissionOwningCompanyElectionWindowConfigurations
   * @param vestingTemplateCompanyCommissionOwningCompanyOptionAwards
   * @param vestingTemplateCompanyCommissionOwningCompanyTradePreClearanceRequests
   * @param vestingTemplateCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards
   * @param vestingTemplateCompanyCommissionOwningCompanyPsuAward
   * @param vestingTemplateCompanyCommissionOwningCompanyPsuAwardVestingDate
   * @param vestingTemplateCompanyCommissionOwningCompanyExtraProperties
   * @param vestingTemplateCompanyCommissionOwningCompanyConcurrencyStamp
   * @param vestingTemplateCompanyCommissionBrokerCompanyId
   * @param vestingTemplateCompanyCommissionBrokerCompanyId
   * @param vestingTemplateCompanyCommissionBrokerCompanyTenantId
   * @param vestingTemplateCompanyCommissionBrokerCompanyCreatorId
   * @param vestingTemplateCompanyCommissionBrokerCompanyCreationTime
   * @param vestingTemplateCompanyCommissionBrokerCompanyLastModifierId
   * @param vestingTemplateCompanyCommissionBrokerCompanyLastModificationTime
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsDeleted
   * @param vestingTemplateCompanyCommissionBrokerCompanyDeleterId
   * @param vestingTemplateCompanyCommissionBrokerCompanyDeletionTime
   * @param vestingTemplateCompanyCommissionBrokerCompanyTicker
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsEmailEnableToParticipant
   * @param vestingTemplateCompanyCommissionBrokerCompanyCommissionId
   * @param vestingTemplateCompanyCommissionBrokerCompanyDtcParticipantId
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp
   * @param vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp
   * @param vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId
   * @param vestingTemplateCompanyCommissionBrokerCompanyPriceThreshold
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsPartBRequired
   * @param vestingTemplateCompanyCommissionBrokerCompanyIsPartCRequired
   * @param vestingTemplateCompanyCommissionBrokerCompanyCommission
   * @param vestingTemplateCompanyCommissionBrokerCompanyCustomerApprovalProcesses
   * @param vestingTemplateCompanyCommissionBrokerCompanyVestingTemplates
   * @param vestingTemplateCompanyCommissionBrokerCompanyRsuAward
   * @param vestingTemplateCompanyCommissionBrokerCompanyOwnedCommissions
   * @param vestingTemplateCompanyCommissionBrokerCompanyBrokeredCommissions
   * @param vestingTemplateCompanyCommissionBrokerCompanyCommissionSchedules
   * @param vestingTemplateCompanyCommissionBrokerCompanyRsuAwardVestingDate
   * @param vestingTemplateCompanyCommissionBrokerCompanyElectionWindowConfigurations
   * @param vestingTemplateCompanyCommissionBrokerCompanyOptionAwards
   * @param vestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceRequests
   * @param vestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards
   * @param vestingTemplateCompanyCommissionBrokerCompanyPsuAward
   * @param vestingTemplateCompanyCommissionBrokerCompanyPsuAwardVestingDate
   * @param vestingTemplateCompanyCommissionBrokerCompanyExtraProperties
   * @param vestingTemplateCompanyCommissionBrokerCompanyConcurrencyStamp
   * @param vestingTemplateCompanyCommissionName
   * @param vestingTemplateCompanyCommissionDescription
   * @param vestingTemplateCompanyCommissionBaseRate
   * @param vestingTemplateCompanyCommissionMaxAmount
   * @param vestingTemplateCompanyCommissionCommissionSchedules
   * @param vestingTemplateCompanyCommissionCompany
   * @param vestingTemplateCompanyCommissionIsDeleted
   * @param vestingTemplateCompanyCommissionDeleterId
   * @param vestingTemplateCompanyCommissionDeletionTime
   * @param vestingTemplateCompanyCommissionLastModificationTime
   * @param vestingTemplateCompanyCommissionLastModifierId
   * @param vestingTemplateCompanyCommissionCreationTime
   * @param vestingTemplateCompanyCommissionCreatorId
   * @param vestingTemplateCompanyCommissionId
   * @param vestingTemplateCompanyCustomerApprovalProcesses
   * @param vestingTemplateCompanyVestingTemplates
   * @param vestingTemplateCompanyRsuAward
   * @param vestingTemplateCompanyOwnedCommissions
   * @param vestingTemplateCompanyBrokeredCommissions
   * @param vestingTemplateCompanyCommissionSchedules
   * @param vestingTemplateCompanyRsuAwardVestingDate
   * @param vestingTemplateCompanyElectionWindowConfigurations
   * @param vestingTemplateCompanyOptionAwards
   * @param vestingTemplateCompanyTradePreClearanceRequests
   * @param vestingTemplateCompanyTradePreClearanceParticipantAwards
   * @param vestingTemplateCompanyPsuAward
   * @param vestingTemplateCompanyPsuAwardVestingDate
   * @param vestingTemplateCompanyExtraProperties
   * @param vestingTemplateCompanyConcurrencyStamp
   * @param vestingTemplateVestingTypeName
   * @param vestingTemplateVestingTypeIsCliffVesting
   * @param vestingTemplateVestingTypeIsStepVesting
   * @param vestingTemplateVestingTypeIsHybridVesting
   * @param vestingTemplateVestingTypeIsCustomVesting
   * @param vestingTemplateVestingTypeIsSpecificVesting
   * @param vestingTemplateVestingTypeIsCustomVestingTranche
   * @param vestingTemplateVestingTypeIsEnabled
   * @param vestingTemplateVestingTypeVestingTemplates
   * @param vestingTemplateVestingTypeDefaultVestingTemplates
   * @param vestingTemplateVestingTypeIsDeleted
   * @param vestingTemplateVestingTypeDeleterId
   * @param vestingTemplateVestingTypeDeletionTime
   * @param vestingTemplateVestingTypeLastModificationTime
   * @param vestingTemplateVestingTypeLastModifierId
   * @param vestingTemplateVestingTypeCreationTime
   * @param vestingTemplateVestingTypeCreatorId
   * @param vestingTemplateVestingTypeExtraProperties
   * @param vestingTemplateVestingTypeConcurrencyStamp
   * @param vestingTemplateVestingTypeId
   * @param vestingTemplateRoundingTypeId
   * @param vestingTemplateRoundingTypeDisplayName
   * @param vestingTemplateRoundingTypeSystemName
   * @param vestingTemplateRoundingTypeVestingTemplates
   * @param vestingTemplateRoundingTypeDefaultVestingTemplates
   * @param vestingTemplateRoundingTypeExtraProperties
   * @param vestingTemplateRoundingTypeConcurrencyStamp
   * @param vestingTemplateRsuAwards
   * @param vestingTemplateGrants
   * @param vestingTemplateOptionAwards
   * @param vestingTemplatePsuAwards
   * @param vestingTemplateLoadingTypeSystemName
   * @param vestingTemplateLoadingTypeDisplayName
   * @param vestingTemplateLoadingTypeLastModificationTime
   * @param vestingTemplateLoadingTypeLastModifierId
   * @param vestingTemplateLoadingTypeCreationTime
   * @param vestingTemplateLoadingTypeCreatorId
   * @param vestingTemplateLoadingTypeExtraProperties
   * @param vestingTemplateLoadingTypeConcurrencyStamp
   * @param vestingTemplateLoadingTypeId
   * @param vestingTemplateEndOfTheMonthTypeSystemName
   * @param vestingTemplateEndOfTheMonthTypeDisplayName
   * @param vestingTemplateEndOfTheMonthTypeLastModificationTime
   * @param vestingTemplateEndOfTheMonthTypeLastModifierId
   * @param vestingTemplateEndOfTheMonthTypeCreationTime
   * @param vestingTemplateEndOfTheMonthTypeCreatorId
   * @param vestingTemplateEndOfTheMonthTypeExtraProperties
   * @param vestingTemplateEndOfTheMonthTypeConcurrencyStamp
   * @param vestingTemplateEndOfTheMonthTypeId
   * @param vestingTemplateIsDeleted
   * @param vestingTemplateDeleterId
   * @param vestingTemplateDeletionTime
   * @param vestingTemplateLastModificationTime
   * @param vestingTemplateLastModifierId
   * @param vestingTemplateCreationTime
   * @param vestingTemplateCreatorId
   * @param vestingTemplateExtraProperties
   * @param vestingTemplateConcurrencyStamp
   * @param vestingTemplateId
   * @param planTenantId
   * @param planEligibleShareClass
   * @param planDescription
   * @param planEvergreenCriteria
   * @param planDeathExpirationOption
   * @param planDisablityExpirationOption
   * @param planRetirementExpirationOption
   * @param planVolutaryTerminationOption
   * @param planInvolutaryTerminationOption
   * @param planOptionExpirationDate
   * @param planNumberOfSharesUnAvailable
   * @param planPlanExpiryDate
   * @param planWithACause
   * @param planTerminationRuleSetId
   * @param planPoolId
   * @param planPoolTenantId
   * @param planPoolCompanyId
   * @param planPoolDescription
   * @param planPoolExternalPoolName
   * @param planPoolExternalPoolReferenceId
   * @param planPoolTransactions
   * @param planPoolRsuAwards
   * @param planPoolPsuAwards
   * @param planPoolOptionAwards
   * @param planPoolGrants
   * @param planPoolPlans
   * @param planPoolIsDeleted
   * @param planPoolDeleterId
   * @param planPoolDeletionTime
   * @param planPoolLastModificationTime
   * @param planPoolLastModifierId
   * @param planPoolCreationTime
   * @param planPoolCreatorId
   * @param planPoolExtraProperties
   * @param planPoolConcurrencyStamp
   * @param planPoolId
   * @param planAllowEditPlanRelatedDocuments
   * @param planPlanDocuments
   * @param planRsuAwards
   * @param planPsuAwards
   * @param planGrants
   * @param planOptionAwards
   * @param planTradePreClearanceRequests
   * @param planEsppOfferingPeriods
   * @param planPlanApprovals
   * @param planPlanPlanTypeCategories
   * @param planTerminationRuleSetId
   * @param planTerminationRuleSetTenantId
   * @param planTerminationRuleSetExtraProperties
   * @param planTerminationRuleSetConcurrencyStamp
   * @param planIsDeleted
   * @param planDeleterId
   * @param planDeletionTime
   * @param planLastModificationTime
   * @param planLastModifierId
   * @param planCreationTime
   * @param planCreatorId
   * @param planExtraProperties
   * @param planConcurrencyStamp
   * @param planId
   * @param poolId
   * @param poolTenantId
   * @param poolCompanyId
   * @param poolDescription
   * @param poolExternalPoolName
   * @param poolExternalPoolReferenceId
   * @param poolTransactions
   * @param poolRsuAwards
   * @param poolPsuAwards
   * @param poolOptionAwards
   * @param poolGrants
   * @param poolPlans
   * @param poolIsDeleted
   * @param poolDeleterId
   * @param poolDeletionTime
   * @param poolLastModificationTime
   * @param poolLastModifierId
   * @param poolCreationTime
   * @param poolCreatorId
   * @param poolExtraProperties
   * @param poolConcurrencyStamp
   * @param poolId
   * @param remarks
   * @param accepted
   * @param acceptedAt
   * @param awardReleasedDate
   * @param grantReason
   * @param signature
   * @param isRsuAwardEmailNotificationSent
   * @param isRsuAwardReleased
   * @param oldRsuAwardId
   * @param cancelledDate
   * @param fileName
   * @param fairValue
   * @param methodTypeId
   * @param asOfDate
   * @param residualShare
   * @param targetOutStandingShare
   * @param targetCancelledShare
   * @param adjustmentReason
   * @param terminationRuleSetId
   * @param settlementTypeId
   * @param rsuAwardApprovals
   * @param rsuAwardVestingDates
   * @param rsuAwardEmailNotificationLogs
   * @param tradePreClearanceParticipantAwards
   * @param fairValues
   * @param participantAwardTerminations
   * @param rsuAwardSignupTokens
   * @param awardDocuments
   * @param terminationRuleSetId
   * @param terminationRuleSetTenantId
   * @param terminationRuleSetExtraProperties
   * @param terminationRuleSetConcurrencyStamp
   * @param settlementTypeId
   * @param settlementTypeSystemName
   * @param settlementTypeDisplayName
   * @param settlementTypeIsCashSellType
   * @param settlementTypeExtraProperties
   * @param settlementTypeConcurrencyStamp
   * @param isDeleted
   * @param deleterId
   * @param deletionTime
   * @param lastModificationTime
   * @param lastModifierId
   * @param creationTime
   * @param creatorId
   * @param extraProperties
   * @param concurrencyStamp
   * @param vestingTranches
   * @param oldShare
   * @param newShare
   * @returns Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate OK
   * @throws ApiError
   */
  public static getApiAwardApiAppRsuAwardImportVestingTrancheRatioCalculationForCustomVesting(
    companyId: string,
    companyName: string,
    companyIsEnabled: boolean,
    companyCommissionOwningCompanyName: string,
    companyCommissionOwningCompanyIsEnabled: boolean,
    companyCommissionBrokerCompanyName: string,
    companyCommissionBrokerCompanyIsEnabled: boolean,
    participantId: string,
    participantFirstName: string,
    participantLastName: string,
    participantEmployeeId: string,
    participantEmail: string,
    grantId: string,
    grantPlanUniquePlanNo: string,
    grantPlanName: string,
    grantPlanCompanyId: string,
    grantPlanNumberOfSharesAuthorized: number,
    grantPlanNumberOfSharesAvailable: number,
    grantPlanPlanApprovalStatus: number,
    grantPlanIsEnabled: boolean,
    grantPlanPlanEffectiveDate: string,
    grantPlanBoardApprovalDate: string,
    grantPlanShareHolderApprovalDate: string,
    grantPlanPlanTerm: number,
    grantPlanEvergreenPlan: boolean,
    grantPlanDividendEligibility: boolean,
    grantPlanPoolPoolName: string,
    grantPlanPoolNumberOfSharesAuthorised: number,
    grantPlanPoolNumberOfSharesAvailable: number,
    grantPlanPoolNumberOfSharesUnAvailable: number,
    grantPlanPoolHasExternalPoolRefrence: boolean,
    grantPoolPoolName: string,
    grantPoolNumberOfSharesAuthorised: number,
    grantPoolNumberOfSharesAvailable: number,
    grantPoolNumberOfSharesUnAvailable: number,
    grantPoolHasExternalPoolRefrence: boolean,
    grantPlanTypeName: string,
    grantPlanTypeIsEnabled: boolean,
    grantPlanTypePlanTypeCategoryName: string,
    grantPlanTypePlanTypeCategoryIsEnabled: boolean,
    grantCompanyName: string,
    grantCompanyIsEnabled: boolean,
    grantCompanyCommissionOwningCompanyName: string,
    grantCompanyCommissionOwningCompanyIsEnabled: boolean,
    grantCompanyCommissionBrokerCompanyName: string,
    grantCompanyCommissionBrokerCompanyIsEnabled: boolean,
    grantVestingTemplateCompanyName: string,
    grantVestingTemplateCompanyIsEnabled: boolean,
    grantVestingTemplateCompanyCommissionOwningCompanyName: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIsEnabled: boolean,
    grantVestingTemplateCompanyCommissionBrokerCompanyName: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsEnabled: boolean,
    grantPerformanceRuleCompanyId: string,
    grantGrantAgreementDocumentGrantDocumentName: string,
    grantGrantNoticeDocumentGrantDocumentName: string,
    grantTermsAndConditionDocumentGrantDocumentName: string,
    grantTermsAndConditionTextGrantDocumentName: string,
    vestingStartDate: string,
    grantIssueDate: string,
    vestingTemplateId: string,
    vestingTemplateCompanyName: string,
    vestingTemplateCompanyIsEnabled: boolean,
    vestingTemplateCompanyCommissionOwningCompanyName: string,
    vestingTemplateCompanyCommissionOwningCompanyIsEnabled: boolean,
    vestingTemplateCompanyCommissionBrokerCompanyName: string,
    vestingTemplateCompanyCommissionBrokerCompanyIsEnabled: boolean,
    planId: string,
    planUniquePlanNo: string,
    planName: string,
    planCompanyId: string,
    planNumberOfSharesAuthorized: number,
    planNumberOfSharesAvailable: number,
    planPlanApprovalStatus: number,
    planIsEnabled: boolean,
    planPlanEffectiveDate: string,
    planBoardApprovalDate: string,
    planShareHolderApprovalDate: string,
    planPlanTerm: number,
    planEvergreenPlan: boolean,
    planDividendEligibility: boolean,
    planPoolPoolName: string,
    planPoolNumberOfSharesAuthorised: number,
    planPoolNumberOfSharesAvailable: number,
    planPoolNumberOfSharesUnAvailable: number,
    planPoolHasExternalPoolRefrence: boolean,
    poolPoolName: string,
    poolNumberOfSharesAuthorised: number,
    poolNumberOfSharesAvailable: number,
    poolNumberOfSharesUnAvailable: number,
    poolHasExternalPoolRefrence: boolean,
    grantQuantity: number,
    grantNumber: string,
    grantPrice: number,
    marketValueAtGrant: number,
    approvalStatus: number,
    isEnabled: boolean,
    id?: string,
    tenantId?: string,
    companyTenantId?: string,
    companyCreatorId?: string,
    companyCreationTime?: string,
    companyLastModifierId?: string,
    companyLastModificationTime?: string,
    companyIsDeleted?: boolean,
    companyDeleterId?: string,
    companyDeletionTime?: string,
    companyTicker?: string,
    companyIsoCalculationSortingTypeId?: number,
    companyIsoCalculationSortingTypeSystemName?: string,
    companyIsoCalculationSortingTypeDisplayName?: string,
    companyIsoCalculationSortingTypeExtraProperties?: Record<string, any>,
    companyIsoCalculationSortingTypeConcurrencyStamp?: string,
    companyIsEmailEnableToParticipant?: boolean,
    companyDtcParticipantId?: string,
    companyIntendedShareRegistrationTypeId?: number,
    companyIntendedShareRegistrationTypeSystemName?: string,
    companyIntendedShareRegistrationTypeDisplayName?: string,
    companyIntendedShareRegistrationTypeLastModificationTime?: string,
    companyIntendedShareRegistrationTypeLastModifierId?: string,
    companyIntendedShareRegistrationTypeCreationTime?: string,
    companyIntendedShareRegistrationTypeCreatorId?: string,
    companyIntendedShareRegistrationTypeExtraProperties?: Record<string, any>,
    companyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    companyTransactionAcquisitionTypeId?: number,
    companyTransactionAcquisitionTypeSystemName?: string,
    companyTransactionAcquisitionTypeDisplayName?: string,
    companyTransactionAcquisitionTypeLastModificationTime?: string,
    companyTransactionAcquisitionTypeLastModifierId?: string,
    companyTransactionAcquisitionTypeCreationTime?: string,
    companyTransactionAcquisitionTypeCreatorId?: string,
    companyTransactionAcquisitionTypeExtraProperties?: Record<string, any>,
    companyTransactionAcquisitionTypeConcurrencyStamp?: string,
    companyPriceThreshold?: number,
    companyIsPartBRequired?: boolean,
    companyIsPartCRequired?: boolean,
    companyCommissionOwningCompanyId?: string,
    companyCommissionOwningCompanyTenantId?: string,
    companyCommissionOwningCompanyCreatorId?: string,
    companyCommissionOwningCompanyCreationTime?: string,
    companyCommissionOwningCompanyLastModifierId?: string,
    companyCommissionOwningCompanyLastModificationTime?: string,
    companyCommissionOwningCompanyIsDeleted?: boolean,
    companyCommissionOwningCompanyDeleterId?: string,
    companyCommissionOwningCompanyDeletionTime?: string,
    companyCommissionOwningCompanyTicker?: string,
    companyCommissionOwningCompanyIsoCalculationSortingTypeId?: number,
    companyCommissionOwningCompanyIsoCalculationSortingTypeSystemName?: string,
    companyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName?: string,
    companyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties?: Record<string, any>,
    companyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    companyCommissionOwningCompanyIsEmailEnableToParticipant?: boolean,
    companyCommissionOwningCompanyCommissionId?: string,
    companyCommissionOwningCompanyDtcParticipantId?: string,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeId?: number,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName?: string,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName?: string,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime?: string,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId?: string,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties?: Record<
      string,
      any
    >,
    companyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    companyCommissionOwningCompanyTransactionAcquisitionTypeId?: number,
    companyCommissionOwningCompanyTransactionAcquisitionTypeSystemName?: string,
    companyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName?: string,
    companyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    companyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId?: string,
    companyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime?: string,
    companyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId?: string,
    companyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties?: Record<string, any>,
    companyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    companyCommissionOwningCompanyPriceThreshold?: number,
    companyCommissionOwningCompanyIsPartBRequired?: boolean,
    companyCommissionOwningCompanyIsPartCRequired?: boolean,
    companyCommissionOwningCompanyCommission?: Wealthlane_AwardService_Commission_Commission,
    companyCommissionOwningCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    companyCommissionOwningCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    companyCommissionOwningCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    companyCommissionOwningCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    companyCommissionOwningCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    companyCommissionOwningCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    companyCommissionOwningCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    companyCommissionOwningCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    companyCommissionOwningCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    companyCommissionOwningCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    companyCommissionOwningCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    companyCommissionOwningCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    companyCommissionOwningCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    companyCommissionOwningCompanyExtraProperties?: Record<string, any>,
    companyCommissionOwningCompanyConcurrencyStamp?: string,
    companyCommissionBrokerCompanyId?: string,
    companyCommissionBrokerCompanyTenantId?: string,
    companyCommissionBrokerCompanyCreatorId?: string,
    companyCommissionBrokerCompanyCreationTime?: string,
    companyCommissionBrokerCompanyLastModifierId?: string,
    companyCommissionBrokerCompanyLastModificationTime?: string,
    companyCommissionBrokerCompanyIsDeleted?: boolean,
    companyCommissionBrokerCompanyDeleterId?: string,
    companyCommissionBrokerCompanyDeletionTime?: string,
    companyCommissionBrokerCompanyTicker?: string,
    companyCommissionBrokerCompanyIsoCalculationSortingTypeId?: number,
    companyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName?: string,
    companyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName?: string,
    companyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties?: Record<string, any>,
    companyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    companyCommissionBrokerCompanyIsEmailEnableToParticipant?: boolean,
    companyCommissionBrokerCompanyCommissionId?: string,
    companyCommissionBrokerCompanyDtcParticipantId?: string,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeId?: number,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName?: string,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName?: string,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime?: string,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId?: string,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties?: Record<
      string,
      any
    >,
    companyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeId?: number,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName?: string,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName?: string,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId?: string,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime?: string,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId?: string,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties?: Record<string, any>,
    companyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    companyCommissionBrokerCompanyPriceThreshold?: number,
    companyCommissionBrokerCompanyIsPartBRequired?: boolean,
    companyCommissionBrokerCompanyIsPartCRequired?: boolean,
    companyCommissionBrokerCompanyCommission?: Wealthlane_AwardService_Commission_Commission,
    companyCommissionBrokerCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    companyCommissionBrokerCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    companyCommissionBrokerCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    companyCommissionBrokerCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    companyCommissionBrokerCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    companyCommissionBrokerCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    companyCommissionBrokerCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    companyCommissionBrokerCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    companyCommissionBrokerCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    companyCommissionBrokerCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    companyCommissionBrokerCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    companyCommissionBrokerCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    companyCommissionBrokerCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    companyCommissionBrokerCompanyExtraProperties?: Record<string, any>,
    companyCommissionBrokerCompanyConcurrencyStamp?: string,
    companyCommissionName?: string,
    companyCommissionDescription?: string,
    companyCommissionBaseRate?: number,
    companyCommissionMaxAmount?: number,
    companyCommissionCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    companyCommissionCompany?: Array<Wealthlane_AwardService_Company_Company>,
    companyCommissionIsDeleted?: boolean,
    companyCommissionDeleterId?: string,
    companyCommissionDeletionTime?: string,
    companyCommissionLastModificationTime?: string,
    companyCommissionLastModifierId?: string,
    companyCommissionCreationTime?: string,
    companyCommissionCreatorId?: string,
    companyCommissionId?: string,
    companyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    companyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    companyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    companyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    companyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    companyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    companyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    companyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    companyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    companyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    companyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    companyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    companyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    companyExtraProperties?: Record<string, any>,
    companyConcurrencyStamp?: string,
    participantTenantId?: string,
    participantCompanyId?: string,
    participantPayrollId?: string,
    participantMiddleName?: string,
    participantDateOfBirth?: string,
    participantGender?: string,
    participantMaritalStatus?: string,
    participantCountryOfLegalResidency?: string,
    participantAddressLine1?: string,
    participantParticipantApprovalStatus?: number,
    participantStatusName?: string,
    participantCreatorId?: string,
    participantCreationDateTime?: string,
    participantHireDate?: string,
    participantAbpUserId?: string,
    participantIsOnBoarded?: boolean,
    participantJobTitle?: string,
    participantDepartment?: string,
    participantEmployeeStatus?: string,
    participantIsTaxCertificationVerified?: boolean,
    participantEmployeeType?: string,
    participantCostCentre?: string,
    participantIsTradePreClearanced?: boolean,
    participantIsBlackout?: boolean,
    participantHomeStateAbbreviation?: string,
    participantWorkStateAbbreviation?: string,
    participantAccountId?: string,
    participantIsEmailSend?: boolean,
    participantIsSection16?: boolean,
    participantIsRule144?: boolean,
    participantFullName?: string,
    participantRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    participantOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    participantPsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    participantTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    participantOptionExercises?: Array<Wealthlane_AwardService_OptionExercise_OptionExercise>,
    participantPspParticipantId?: string,
    participantEsppPurchaseItems?: Array<Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchaseItem>,
    participantParticipantTerminations?: Array<Wealthlane_AwardService_ParticipantTermination_ParticipantTermination>,
    participantTaxInputs?: Array<Wealthlane_AwardService_TaxInput_TaxInput>,
    participantEsppParticipants?: Array<Wealthlane_AwardService_EsppAwards_EsppParticipant>,
    participantTransactions?: Array<Wealthlane_AwardService_Transaction_Transaction>,
    participantTadrsInstructions?: Array<Wealthlane_AwardService_TADRSInstruction_TADRSInstruction>,
    participantTerminationRuleSetId?: string,
    participantTerminationRuleSetTenantId?: string,
    participantTerminationRuleSetExtraProperties?: Record<string, any>,
    participantTerminationRuleSetConcurrencyStamp?: string,
    participantSettlementTypeId?: string,
    participantSettlementTypeSystemName?: string,
    participantSettlementTypeDisplayName?: string,
    participantSettlementTypeIsCashSellType?: boolean,
    participantSettlementTypeExtraProperties?: Record<string, any>,
    participantSettlementTypeConcurrencyStamp?: string,
    participantExtraProperties?: Record<string, any>,
    participantConcurrencyStamp?: string,
    grantTenantId?: string,
    grantCompanyId?: string,
    grantUniqueGrantNo?: string,
    grantPlanId?: string,
    grantPoolId?: string,
    grantPlanTypeId?: string,
    grantName?: string,
    grantIsEnabled?: boolean,
    grantApprovedDate?: string,
    grantVestingTemplateId?: string,
    grantPerformanceRuleId?: string,
    grantApprovalRequired?: boolean,
    grantGrantAgreementDocumentId?: string,
    grantGrantNoticeDocumentId?: string,
    grantAgreementStatement?: string,
    grantAgreementStatementStatus?: boolean,
    grantTermsAndConditionDocumentId?: string,
    grantTermsAndConditionTextId?: string,
    grantTerminationRuleSetId?: string,
    grantSettlementTypeId?: string,
    grantPlanTenantId?: string,
    grantPlanEligibleShareClass?: string,
    grantPlanDescription?: string,
    grantPlanEvergreenCriteria?: string,
    grantPlanDeathExpirationOption?: number,
    grantPlanDisablityExpirationOption?: number,
    grantPlanRetirementExpirationOption?: number,
    grantPlanVolutaryTerminationOption?: number,
    grantPlanInvolutaryTerminationOption?: number,
    grantPlanOptionExpirationDate?: number,
    grantPlanNumberOfSharesUnAvailable?: number,
    grantPlanPlanExpiryDate?: string,
    grantPlanWithACause?: number,
    grantPlanTerminationRuleSetId?: string,
    grantPlanPoolId?: string,
    grantPlanPoolTenantId?: string,
    grantPlanPoolCompanyId?: string,
    grantPlanPoolDescription?: string,
    grantPlanPoolExternalPoolName?: string,
    grantPlanPoolExternalPoolReferenceId?: string,
    grantPlanPoolTransactions?: Array<Wealthlane_AwardService_Transaction_Transaction>,
    grantPlanPoolRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantPlanPoolPsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantPlanPoolOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantPlanPoolGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantPlanPoolPlans?: Array<Wealthlane_AwardService_Plan_Plan>,
    grantPlanPoolIsDeleted?: boolean,
    grantPlanPoolDeleterId?: string,
    grantPlanPoolDeletionTime?: string,
    grantPlanPoolLastModificationTime?: string,
    grantPlanPoolLastModifierId?: string,
    grantPlanPoolCreationTime?: string,
    grantPlanPoolCreatorId?: string,
    grantPlanPoolExtraProperties?: Record<string, any>,
    grantPlanPoolConcurrencyStamp?: string,
    grantPlanAllowEditPlanRelatedDocuments?: boolean,
    grantPlanPlanDocuments?: Array<Wealthlane_AwardService_PlanDocument_PlanDocument>,
    grantPlanRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantPlanPsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantPlanGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantPlanOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantPlanTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    grantPlanEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantPlanPlanApprovals?: Array<Wealthlane_AwardService_PlanApproval_PlanApproval>,
    grantPlanPlanPlanTypeCategories?: Array<Wealthlane_AwardService_PlanPlanTypeCategory_PlanPlanTypeCategory>,
    grantPlanTerminationRuleSetTenantId?: string,
    grantPlanTerminationRuleSetExtraProperties?: Record<string, any>,
    grantPlanTerminationRuleSetConcurrencyStamp?: string,
    grantPlanIsDeleted?: boolean,
    grantPlanDeleterId?: string,
    grantPlanDeletionTime?: string,
    grantPlanLastModificationTime?: string,
    grantPlanLastModifierId?: string,
    grantPlanCreationTime?: string,
    grantPlanCreatorId?: string,
    grantPlanExtraProperties?: Record<string, any>,
    grantPlanConcurrencyStamp?: string,
    grantPoolTenantId?: string,
    grantPoolCompanyId?: string,
    grantPoolDescription?: string,
    grantPoolExternalPoolName?: string,
    grantPoolExternalPoolReferenceId?: string,
    grantPoolTransactions?: Array<Wealthlane_AwardService_Transaction_Transaction>,
    grantPoolRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantPoolPsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantPoolOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantPoolGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantPoolPlans?: Array<Wealthlane_AwardService_Plan_Plan>,
    grantPoolIsDeleted?: boolean,
    grantPoolDeleterId?: string,
    grantPoolDeletionTime?: string,
    grantPoolLastModificationTime?: string,
    grantPoolLastModifierId?: string,
    grantPoolCreationTime?: string,
    grantPoolCreatorId?: string,
    grantPoolExtraProperties?: Record<string, any>,
    grantPoolConcurrencyStamp?: string,
    grantPlanTypePlanTypeCategoryId?: string,
    grantPlanTypePlanTypeCategoryElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    grantPlanTypePlanTypeCategoryDefaultSettlementConfigurations?: Array<Wealthlane_AwardService_DefaultSettlementConfiguration_DefaultSettlementConfiguration>,
    grantPlanTypePlanTypeCategoryPlanPlanTypeCategories?: Array<Wealthlane_AwardService_PlanPlanTypeCategory_PlanPlanTypeCategory>,
    grantPlanTypePlanTypeCategoryExtraProperties?: Record<string, any>,
    grantPlanTypePlanTypeCategoryConcurrencyStamp?: string,
    grantPlanTypeOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantPlanTypeExtraProperties?: Record<string, any>,
    grantPlanTypeConcurrencyStamp?: string,
    grantCompanyTenantId?: string,
    grantCompanyCreatorId?: string,
    grantCompanyCreationTime?: string,
    grantCompanyLastModifierId?: string,
    grantCompanyLastModificationTime?: string,
    grantCompanyIsDeleted?: boolean,
    grantCompanyDeleterId?: string,
    grantCompanyDeletionTime?: string,
    grantCompanyTicker?: string,
    grantCompanyIsoCalculationSortingTypeId?: number,
    grantCompanyIsoCalculationSortingTypeSystemName?: string,
    grantCompanyIsoCalculationSortingTypeDisplayName?: string,
    grantCompanyIsoCalculationSortingTypeExtraProperties?: Record<string, any>,
    grantCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    grantCompanyIsEmailEnableToParticipant?: boolean,
    grantCompanyCommissionId?: string,
    grantCompanyDtcParticipantId?: string,
    grantCompanyIntendedShareRegistrationTypeId?: number,
    grantCompanyIntendedShareRegistrationTypeSystemName?: string,
    grantCompanyIntendedShareRegistrationTypeDisplayName?: string,
    grantCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    grantCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    grantCompanyIntendedShareRegistrationTypeCreationTime?: string,
    grantCompanyIntendedShareRegistrationTypeCreatorId?: string,
    grantCompanyIntendedShareRegistrationTypeExtraProperties?: Record<string, any>,
    grantCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    grantCompanyTransactionAcquisitionTypeId?: number,
    grantCompanyTransactionAcquisitionTypeSystemName?: string,
    grantCompanyTransactionAcquisitionTypeDisplayName?: string,
    grantCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    grantCompanyTransactionAcquisitionTypeLastModifierId?: string,
    grantCompanyTransactionAcquisitionTypeCreationTime?: string,
    grantCompanyTransactionAcquisitionTypeCreatorId?: string,
    grantCompanyTransactionAcquisitionTypeExtraProperties?: Record<string, any>,
    grantCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    grantCompanyPriceThreshold?: number,
    grantCompanyIsPartBRequired?: boolean,
    grantCompanyIsPartCRequired?: boolean,
    grantCompanyCommissionOwningCompanyId?: string,
    grantCompanyCommissionOwningCompanyTenantId?: string,
    grantCompanyCommissionOwningCompanyCreatorId?: string,
    grantCompanyCommissionOwningCompanyCreationTime?: string,
    grantCompanyCommissionOwningCompanyLastModifierId?: string,
    grantCompanyCommissionOwningCompanyLastModificationTime?: string,
    grantCompanyCommissionOwningCompanyIsDeleted?: boolean,
    grantCompanyCommissionOwningCompanyDeleterId?: string,
    grantCompanyCommissionOwningCompanyDeletionTime?: string,
    grantCompanyCommissionOwningCompanyTicker?: string,
    grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeId?: number,
    grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName?: string,
    grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName?: string,
    grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties?: Record<
      string,
      any
    >,
    grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    grantCompanyCommissionOwningCompanyIsEmailEnableToParticipant?: boolean,
    grantCompanyCommissionOwningCompanyCommissionId?: string,
    grantCompanyCommissionOwningCompanyDtcParticipantId?: string,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId?: number,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName?: string,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName?: string,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime?: string,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId?: string,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties?: Record<
      string,
      any
    >,
    grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeId?: number,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName?: string,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName?: string,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId?: string,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime?: string,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId?: string,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties?: Record<
      string,
      any
    >,
    grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    grantCompanyCommissionOwningCompanyPriceThreshold?: number,
    grantCompanyCommissionOwningCompanyIsPartBRequired?: boolean,
    grantCompanyCommissionOwningCompanyIsPartCRequired?: boolean,
    grantCompanyCommissionOwningCompanyCommission?: Wealthlane_AwardService_Commission_Commission,
    grantCompanyCommissionOwningCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    grantCompanyCommissionOwningCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    grantCompanyCommissionOwningCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantCompanyCommissionOwningCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantCompanyCommissionOwningCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantCompanyCommissionOwningCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    grantCompanyCommissionOwningCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    grantCompanyCommissionOwningCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    grantCompanyCommissionOwningCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantCompanyCommissionOwningCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    grantCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    grantCompanyCommissionOwningCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantCompanyCommissionOwningCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    grantCompanyCommissionOwningCompanyExtraProperties?: Record<string, any>,
    grantCompanyCommissionOwningCompanyConcurrencyStamp?: string,
    grantCompanyCommissionBrokerCompanyId?: string,
    grantCompanyCommissionBrokerCompanyTenantId?: string,
    grantCompanyCommissionBrokerCompanyCreatorId?: string,
    grantCompanyCommissionBrokerCompanyCreationTime?: string,
    grantCompanyCommissionBrokerCompanyLastModifierId?: string,
    grantCompanyCommissionBrokerCompanyLastModificationTime?: string,
    grantCompanyCommissionBrokerCompanyIsDeleted?: boolean,
    grantCompanyCommissionBrokerCompanyDeleterId?: string,
    grantCompanyCommissionBrokerCompanyDeletionTime?: string,
    grantCompanyCommissionBrokerCompanyTicker?: string,
    grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId?: number,
    grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName?: string,
    grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName?: string,
    grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties?: Record<
      string,
      any
    >,
    grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    grantCompanyCommissionBrokerCompanyIsEmailEnableToParticipant?: boolean,
    grantCompanyCommissionBrokerCompanyCommissionId?: string,
    grantCompanyCommissionBrokerCompanyDtcParticipantId?: string,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId?: number,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName?: string,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName?: string,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime?: string,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId?: string,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties?: Record<
      string,
      any
    >,
    grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId?: number,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName?: string,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName?: string,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId?: string,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime?: string,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId?: string,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties?: Record<
      string,
      any
    >,
    grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    grantCompanyCommissionBrokerCompanyPriceThreshold?: number,
    grantCompanyCommissionBrokerCompanyIsPartBRequired?: boolean,
    grantCompanyCommissionBrokerCompanyIsPartCRequired?: boolean,
    grantCompanyCommissionBrokerCompanyCommission?: Wealthlane_AwardService_Commission_Commission,
    grantCompanyCommissionBrokerCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    grantCompanyCommissionBrokerCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    grantCompanyCommissionBrokerCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantCompanyCommissionBrokerCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantCompanyCommissionBrokerCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantCompanyCommissionBrokerCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    grantCompanyCommissionBrokerCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    grantCompanyCommissionBrokerCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    grantCompanyCommissionBrokerCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantCompanyCommissionBrokerCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    grantCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    grantCompanyCommissionBrokerCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantCompanyCommissionBrokerCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    grantCompanyCommissionBrokerCompanyExtraProperties?: Record<string, any>,
    grantCompanyCommissionBrokerCompanyConcurrencyStamp?: string,
    grantCompanyCommissionName?: string,
    grantCompanyCommissionDescription?: string,
    grantCompanyCommissionBaseRate?: number,
    grantCompanyCommissionMaxAmount?: number,
    grantCompanyCommissionCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    grantCompanyCommissionCompany?: Array<Wealthlane_AwardService_Company_Company>,
    grantCompanyCommissionIsDeleted?: boolean,
    grantCompanyCommissionDeleterId?: string,
    grantCompanyCommissionDeletionTime?: string,
    grantCompanyCommissionLastModificationTime?: string,
    grantCompanyCommissionLastModifierId?: string,
    grantCompanyCommissionCreationTime?: string,
    grantCompanyCommissionCreatorId?: string,
    grantCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    grantCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    grantCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    grantCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    grantCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    grantCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    grantCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    grantCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    grantCompanyExtraProperties?: Record<string, any>,
    grantCompanyConcurrencyStamp?: string,
    grantVestingTemplateTenantId?: string,
    grantVestingTemplateCompanyId?: string,
    grantVestingTemplateName?: string,
    grantVestingTemplateSummary?: string,
    grantVestingTemplateVestingTypeId?: string,
    grantVestingTemplateLengthInMonths?: number,
    grantVestingTemplateAmountOneInPercentage?: number,
    grantVestingTemplateVestsAfterInMonths?: number,
    grantVestingTemplateAmountTwoInPercentage?: number,
    grantVestingTemplateVestsInMonths?: number,
    grantVestingTemplateIntervalInMonths?: number,
    grantVestingTemplateIsEnabled?: boolean,
    grantVestingTemplateIsDefaultVestingTemplate?: boolean,
    grantVestingTemplatePeriodStartDate?: string,
    grantVestingTemplateRoundingTypeId?: number,
    grantVestingTemplateFractionalDecimalDigit?: number,
    grantVestingTemplateVestAtEndOfMonth?: boolean,
    grantVestingTemplateSpecificVestingInstruction?: string,
    grantVestingTemplateLoadingTypeId?: number,
    grantVestingTemplateEndOfTheMonthTypeId?: number,
    grantVestingTemplateCompanyTenantId?: string,
    grantVestingTemplateCompanyCreatorId?: string,
    grantVestingTemplateCompanyCreationTime?: string,
    grantVestingTemplateCompanyLastModifierId?: string,
    grantVestingTemplateCompanyLastModificationTime?: string,
    grantVestingTemplateCompanyIsDeleted?: boolean,
    grantVestingTemplateCompanyDeleterId?: string,
    grantVestingTemplateCompanyDeletionTime?: string,
    grantVestingTemplateCompanyTicker?: string,
    grantVestingTemplateCompanyIsoCalculationSortingTypeId?: number,
    grantVestingTemplateCompanyIsoCalculationSortingTypeSystemName?: string,
    grantVestingTemplateCompanyIsoCalculationSortingTypeDisplayName?: string,
    grantVestingTemplateCompanyIsoCalculationSortingTypeExtraProperties?: Record<string, any>,
    grantVestingTemplateCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyIsEmailEnableToParticipant?: boolean,
    grantVestingTemplateCompanyCommissionId?: string,
    grantVestingTemplateCompanyDtcParticipantId?: string,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeId?: number,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeSystemName?: string,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeDisplayName?: string,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeCreationTime?: string,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeCreatorId?: string,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeExtraProperties?: Record<string, any>,
    grantVestingTemplateCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyTransactionAcquisitionTypeId?: number,
    grantVestingTemplateCompanyTransactionAcquisitionTypeSystemName?: string,
    grantVestingTemplateCompanyTransactionAcquisitionTypeDisplayName?: string,
    grantVestingTemplateCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    grantVestingTemplateCompanyTransactionAcquisitionTypeLastModifierId?: string,
    grantVestingTemplateCompanyTransactionAcquisitionTypeCreationTime?: string,
    grantVestingTemplateCompanyTransactionAcquisitionTypeCreatorId?: string,
    grantVestingTemplateCompanyTransactionAcquisitionTypeExtraProperties?: Record<string, any>,
    grantVestingTemplateCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyPriceThreshold?: number,
    grantVestingTemplateCompanyIsPartBRequired?: boolean,
    grantVestingTemplateCompanyIsPartCRequired?: boolean,
    grantVestingTemplateCompanyCommissionOwningCompanyId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTenantId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyCreatorId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyCreationTime?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyLastModifierId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyLastModificationTime?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIsDeleted?: boolean,
    grantVestingTemplateCompanyCommissionOwningCompanyDeleterId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyDeletionTime?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTicker?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId?: number,
    grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties?: Record<
      string,
      any
    >,
    grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIsEmailEnableToParticipant?: boolean,
    grantVestingTemplateCompanyCommissionOwningCompanyCommissionId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyDtcParticipantId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId?: number,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties?: Record<
      string,
      any
    >,
    grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties?: Record<
      string,
      any
    >,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId?: number,
    grantVestingTemplateCompanyCommissionOwningCompanyPriceThreshold?: number,
    grantVestingTemplateCompanyCommissionOwningCompanyIsPartBRequired?: boolean,
    grantVestingTemplateCompanyCommissionOwningCompanyIsPartCRequired?: boolean,
    grantVestingTemplateCompanyCommissionOwningCompanyCommission?: Wealthlane_AwardService_Commission_Commission,
    grantVestingTemplateCompanyCommissionOwningCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    grantVestingTemplateCompanyCommissionOwningCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    grantVestingTemplateCompanyCommissionOwningCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantVestingTemplateCompanyCommissionOwningCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantVestingTemplateCompanyCommissionOwningCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantVestingTemplateCompanyCommissionOwningCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    grantVestingTemplateCompanyCommissionOwningCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    grantVestingTemplateCompanyCommissionOwningCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    grantVestingTemplateCompanyCommissionOwningCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantVestingTemplateCompanyCommissionOwningCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    grantVestingTemplateCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    grantVestingTemplateCompanyCommissionOwningCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantVestingTemplateCompanyCommissionOwningCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    grantVestingTemplateCompanyCommissionOwningCompanyExtraProperties?: Record<string, any>,
    grantVestingTemplateCompanyCommissionOwningCompanyConcurrencyStamp?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyTenantId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyCreatorId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyCreationTime?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyLastModifierId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyLastModificationTime?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsDeleted?: boolean,
    grantVestingTemplateCompanyCommissionBrokerCompanyDeleterId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyDeletionTime?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyTicker?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId?: number,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties?: Record<
      string,
      any
    >,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsEmailEnableToParticipant?: boolean,
    grantVestingTemplateCompanyCommissionBrokerCompanyCommissionId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyDtcParticipantId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties?: Record<
      string,
      any
    >,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId?: number,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId?: number,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties?: Record<
      string,
      any
    >,
    grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    grantVestingTemplateCompanyCommissionBrokerCompanyPriceThreshold?: number,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsPartBRequired?: boolean,
    grantVestingTemplateCompanyCommissionBrokerCompanyIsPartCRequired?: boolean,
    grantVestingTemplateCompanyCommissionBrokerCompanyCommission?: Wealthlane_AwardService_Commission_Commission,
    grantVestingTemplateCompanyCommissionBrokerCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    grantVestingTemplateCompanyCommissionBrokerCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    grantVestingTemplateCompanyCommissionBrokerCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantVestingTemplateCompanyCommissionBrokerCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantVestingTemplateCompanyCommissionBrokerCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantVestingTemplateCompanyCommissionBrokerCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    grantVestingTemplateCompanyCommissionBrokerCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    grantVestingTemplateCompanyCommissionBrokerCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    grantVestingTemplateCompanyCommissionBrokerCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantVestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    grantVestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    grantVestingTemplateCompanyCommissionBrokerCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantVestingTemplateCompanyCommissionBrokerCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    grantVestingTemplateCompanyCommissionBrokerCompanyExtraProperties?: Record<string, any>,
    grantVestingTemplateCompanyCommissionBrokerCompanyConcurrencyStamp?: string,
    grantVestingTemplateCompanyCommissionName?: string,
    grantVestingTemplateCompanyCommissionDescription?: string,
    grantVestingTemplateCompanyCommissionBaseRate?: number,
    grantVestingTemplateCompanyCommissionMaxAmount?: number,
    grantVestingTemplateCompanyCommissionCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    grantVestingTemplateCompanyCommissionCompany?: Array<Wealthlane_AwardService_Company_Company>,
    grantVestingTemplateCompanyCommissionIsDeleted?: boolean,
    grantVestingTemplateCompanyCommissionDeleterId?: string,
    grantVestingTemplateCompanyCommissionDeletionTime?: string,
    grantVestingTemplateCompanyCommissionLastModificationTime?: string,
    grantVestingTemplateCompanyCommissionLastModifierId?: string,
    grantVestingTemplateCompanyCommissionCreationTime?: string,
    grantVestingTemplateCompanyCommissionCreatorId?: string,
    grantVestingTemplateCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    grantVestingTemplateCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    grantVestingTemplateCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantVestingTemplateCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantVestingTemplateCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    grantVestingTemplateCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    grantVestingTemplateCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    grantVestingTemplateCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    grantVestingTemplateCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantVestingTemplateCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    grantVestingTemplateCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    grantVestingTemplateCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantVestingTemplateCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    grantVestingTemplateCompanyExtraProperties?: Record<string, any>,
    grantVestingTemplateCompanyConcurrencyStamp?: string,
    grantVestingTemplateVestingTypeName?: string,
    grantVestingTemplateVestingTypeIsCliffVesting?: boolean,
    grantVestingTemplateVestingTypeIsStepVesting?: boolean,
    grantVestingTemplateVestingTypeIsHybridVesting?: boolean,
    grantVestingTemplateVestingTypeIsCustomVesting?: boolean,
    grantVestingTemplateVestingTypeIsSpecificVesting?: boolean,
    grantVestingTemplateVestingTypeIsCustomVestingTranche?: boolean,
    grantVestingTemplateVestingTypeIsEnabled?: boolean,
    grantVestingTemplateVestingTypeVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    grantVestingTemplateVestingTypeDefaultVestingTemplates?: Array<Wealthlane_AwardService_DefaultVestingTemplate_DefaultVestingTemplate>,
    grantVestingTemplateVestingTypeIsDeleted?: boolean,
    grantVestingTemplateVestingTypeDeleterId?: string,
    grantVestingTemplateVestingTypeDeletionTime?: string,
    grantVestingTemplateVestingTypeLastModificationTime?: string,
    grantVestingTemplateVestingTypeLastModifierId?: string,
    grantVestingTemplateVestingTypeCreationTime?: string,
    grantVestingTemplateVestingTypeCreatorId?: string,
    grantVestingTemplateVestingTypeExtraProperties?: Record<string, any>,
    grantVestingTemplateVestingTypeConcurrencyStamp?: string,
    grantVestingTemplateRoundingTypeDisplayName?: string,
    grantVestingTemplateRoundingTypeSystemName?: string,
    grantVestingTemplateRoundingTypeVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    grantVestingTemplateRoundingTypeDefaultVestingTemplates?: Array<Wealthlane_AwardService_DefaultVestingTemplate_DefaultVestingTemplate>,
    grantVestingTemplateRoundingTypeExtraProperties?: Record<string, any>,
    grantVestingTemplateRoundingTypeConcurrencyStamp?: string,
    grantVestingTemplateRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantVestingTemplateGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantVestingTemplateOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantVestingTemplatePsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantVestingTemplateLoadingTypeSystemName?: string,
    grantVestingTemplateLoadingTypeDisplayName?: string,
    grantVestingTemplateLoadingTypeLastModificationTime?: string,
    grantVestingTemplateLoadingTypeLastModifierId?: string,
    grantVestingTemplateLoadingTypeCreationTime?: string,
    grantVestingTemplateLoadingTypeCreatorId?: string,
    grantVestingTemplateLoadingTypeExtraProperties?: Record<string, any>,
    grantVestingTemplateLoadingTypeConcurrencyStamp?: string,
    grantVestingTemplateEndOfTheMonthTypeSystemName?: string,
    grantVestingTemplateEndOfTheMonthTypeDisplayName?: string,
    grantVestingTemplateEndOfTheMonthTypeLastModificationTime?: string,
    grantVestingTemplateEndOfTheMonthTypeLastModifierId?: string,
    grantVestingTemplateEndOfTheMonthTypeCreationTime?: string,
    grantVestingTemplateEndOfTheMonthTypeCreatorId?: string,
    grantVestingTemplateEndOfTheMonthTypeExtraProperties?: Record<string, any>,
    grantVestingTemplateEndOfTheMonthTypeConcurrencyStamp?: string,
    grantVestingTemplateIsDeleted?: boolean,
    grantVestingTemplateDeleterId?: string,
    grantVestingTemplateDeletionTime?: string,
    grantVestingTemplateLastModificationTime?: string,
    grantVestingTemplateLastModifierId?: string,
    grantVestingTemplateCreationTime?: string,
    grantVestingTemplateCreatorId?: string,
    grantVestingTemplateExtraProperties?: Record<string, any>,
    grantVestingTemplateConcurrencyStamp?: string,
    grantPerformanceRuleTenantId?: string,
    grantPerformanceRuleRuleName?: string,
    grantPerformanceRuleMinimumPercentage?: number,
    grantPerformanceRuleMaximumPercentage?: number,
    grantPerformanceRuleRuleDescription?: string,
    grantPerformanceRuleRuleSummary?: string,
    grantPerformanceRuleIsAvailable?: boolean,
    grantPerformanceRuleShowRuleDisplayToParticipant?: boolean,
    grantPerformanceRuleShowPerformanceTrackingToParticipant?: boolean,
    grantPerformanceRuleEvaluationPeriodStartDate?: string,
    grantPerformanceRuleEvaluationPeriodEndDate?: string,
    grantPerformanceRuleRuleTypeId?: string,
    grantPerformanceRuleRuleTypeSystemName?: string,
    grantPerformanceRuleRuleTypeDisplayName?: string,
    grantPerformanceRuleRuleTypePerformanceRules?: Array<Wealthlane_AwardService_PerformanceRule_PerformanceRule>,
    grantPerformanceRuleRuleTypeExtraProperties?: Record<string, any>,
    grantPerformanceRuleRuleTypeConcurrencyStamp?: string,
    grantPerformanceRuleApprovalStatusId?: number,
    grantPerformanceRuleApprovalStatusSystemName?: string,
    grantPerformanceRuleApprovalStatusDisplayName?: string,
    grantPerformanceRuleApprovalStatusPerformanceRules?: Array<Wealthlane_AwardService_PerformanceRule_PerformanceRule>,
    grantPerformanceRuleApprovalStatusExtraProperties?: Record<string, any>,
    grantPerformanceRuleApprovalStatusConcurrencyStamp?: string,
    grantPerformanceRuleEarnedStatusId?: number,
    grantPerformanceRuleEarnedStatusSystemName?: string,
    grantPerformanceRuleEarnedStatusDisplayName?: string,
    grantPerformanceRuleEarnedStatusPerformanceRules?: Array<Wealthlane_AwardService_PerformanceRule_PerformanceRule>,
    grantPerformanceRuleEarnedStatusExtraProperties?: Record<string, any>,
    grantPerformanceRuleEarnedStatusConcurrencyStamp?: string,
    grantPerformanceRuleAvailableStatusId?: number,
    grantPerformanceRuleAvailableStatusSystemName?: string,
    grantPerformanceRuleAvailableStatusDisplayName?: string,
    grantPerformanceRuleAvailableStatusPerformanceRules?: Array<Wealthlane_AwardService_PerformanceRule_PerformanceRule>,
    grantPerformanceRuleAvailableStatusExtraProperties?: Record<string, any>,
    grantPerformanceRuleAvailableStatusConcurrencyStamp?: string,
    grantPerformanceRulePerformanceEvaluations?: Array<Wealthlane_AwardService_PerformanceEvaluation_PerformanceEvaluation>,
    grantPerformanceRuleEstimatePerformanceTracking?: Array<Wealthlane_AwardService_EstimatePerformanceTracking_EstimatePerformanceTracking>,
    grantPerformanceRuleGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantPerformanceRulePerformanceRuleApprovals?: Array<Wealthlane_AwardService_PerformanceRuleApproval_PerformanceRuleApproval>,
    grantPerformanceRuleIsDeleted?: boolean,
    grantPerformanceRuleDeleterId?: string,
    grantPerformanceRuleDeletionTime?: string,
    grantPerformanceRuleLastModificationTime?: string,
    grantPerformanceRuleLastModifierId?: string,
    grantPerformanceRuleCreationTime?: string,
    grantPerformanceRuleCreatorId?: string,
    grantPerformanceRuleExtraProperties?: Record<string, any>,
    grantPerformanceRuleConcurrencyStamp?: string,
    grantRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    grantGrantDocuments?: Array<Wealthlane_AwardService_GrantDocument_GrantDocument>,
    grantPsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    grantGrantAgreementDocumentTenantId?: string,
    grantGrantAgreementDocumentPlanId?: string,
    grantGrantAgreementDocumentDescription?: string,
    grantGrantAgreementDocumentGrantDocumentType?: number,
    grantGrantAgreementDocumentGrantTermsAndConditionText?: string,
    grantGrantAgreementDocumentTnCDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantGrantAgreementDocumentNoticeDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantGrantAgreementDocumentAgreementDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantGrantAgreementDocumentTnCDocumentTextEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantGrantAgreementDocumentGrantAgreementDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantGrantAgreementDocumentGrantNoticeDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantGrantAgreementDocumentGrantTermsAndConditionDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantGrantAgreementDocumentGrantTermsAndConditionTexts?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantGrantAgreementDocumentPlanGrantDocumentDetails?: Array<Wealthlane_AwardService_PlanGrantDocumentDetail_PlanGrantDocumentDetails>,
    grantGrantAgreementDocumentIsDeleted?: boolean,
    grantGrantAgreementDocumentDeleterId?: string,
    grantGrantAgreementDocumentDeletionTime?: string,
    grantGrantAgreementDocumentLastModificationTime?: string,
    grantGrantAgreementDocumentLastModifierId?: string,
    grantGrantAgreementDocumentCreationTime?: string,
    grantGrantAgreementDocumentCreatorId?: string,
    grantGrantAgreementDocumentExtraProperties?: Record<string, any>,
    grantGrantAgreementDocumentConcurrencyStamp?: string,
    grantGrantNoticeDocumentTenantId?: string,
    grantGrantNoticeDocumentPlanId?: string,
    grantGrantNoticeDocumentDescription?: string,
    grantGrantNoticeDocumentGrantDocumentType?: number,
    grantGrantNoticeDocumentGrantTermsAndConditionText?: string,
    grantGrantNoticeDocumentTnCDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantGrantNoticeDocumentNoticeDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantGrantNoticeDocumentAgreementDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantGrantNoticeDocumentTnCDocumentTextEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantGrantNoticeDocumentGrantAgreementDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantGrantNoticeDocumentGrantNoticeDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantGrantNoticeDocumentGrantTermsAndConditionDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantGrantNoticeDocumentGrantTermsAndConditionTexts?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantGrantNoticeDocumentPlanGrantDocumentDetails?: Array<Wealthlane_AwardService_PlanGrantDocumentDetail_PlanGrantDocumentDetails>,
    grantGrantNoticeDocumentIsDeleted?: boolean,
    grantGrantNoticeDocumentDeleterId?: string,
    grantGrantNoticeDocumentDeletionTime?: string,
    grantGrantNoticeDocumentLastModificationTime?: string,
    grantGrantNoticeDocumentLastModifierId?: string,
    grantGrantNoticeDocumentCreationTime?: string,
    grantGrantNoticeDocumentCreatorId?: string,
    grantGrantNoticeDocumentExtraProperties?: Record<string, any>,
    grantGrantNoticeDocumentConcurrencyStamp?: string,
    grantTermsAndConditionDocumentTenantId?: string,
    grantTermsAndConditionDocumentPlanId?: string,
    grantTermsAndConditionDocumentDescription?: string,
    grantTermsAndConditionDocumentGrantDocumentType?: number,
    grantTermsAndConditionDocumentGrantTermsAndConditionText?: string,
    grantTermsAndConditionDocumentTnCDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantTermsAndConditionDocumentNoticeDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantTermsAndConditionDocumentAgreementDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantTermsAndConditionDocumentTnCDocumentTextEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantTermsAndConditionDocumentGrantAgreementDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantTermsAndConditionDocumentGrantNoticeDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantTermsAndConditionDocumentGrantTermsAndConditionDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantTermsAndConditionDocumentGrantTermsAndConditionTexts?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantTermsAndConditionDocumentPlanGrantDocumentDetails?: Array<Wealthlane_AwardService_PlanGrantDocumentDetail_PlanGrantDocumentDetails>,
    grantTermsAndConditionDocumentIsDeleted?: boolean,
    grantTermsAndConditionDocumentDeleterId?: string,
    grantTermsAndConditionDocumentDeletionTime?: string,
    grantTermsAndConditionDocumentLastModificationTime?: string,
    grantTermsAndConditionDocumentLastModifierId?: string,
    grantTermsAndConditionDocumentCreationTime?: string,
    grantTermsAndConditionDocumentCreatorId?: string,
    grantTermsAndConditionDocumentExtraProperties?: Record<string, any>,
    grantTermsAndConditionDocumentConcurrencyStamp?: string,
    grantTermsAndConditionTextTenantId?: string,
    grantTermsAndConditionTextPlanId?: string,
    grantTermsAndConditionTextDescription?: string,
    grantTermsAndConditionTextGrantDocumentType?: number,
    grantTermsAndConditionTextGrantTermsAndConditionText?: string,
    grantTermsAndConditionTextTnCDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantTermsAndConditionTextNoticeDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantTermsAndConditionTextAgreementDocumentEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantTermsAndConditionTextTnCDocumentTextEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    grantTermsAndConditionTextGrantAgreementDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantTermsAndConditionTextGrantNoticeDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantTermsAndConditionTextGrantTermsAndConditionDocuments?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantTermsAndConditionTextGrantTermsAndConditionTexts?: Array<Wealthlane_AwardService_Grant_Grant>,
    grantTermsAndConditionTextPlanGrantDocumentDetails?: Array<Wealthlane_AwardService_PlanGrantDocumentDetail_PlanGrantDocumentDetails>,
    grantTermsAndConditionTextIsDeleted?: boolean,
    grantTermsAndConditionTextDeleterId?: string,
    grantTermsAndConditionTextDeletionTime?: string,
    grantTermsAndConditionTextLastModificationTime?: string,
    grantTermsAndConditionTextLastModifierId?: string,
    grantTermsAndConditionTextCreationTime?: string,
    grantTermsAndConditionTextCreatorId?: string,
    grantTermsAndConditionTextExtraProperties?: Record<string, any>,
    grantTermsAndConditionTextConcurrencyStamp?: string,
    grantGrantTermsAndConditions?: Array<Wealthlane_AwardService_GrantTermsAndConditions_GrantTermsAndConditions>,
    grantOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    grantTerminationRuleSetTenantId?: string,
    grantTerminationRuleSetExtraProperties?: Record<string, any>,
    grantTerminationRuleSetConcurrencyStamp?: string,
    grantSettlementTypeSystemName?: string,
    grantSettlementTypeDisplayName?: string,
    grantSettlementTypeIsCashSellType?: boolean,
    grantSettlementTypeExtraProperties?: Record<string, any>,
    grantSettlementTypeConcurrencyStamp?: string,
    grantIsDeleted?: boolean,
    grantDeleterId?: string,
    grantDeletionTime?: string,
    grantLastModificationTime?: string,
    grantLastModifierId?: string,
    grantCreationTime?: string,
    grantCreatorId?: string,
    vestingTemplateTenantId?: string,
    vestingTemplateCompanyId?: string,
    vestingTemplateName?: string,
    vestingTemplateSummary?: string,
    vestingTemplateVestingTypeId?: string,
    vestingTemplateLengthInMonths?: number,
    vestingTemplateAmountOneInPercentage?: number,
    vestingTemplateVestsAfterInMonths?: number,
    vestingTemplateAmountTwoInPercentage?: number,
    vestingTemplateVestsInMonths?: number,
    vestingTemplateIntervalInMonths?: number,
    vestingTemplateIsEnabled?: boolean,
    vestingTemplateIsDefaultVestingTemplate?: boolean,
    vestingTemplatePeriodStartDate?: string,
    vestingTemplateRoundingTypeId?: number,
    vestingTemplateFractionalDecimalDigit?: number,
    vestingTemplateVestAtEndOfMonth?: boolean,
    vestingTemplateSpecificVestingInstruction?: string,
    vestingTemplateLoadingTypeId?: number,
    vestingTemplateEndOfTheMonthTypeId?: number,
    vestingTemplateCompanyTenantId?: string,
    vestingTemplateCompanyCreatorId?: string,
    vestingTemplateCompanyCreationTime?: string,
    vestingTemplateCompanyLastModifierId?: string,
    vestingTemplateCompanyLastModificationTime?: string,
    vestingTemplateCompanyIsDeleted?: boolean,
    vestingTemplateCompanyDeleterId?: string,
    vestingTemplateCompanyDeletionTime?: string,
    vestingTemplateCompanyTicker?: string,
    vestingTemplateCompanyIsoCalculationSortingTypeId?: number,
    vestingTemplateCompanyIsoCalculationSortingTypeSystemName?: string,
    vestingTemplateCompanyIsoCalculationSortingTypeDisplayName?: string,
    vestingTemplateCompanyIsoCalculationSortingTypeExtraProperties?: Record<string, any>,
    vestingTemplateCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    vestingTemplateCompanyIsEmailEnableToParticipant?: boolean,
    vestingTemplateCompanyCommissionId?: string,
    vestingTemplateCompanyDtcParticipantId?: string,
    vestingTemplateCompanyIntendedShareRegistrationTypeSystemName?: string,
    vestingTemplateCompanyIntendedShareRegistrationTypeDisplayName?: string,
    vestingTemplateCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    vestingTemplateCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    vestingTemplateCompanyIntendedShareRegistrationTypeCreationTime?: string,
    vestingTemplateCompanyIntendedShareRegistrationTypeCreatorId?: string,
    vestingTemplateCompanyIntendedShareRegistrationTypeExtraProperties?: Record<string, any>,
    vestingTemplateCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    vestingTemplateCompanyIntendedShareRegistrationTypeId?: number,
    vestingTemplateCompanyTransactionAcquisitionTypeId?: number,
    vestingTemplateCompanyTransactionAcquisitionTypeSystemName?: string,
    vestingTemplateCompanyTransactionAcquisitionTypeDisplayName?: string,
    vestingTemplateCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    vestingTemplateCompanyTransactionAcquisitionTypeLastModifierId?: string,
    vestingTemplateCompanyTransactionAcquisitionTypeCreationTime?: string,
    vestingTemplateCompanyTransactionAcquisitionTypeCreatorId?: string,
    vestingTemplateCompanyTransactionAcquisitionTypeExtraProperties?: Record<string, any>,
    vestingTemplateCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    vestingTemplateCompanyPriceThreshold?: number,
    vestingTemplateCompanyIsPartBRequired?: boolean,
    vestingTemplateCompanyIsPartCRequired?: boolean,
    vestingTemplateCompanyCommissionOwningCompanyId?: string,
    vestingTemplateCompanyCommissionOwningCompanyTenantId?: string,
    vestingTemplateCompanyCommissionOwningCompanyCreatorId?: string,
    vestingTemplateCompanyCommissionOwningCompanyCreationTime?: string,
    vestingTemplateCompanyCommissionOwningCompanyLastModifierId?: string,
    vestingTemplateCompanyCommissionOwningCompanyLastModificationTime?: string,
    vestingTemplateCompanyCommissionOwningCompanyIsDeleted?: boolean,
    vestingTemplateCompanyCommissionOwningCompanyDeleterId?: string,
    vestingTemplateCompanyCommissionOwningCompanyDeletionTime?: string,
    vestingTemplateCompanyCommissionOwningCompanyTicker?: string,
    vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId?: number,
    vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName?: string,
    vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName?: string,
    vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties?: Record<
      string,
      any
    >,
    vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    vestingTemplateCompanyCommissionOwningCompanyIsEmailEnableToParticipant?: boolean,
    vestingTemplateCompanyCommissionOwningCompanyCommissionId?: string,
    vestingTemplateCompanyCommissionOwningCompanyDtcParticipantId?: string,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId?: number,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName?: string,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName?: string,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime?: string,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId?: string,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties?: Record<
      string,
      any
    >,
    vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName?: string,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName?: string,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId?: string,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime?: string,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId?: string,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties?: Record<
      string,
      any
    >,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId?: number,
    vestingTemplateCompanyCommissionOwningCompanyPriceThreshold?: number,
    vestingTemplateCompanyCommissionOwningCompanyIsPartBRequired?: boolean,
    vestingTemplateCompanyCommissionOwningCompanyIsPartCRequired?: boolean,
    vestingTemplateCompanyCommissionOwningCompanyCommission?: Wealthlane_AwardService_Commission_Commission,
    vestingTemplateCompanyCommissionOwningCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    vestingTemplateCompanyCommissionOwningCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    vestingTemplateCompanyCommissionOwningCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    vestingTemplateCompanyCommissionOwningCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    vestingTemplateCompanyCommissionOwningCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    vestingTemplateCompanyCommissionOwningCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    vestingTemplateCompanyCommissionOwningCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    vestingTemplateCompanyCommissionOwningCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    vestingTemplateCompanyCommissionOwningCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    vestingTemplateCompanyCommissionOwningCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    vestingTemplateCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    vestingTemplateCompanyCommissionOwningCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    vestingTemplateCompanyCommissionOwningCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    vestingTemplateCompanyCommissionOwningCompanyExtraProperties?: Record<string, any>,
    vestingTemplateCompanyCommissionOwningCompanyConcurrencyStamp?: string,
    vestingTemplateCompanyCommissionBrokerCompanyId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTenantId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyCreatorId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyCreationTime?: string,
    vestingTemplateCompanyCommissionBrokerCompanyLastModifierId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyLastModificationTime?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIsDeleted?: boolean,
    vestingTemplateCompanyCommissionBrokerCompanyDeleterId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyDeletionTime?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTicker?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId?: number,
    vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties?: Record<
      string,
      any
    >,
    vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIsEmailEnableToParticipant?: boolean,
    vestingTemplateCompanyCommissionBrokerCompanyCommissionId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyDtcParticipantId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId?: number,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties?: Record<
      string,
      any
    >,
    vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId?: number,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId?: string,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties?: Record<
      string,
      any
    >,
    vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp?: string,
    vestingTemplateCompanyCommissionBrokerCompanyPriceThreshold?: number,
    vestingTemplateCompanyCommissionBrokerCompanyIsPartBRequired?: boolean,
    vestingTemplateCompanyCommissionBrokerCompanyIsPartCRequired?: boolean,
    vestingTemplateCompanyCommissionBrokerCompanyCommission?: Wealthlane_AwardService_Commission_Commission,
    vestingTemplateCompanyCommissionBrokerCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    vestingTemplateCompanyCommissionBrokerCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    vestingTemplateCompanyCommissionBrokerCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    vestingTemplateCompanyCommissionBrokerCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    vestingTemplateCompanyCommissionBrokerCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    vestingTemplateCompanyCommissionBrokerCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    vestingTemplateCompanyCommissionBrokerCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    vestingTemplateCompanyCommissionBrokerCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    vestingTemplateCompanyCommissionBrokerCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    vestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    vestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    vestingTemplateCompanyCommissionBrokerCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    vestingTemplateCompanyCommissionBrokerCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    vestingTemplateCompanyCommissionBrokerCompanyExtraProperties?: Record<string, any>,
    vestingTemplateCompanyCommissionBrokerCompanyConcurrencyStamp?: string,
    vestingTemplateCompanyCommissionName?: string,
    vestingTemplateCompanyCommissionDescription?: string,
    vestingTemplateCompanyCommissionBaseRate?: number,
    vestingTemplateCompanyCommissionMaxAmount?: number,
    vestingTemplateCompanyCommissionCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    vestingTemplateCompanyCommissionCompany?: Array<Wealthlane_AwardService_Company_Company>,
    vestingTemplateCompanyCommissionIsDeleted?: boolean,
    vestingTemplateCompanyCommissionDeleterId?: string,
    vestingTemplateCompanyCommissionDeletionTime?: string,
    vestingTemplateCompanyCommissionLastModificationTime?: string,
    vestingTemplateCompanyCommissionLastModifierId?: string,
    vestingTemplateCompanyCommissionCreationTime?: string,
    vestingTemplateCompanyCommissionCreatorId?: string,
    vestingTemplateCompanyCustomerApprovalProcesses?: Array<Wealthlane_AwardService_CustomerApprovalProcess_CustomerApprovalProcess>,
    vestingTemplateCompanyVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    vestingTemplateCompanyRsuAward?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    vestingTemplateCompanyOwnedCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    vestingTemplateCompanyBrokeredCommissions?: Array<Wealthlane_AwardService_Commission_Commission>,
    vestingTemplateCompanyCommissionSchedules?: Array<Wealthlane_AwardService_CommissionSchedule_CommissionSchedule>,
    vestingTemplateCompanyRsuAwardVestingDate?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    vestingTemplateCompanyElectionWindowConfigurations?: Array<Wealthlane_AwardService_ElectionWindowConfiguration_ElectionWindowConfiguration>,
    vestingTemplateCompanyOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    vestingTemplateCompanyTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    vestingTemplateCompanyTradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    vestingTemplateCompanyPsuAward?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    vestingTemplateCompanyPsuAwardVestingDate?: Array<Wealthlane_AwardService_PSUAwardVestingDate_PSUAwardVestingDate>,
    vestingTemplateCompanyExtraProperties?: Record<string, any>,
    vestingTemplateCompanyConcurrencyStamp?: string,
    vestingTemplateVestingTypeName?: string,
    vestingTemplateVestingTypeIsCliffVesting?: boolean,
    vestingTemplateVestingTypeIsStepVesting?: boolean,
    vestingTemplateVestingTypeIsHybridVesting?: boolean,
    vestingTemplateVestingTypeIsCustomVesting?: boolean,
    vestingTemplateVestingTypeIsSpecificVesting?: boolean,
    vestingTemplateVestingTypeIsCustomVestingTranche?: boolean,
    vestingTemplateVestingTypeIsEnabled?: boolean,
    vestingTemplateVestingTypeVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    vestingTemplateVestingTypeDefaultVestingTemplates?: Array<Wealthlane_AwardService_DefaultVestingTemplate_DefaultVestingTemplate>,
    vestingTemplateVestingTypeIsDeleted?: boolean,
    vestingTemplateVestingTypeDeleterId?: string,
    vestingTemplateVestingTypeDeletionTime?: string,
    vestingTemplateVestingTypeLastModificationTime?: string,
    vestingTemplateVestingTypeLastModifierId?: string,
    vestingTemplateVestingTypeCreationTime?: string,
    vestingTemplateVestingTypeCreatorId?: string,
    vestingTemplateVestingTypeExtraProperties?: Record<string, any>,
    vestingTemplateVestingTypeConcurrencyStamp?: string,
    vestingTemplateRoundingTypeDisplayName?: string,
    vestingTemplateRoundingTypeSystemName?: string,
    vestingTemplateRoundingTypeVestingTemplates?: Array<Wealthlane_AwardService_VestingTemplate_VestingTemplate>,
    vestingTemplateRoundingTypeDefaultVestingTemplates?: Array<Wealthlane_AwardService_DefaultVestingTemplate_DefaultVestingTemplate>,
    vestingTemplateRoundingTypeExtraProperties?: Record<string, any>,
    vestingTemplateRoundingTypeConcurrencyStamp?: string,
    vestingTemplateRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    vestingTemplateGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    vestingTemplateOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    vestingTemplatePsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    vestingTemplateLoadingTypeSystemName?: string,
    vestingTemplateLoadingTypeDisplayName?: string,
    vestingTemplateLoadingTypeLastModificationTime?: string,
    vestingTemplateLoadingTypeLastModifierId?: string,
    vestingTemplateLoadingTypeCreationTime?: string,
    vestingTemplateLoadingTypeCreatorId?: string,
    vestingTemplateLoadingTypeExtraProperties?: Record<string, any>,
    vestingTemplateLoadingTypeConcurrencyStamp?: string,
    vestingTemplateEndOfTheMonthTypeSystemName?: string,
    vestingTemplateEndOfTheMonthTypeDisplayName?: string,
    vestingTemplateEndOfTheMonthTypeLastModificationTime?: string,
    vestingTemplateEndOfTheMonthTypeLastModifierId?: string,
    vestingTemplateEndOfTheMonthTypeCreationTime?: string,
    vestingTemplateEndOfTheMonthTypeCreatorId?: string,
    vestingTemplateEndOfTheMonthTypeExtraProperties?: Record<string, any>,
    vestingTemplateEndOfTheMonthTypeConcurrencyStamp?: string,
    vestingTemplateIsDeleted?: boolean,
    vestingTemplateDeleterId?: string,
    vestingTemplateDeletionTime?: string,
    vestingTemplateLastModificationTime?: string,
    vestingTemplateLastModifierId?: string,
    vestingTemplateCreationTime?: string,
    vestingTemplateCreatorId?: string,
    vestingTemplateExtraProperties?: Record<string, any>,
    vestingTemplateConcurrencyStamp?: string,
    planTenantId?: string,
    planEligibleShareClass?: string,
    planDescription?: string,
    planEvergreenCriteria?: string,
    planDeathExpirationOption?: number,
    planDisablityExpirationOption?: number,
    planRetirementExpirationOption?: number,
    planVolutaryTerminationOption?: number,
    planInvolutaryTerminationOption?: number,
    planOptionExpirationDate?: number,
    planNumberOfSharesUnAvailable?: number,
    planPlanExpiryDate?: string,
    planWithACause?: number,
    planTerminationRuleSetId?: string,
    planPoolId?: string,
    planPoolTenantId?: string,
    planPoolCompanyId?: string,
    planPoolDescription?: string,
    planPoolExternalPoolName?: string,
    planPoolExternalPoolReferenceId?: string,
    planPoolTransactions?: Array<Wealthlane_AwardService_Transaction_Transaction>,
    planPoolRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    planPoolPsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    planPoolOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    planPoolGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    planPoolPlans?: Array<Wealthlane_AwardService_Plan_Plan>,
    planPoolIsDeleted?: boolean,
    planPoolDeleterId?: string,
    planPoolDeletionTime?: string,
    planPoolLastModificationTime?: string,
    planPoolLastModifierId?: string,
    planPoolCreationTime?: string,
    planPoolCreatorId?: string,
    planPoolExtraProperties?: Record<string, any>,
    planPoolConcurrencyStamp?: string,
    planAllowEditPlanRelatedDocuments?: boolean,
    planPlanDocuments?: Array<Wealthlane_AwardService_PlanDocument_PlanDocument>,
    planRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    planPsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    planGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    planOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    planTradePreClearanceRequests?: Array<Wealthlane_AwardService_TradePreClearanceRequest_TradePreClearanceRequest>,
    planEsppOfferingPeriods?: Array<Wealthlane_AwardService_EsppAwards_EsppOfferingPeriod>,
    planPlanApprovals?: Array<Wealthlane_AwardService_PlanApproval_PlanApproval>,
    planPlanPlanTypeCategories?: Array<Wealthlane_AwardService_PlanPlanTypeCategory_PlanPlanTypeCategory>,
    planTerminationRuleSetTenantId?: string,
    planTerminationRuleSetExtraProperties?: Record<string, any>,
    planTerminationRuleSetConcurrencyStamp?: string,
    planIsDeleted?: boolean,
    planDeleterId?: string,
    planDeletionTime?: string,
    planLastModificationTime?: string,
    planLastModifierId?: string,
    planCreationTime?: string,
    planCreatorId?: string,
    planExtraProperties?: Record<string, any>,
    planConcurrencyStamp?: string,
    poolId?: string,
    poolTenantId?: string,
    poolCompanyId?: string,
    poolDescription?: string,
    poolExternalPoolName?: string,
    poolExternalPoolReferenceId?: string,
    poolTransactions?: Array<Wealthlane_AwardService_Transaction_Transaction>,
    poolRsuAwards?: Array<Wealthlane_AwardService_RSUAward_RSUAward>,
    poolPsuAwards?: Array<Wealthlane_AwardService_PSUAward_PSUAward>,
    poolOptionAwards?: Array<Wealthlane_AwardService_OptionAwards_OptionAwards>,
    poolGrants?: Array<Wealthlane_AwardService_Grant_Grant>,
    poolPlans?: Array<Wealthlane_AwardService_Plan_Plan>,
    poolIsDeleted?: boolean,
    poolDeleterId?: string,
    poolDeletionTime?: string,
    poolLastModificationTime?: string,
    poolLastModifierId?: string,
    poolCreationTime?: string,
    poolCreatorId?: string,
    poolExtraProperties?: Record<string, any>,
    poolConcurrencyStamp?: string,
    remarks?: string,
    accepted?: boolean,
    acceptedAt?: string,
    awardReleasedDate?: string,
    grantReason?: string,
    signature?: string,
    isRsuAwardEmailNotificationSent?: boolean,
    isRsuAwardReleased?: boolean,
    oldRsuAwardId?: string,
    cancelledDate?: string,
    fileName?: string,
    fairValue?: number,
    methodTypeId?: number,
    asOfDate?: string,
    residualShare?: string,
    targetOutStandingShare?: number,
    targetCancelledShare?: number,
    adjustmentReason?: string,
    terminationRuleSetId?: string,
    settlementTypeId?: string,
    rsuAwardApprovals?: Array<Wealthlane_AwardService_RSUAwardApproval_RSUAwardApproval>,
    rsuAwardVestingDates?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    rsuAwardEmailNotificationLogs?: Array<Wealthlane_AwardService_RSUAwardEmailNotificationLog_RSUAwardEmailNotificationLog>,
    tradePreClearanceParticipantAwards?: Array<Wealthlane_AwardService_TradePreClearanceParticipantAward_TradePreClearanceParticipantAward>,
    fairValues?: Array<Wealthlane_AwardService_FairValue_FairValue>,
    participantAwardTerminations?: Array<Wealthlane_AwardService_ParticipantAwardTermination_ParticipantAwardTermination>,
    rsuAwardSignupTokens?: Array<Wealthlane_AwardService_RSUAwardSignupToken_RSUAwardSignupToken>,
    awardDocuments?: Array<Wealthlane_AwardService_AwardDocument_AwardDocument>,
    terminationRuleSetTenantId?: string,
    terminationRuleSetExtraProperties?: Record<string, any>,
    terminationRuleSetConcurrencyStamp?: string,
    settlementTypeSystemName?: string,
    settlementTypeDisplayName?: string,
    settlementTypeIsCashSellType?: boolean,
    settlementTypeExtraProperties?: Record<string, any>,
    settlementTypeConcurrencyStamp?: string,
    isDeleted?: boolean,
    deleterId?: string,
    deletionTime?: string,
    lastModificationTime?: string,
    lastModifierId?: string,
    creationTime?: string,
    creatorId?: string,
    extraProperties?: Record<string, any>,
    concurrencyStamp?: string,
    vestingTranches?: Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>,
    oldShare?: number,
    newShare?: number
  ): CancelablePromise<Array<Wealthlane_AwardService_RSUAwardVestingDate_RSUAwardVestingDate>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/app/rsu-award-import/vesting-tranche-ratio-calculation-for-custom-vesting',
      query: {
        Id: id,
        TenantId: tenantId,
        CompanyId: companyId,
        'Company.Id': companyId,
        'Company.TenantId': companyTenantId,
        'Company.Name': companyName,
        'Company.IsEnabled': companyIsEnabled,
        'Company.CreatorId': companyCreatorId,
        'Company.CreationTime': companyCreationTime,
        'Company.LastModifierId': companyLastModifierId,
        'Company.LastModificationTime': companyLastModificationTime,
        'Company.IsDeleted': companyIsDeleted,
        'Company.DeleterId': companyDeleterId,
        'Company.DeletionTime': companyDeletionTime,
        'Company.Ticker': companyTicker,
        'Company.IsoCalculationSortingTypeId': companyIsoCalculationSortingTypeId,
        'Company.IsoCalculationSortingType.Id': companyIsoCalculationSortingTypeId,
        'Company.IsoCalculationSortingType.SystemName': companyIsoCalculationSortingTypeSystemName,
        'Company.IsoCalculationSortingType.DisplayName':
          companyIsoCalculationSortingTypeDisplayName,
        'Company.IsoCalculationSortingType.ExtraProperties':
          companyIsoCalculationSortingTypeExtraProperties,
        'Company.IsoCalculationSortingType.ConcurrencyStamp':
          companyIsoCalculationSortingTypeConcurrencyStamp,
        'Company.IsEmailEnableToParticipant': companyIsEmailEnableToParticipant,
        'Company.CommissionId': companyCommissionId,
        'Company.DtcParticipantId': companyDtcParticipantId,
        'Company.IntendedShareRegistrationTypeId': companyIntendedShareRegistrationTypeId,
        'Company.IntendedShareRegistrationType.SystemName':
          companyIntendedShareRegistrationTypeSystemName,
        'Company.IntendedShareRegistrationType.DisplayName':
          companyIntendedShareRegistrationTypeDisplayName,
        'Company.IntendedShareRegistrationType.LastModificationTime':
          companyIntendedShareRegistrationTypeLastModificationTime,
        'Company.IntendedShareRegistrationType.LastModifierId':
          companyIntendedShareRegistrationTypeLastModifierId,
        'Company.IntendedShareRegistrationType.CreationTime':
          companyIntendedShareRegistrationTypeCreationTime,
        'Company.IntendedShareRegistrationType.CreatorId':
          companyIntendedShareRegistrationTypeCreatorId,
        'Company.IntendedShareRegistrationType.ExtraProperties':
          companyIntendedShareRegistrationTypeExtraProperties,
        'Company.IntendedShareRegistrationType.ConcurrencyStamp':
          companyIntendedShareRegistrationTypeConcurrencyStamp,
        'Company.IntendedShareRegistrationType.Id': companyIntendedShareRegistrationTypeId,
        'Company.TransactionAcquisitionTypeId': companyTransactionAcquisitionTypeId,
        'Company.TransactionAcquisitionType.SystemName':
          companyTransactionAcquisitionTypeSystemName,
        'Company.TransactionAcquisitionType.DisplayName':
          companyTransactionAcquisitionTypeDisplayName,
        'Company.TransactionAcquisitionType.LastModificationTime':
          companyTransactionAcquisitionTypeLastModificationTime,
        'Company.TransactionAcquisitionType.LastModifierId':
          companyTransactionAcquisitionTypeLastModifierId,
        'Company.TransactionAcquisitionType.CreationTime':
          companyTransactionAcquisitionTypeCreationTime,
        'Company.TransactionAcquisitionType.CreatorId': companyTransactionAcquisitionTypeCreatorId,
        'Company.TransactionAcquisitionType.ExtraProperties':
          companyTransactionAcquisitionTypeExtraProperties,
        'Company.TransactionAcquisitionType.ConcurrencyStamp':
          companyTransactionAcquisitionTypeConcurrencyStamp,
        'Company.TransactionAcquisitionType.Id': companyTransactionAcquisitionTypeId,
        'Company.PriceThreshold': companyPriceThreshold,
        'Company.IsPartBRequired': companyIsPartBRequired,
        'Company.IsPartCRequired': companyIsPartCRequired,
        'Company.Commission.OwningCompanyId': companyCommissionOwningCompanyId,
        'Company.Commission.OwningCompany.Id': companyCommissionOwningCompanyId,
        'Company.Commission.OwningCompany.TenantId': companyCommissionOwningCompanyTenantId,
        'Company.Commission.OwningCompany.Name': companyCommissionOwningCompanyName,
        'Company.Commission.OwningCompany.IsEnabled': companyCommissionOwningCompanyIsEnabled,
        'Company.Commission.OwningCompany.CreatorId': companyCommissionOwningCompanyCreatorId,
        'Company.Commission.OwningCompany.CreationTime': companyCommissionOwningCompanyCreationTime,
        'Company.Commission.OwningCompany.LastModifierId':
          companyCommissionOwningCompanyLastModifierId,
        'Company.Commission.OwningCompany.LastModificationTime':
          companyCommissionOwningCompanyLastModificationTime,
        'Company.Commission.OwningCompany.IsDeleted': companyCommissionOwningCompanyIsDeleted,
        'Company.Commission.OwningCompany.DeleterId': companyCommissionOwningCompanyDeleterId,
        'Company.Commission.OwningCompany.DeletionTime': companyCommissionOwningCompanyDeletionTime,
        'Company.Commission.OwningCompany.Ticker': companyCommissionOwningCompanyTicker,
        'Company.Commission.OwningCompany.IsoCalculationSortingTypeId':
          companyCommissionOwningCompanyIsoCalculationSortingTypeId,
        'Company.Commission.OwningCompany.IsoCalculationSortingType.Id':
          companyCommissionOwningCompanyIsoCalculationSortingTypeId,
        'Company.Commission.OwningCompany.IsoCalculationSortingType.SystemName':
          companyCommissionOwningCompanyIsoCalculationSortingTypeSystemName,
        'Company.Commission.OwningCompany.IsoCalculationSortingType.DisplayName':
          companyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName,
        'Company.Commission.OwningCompany.IsoCalculationSortingType.ExtraProperties':
          companyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties,
        'Company.Commission.OwningCompany.IsoCalculationSortingType.ConcurrencyStamp':
          companyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'Company.Commission.OwningCompany.IsEmailEnableToParticipant':
          companyCommissionOwningCompanyIsEmailEnableToParticipant,
        'Company.Commission.OwningCompany.CommissionId': companyCommissionOwningCompanyCommissionId,
        'Company.Commission.OwningCompany.DtcParticipantId':
          companyCommissionOwningCompanyDtcParticipantId,
        'Company.Commission.OwningCompany.IntendedShareRegistrationTypeId':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeId,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.SystemName':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.DisplayName':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.LastModificationTime':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.LastModifierId':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.CreationTime':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.CreatorId':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.ExtraProperties':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.ConcurrencyStamp':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'Company.Commission.OwningCompany.IntendedShareRegistrationType.Id':
          companyCommissionOwningCompanyIntendedShareRegistrationTypeId,
        'Company.Commission.OwningCompany.TransactionAcquisitionTypeId':
          companyCommissionOwningCompanyTransactionAcquisitionTypeId,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.SystemName':
          companyCommissionOwningCompanyTransactionAcquisitionTypeSystemName,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.DisplayName':
          companyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.LastModificationTime':
          companyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.LastModifierId':
          companyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.CreationTime':
          companyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.CreatorId':
          companyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.ExtraProperties':
          companyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.ConcurrencyStamp':
          companyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'Company.Commission.OwningCompany.TransactionAcquisitionType.Id':
          companyCommissionOwningCompanyTransactionAcquisitionTypeId,
        'Company.Commission.OwningCompany.PriceThreshold':
          companyCommissionOwningCompanyPriceThreshold,
        'Company.Commission.OwningCompany.IsPartBRequired':
          companyCommissionOwningCompanyIsPartBRequired,
        'Company.Commission.OwningCompany.IsPartCRequired':
          companyCommissionOwningCompanyIsPartCRequired,
        'Company.Commission.OwningCompany.Commission': companyCommissionOwningCompanyCommission,
        'Company.Commission.OwningCompany.CustomerApprovalProcesses':
          companyCommissionOwningCompanyCustomerApprovalProcesses,
        'Company.Commission.OwningCompany.VestingTemplates':
          companyCommissionOwningCompanyVestingTemplates,
        'Company.Commission.OwningCompany.RSUAward': companyCommissionOwningCompanyRsuAward,
        'Company.Commission.OwningCompany.OwnedCommissions':
          companyCommissionOwningCompanyOwnedCommissions,
        'Company.Commission.OwningCompany.BrokeredCommissions':
          companyCommissionOwningCompanyBrokeredCommissions,
        'Company.Commission.OwningCompany.CommissionSchedules':
          companyCommissionOwningCompanyCommissionSchedules,
        'Company.Commission.OwningCompany.RSUAwardVestingDate':
          companyCommissionOwningCompanyRsuAwardVestingDate,
        'Company.Commission.OwningCompany.ElectionWindowConfigurations':
          companyCommissionOwningCompanyElectionWindowConfigurations,
        'Company.Commission.OwningCompany.OptionAwards': companyCommissionOwningCompanyOptionAwards,
        'Company.Commission.OwningCompany.TradePreClearanceRequests':
          companyCommissionOwningCompanyTradePreClearanceRequests,
        'Company.Commission.OwningCompany.TradePreClearanceParticipantAwards':
          companyCommissionOwningCompanyTradePreClearanceParticipantAwards,
        'Company.Commission.OwningCompany.PSUAward': companyCommissionOwningCompanyPsuAward,
        'Company.Commission.OwningCompany.PSUAwardVestingDate':
          companyCommissionOwningCompanyPsuAwardVestingDate,
        'Company.Commission.OwningCompany.ExtraProperties':
          companyCommissionOwningCompanyExtraProperties,
        'Company.Commission.OwningCompany.ConcurrencyStamp':
          companyCommissionOwningCompanyConcurrencyStamp,
        'Company.Commission.BrokerCompanyId': companyCommissionBrokerCompanyId,
        'Company.Commission.BrokerCompany.Id': companyCommissionBrokerCompanyId,
        'Company.Commission.BrokerCompany.TenantId': companyCommissionBrokerCompanyTenantId,
        'Company.Commission.BrokerCompany.Name': companyCommissionBrokerCompanyName,
        'Company.Commission.BrokerCompany.IsEnabled': companyCommissionBrokerCompanyIsEnabled,
        'Company.Commission.BrokerCompany.CreatorId': companyCommissionBrokerCompanyCreatorId,
        'Company.Commission.BrokerCompany.CreationTime': companyCommissionBrokerCompanyCreationTime,
        'Company.Commission.BrokerCompany.LastModifierId':
          companyCommissionBrokerCompanyLastModifierId,
        'Company.Commission.BrokerCompany.LastModificationTime':
          companyCommissionBrokerCompanyLastModificationTime,
        'Company.Commission.BrokerCompany.IsDeleted': companyCommissionBrokerCompanyIsDeleted,
        'Company.Commission.BrokerCompany.DeleterId': companyCommissionBrokerCompanyDeleterId,
        'Company.Commission.BrokerCompany.DeletionTime': companyCommissionBrokerCompanyDeletionTime,
        'Company.Commission.BrokerCompany.Ticker': companyCommissionBrokerCompanyTicker,
        'Company.Commission.BrokerCompany.IsoCalculationSortingTypeId':
          companyCommissionBrokerCompanyIsoCalculationSortingTypeId,
        'Company.Commission.BrokerCompany.IsoCalculationSortingType.Id':
          companyCommissionBrokerCompanyIsoCalculationSortingTypeId,
        'Company.Commission.BrokerCompany.IsoCalculationSortingType.SystemName':
          companyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName,
        'Company.Commission.BrokerCompany.IsoCalculationSortingType.DisplayName':
          companyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName,
        'Company.Commission.BrokerCompany.IsoCalculationSortingType.ExtraProperties':
          companyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties,
        'Company.Commission.BrokerCompany.IsoCalculationSortingType.ConcurrencyStamp':
          companyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'Company.Commission.BrokerCompany.IsEmailEnableToParticipant':
          companyCommissionBrokerCompanyIsEmailEnableToParticipant,
        'Company.Commission.BrokerCompany.CommissionId': companyCommissionBrokerCompanyCommissionId,
        'Company.Commission.BrokerCompany.DtcParticipantId':
          companyCommissionBrokerCompanyDtcParticipantId,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationTypeId':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeId,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.SystemName':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.DisplayName':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.LastModificationTime':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.LastModifierId':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.CreationTime':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.CreatorId':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.ExtraProperties':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.ConcurrencyStamp':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'Company.Commission.BrokerCompany.IntendedShareRegistrationType.Id':
          companyCommissionBrokerCompanyIntendedShareRegistrationTypeId,
        'Company.Commission.BrokerCompany.TransactionAcquisitionTypeId':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeId,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.SystemName':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.DisplayName':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.LastModificationTime':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.LastModifierId':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.CreationTime':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.CreatorId':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.ExtraProperties':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.ConcurrencyStamp':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'Company.Commission.BrokerCompany.TransactionAcquisitionType.Id':
          companyCommissionBrokerCompanyTransactionAcquisitionTypeId,
        'Company.Commission.BrokerCompany.PriceThreshold':
          companyCommissionBrokerCompanyPriceThreshold,
        'Company.Commission.BrokerCompany.IsPartBRequired':
          companyCommissionBrokerCompanyIsPartBRequired,
        'Company.Commission.BrokerCompany.IsPartCRequired':
          companyCommissionBrokerCompanyIsPartCRequired,
        'Company.Commission.BrokerCompany.Commission': companyCommissionBrokerCompanyCommission,
        'Company.Commission.BrokerCompany.CustomerApprovalProcesses':
          companyCommissionBrokerCompanyCustomerApprovalProcesses,
        'Company.Commission.BrokerCompany.VestingTemplates':
          companyCommissionBrokerCompanyVestingTemplates,
        'Company.Commission.BrokerCompany.RSUAward': companyCommissionBrokerCompanyRsuAward,
        'Company.Commission.BrokerCompany.OwnedCommissions':
          companyCommissionBrokerCompanyOwnedCommissions,
        'Company.Commission.BrokerCompany.BrokeredCommissions':
          companyCommissionBrokerCompanyBrokeredCommissions,
        'Company.Commission.BrokerCompany.CommissionSchedules':
          companyCommissionBrokerCompanyCommissionSchedules,
        'Company.Commission.BrokerCompany.RSUAwardVestingDate':
          companyCommissionBrokerCompanyRsuAwardVestingDate,
        'Company.Commission.BrokerCompany.ElectionWindowConfigurations':
          companyCommissionBrokerCompanyElectionWindowConfigurations,
        'Company.Commission.BrokerCompany.OptionAwards': companyCommissionBrokerCompanyOptionAwards,
        'Company.Commission.BrokerCompany.TradePreClearanceRequests':
          companyCommissionBrokerCompanyTradePreClearanceRequests,
        'Company.Commission.BrokerCompany.TradePreClearanceParticipantAwards':
          companyCommissionBrokerCompanyTradePreClearanceParticipantAwards,
        'Company.Commission.BrokerCompany.PSUAward': companyCommissionBrokerCompanyPsuAward,
        'Company.Commission.BrokerCompany.PSUAwardVestingDate':
          companyCommissionBrokerCompanyPsuAwardVestingDate,
        'Company.Commission.BrokerCompany.ExtraProperties':
          companyCommissionBrokerCompanyExtraProperties,
        'Company.Commission.BrokerCompany.ConcurrencyStamp':
          companyCommissionBrokerCompanyConcurrencyStamp,
        'Company.Commission.Name': companyCommissionName,
        'Company.Commission.Description': companyCommissionDescription,
        'Company.Commission.BaseRate': companyCommissionBaseRate,
        'Company.Commission.MaxAmount': companyCommissionMaxAmount,
        'Company.Commission.CommissionSchedules': companyCommissionCommissionSchedules,
        'Company.Commission.Company': companyCommissionCompany,
        'Company.Commission.IsDeleted': companyCommissionIsDeleted,
        'Company.Commission.DeleterId': companyCommissionDeleterId,
        'Company.Commission.DeletionTime': companyCommissionDeletionTime,
        'Company.Commission.LastModificationTime': companyCommissionLastModificationTime,
        'Company.Commission.LastModifierId': companyCommissionLastModifierId,
        'Company.Commission.CreationTime': companyCommissionCreationTime,
        'Company.Commission.CreatorId': companyCommissionCreatorId,
        'Company.Commission.Id': companyCommissionId,
        'Company.CustomerApprovalProcesses': companyCustomerApprovalProcesses,
        'Company.VestingTemplates': companyVestingTemplates,
        'Company.RSUAward': companyRsuAward,
        'Company.OwnedCommissions': companyOwnedCommissions,
        'Company.BrokeredCommissions': companyBrokeredCommissions,
        'Company.CommissionSchedules': companyCommissionSchedules,
        'Company.RSUAwardVestingDate': companyRsuAwardVestingDate,
        'Company.ElectionWindowConfigurations': companyElectionWindowConfigurations,
        'Company.OptionAwards': companyOptionAwards,
        'Company.TradePreClearanceRequests': companyTradePreClearanceRequests,
        'Company.TradePreClearanceParticipantAwards': companyTradePreClearanceParticipantAwards,
        'Company.PSUAward': companyPsuAward,
        'Company.PSUAwardVestingDate': companyPsuAwardVestingDate,
        'Company.ExtraProperties': companyExtraProperties,
        'Company.ConcurrencyStamp': companyConcurrencyStamp,
        ParticipantId: participantId,
        'Participant.Id': participantId,
        'Participant.TenantId': participantTenantId,
        'Participant.CompanyId': participantCompanyId,
        'Participant.PayrollId': participantPayrollId,
        'Participant.FirstName': participantFirstName,
        'Participant.MiddleName': participantMiddleName,
        'Participant.LastName': participantLastName,
        'Participant.EmployeeId': participantEmployeeId,
        'Participant.Email': participantEmail,
        'Participant.DateOfBirth': participantDateOfBirth,
        'Participant.Gender': participantGender,
        'Participant.MaritalStatus': participantMaritalStatus,
        'Participant.CountryOfLegalResidency': participantCountryOfLegalResidency,
        'Participant.AddressLine1': participantAddressLine1,
        'Participant.ParticipantApprovalStatus': participantParticipantApprovalStatus,
        'Participant.StatusName': participantStatusName,
        'Participant.CreatorId': participantCreatorId,
        'Participant.CreationDateTime': participantCreationDateTime,
        'Participant.HireDate': participantHireDate,
        'Participant.AbpUserId': participantAbpUserId,
        'Participant.IsOnBoarded': participantIsOnBoarded,
        'Participant.JobTitle': participantJobTitle,
        'Participant.Department': participantDepartment,
        'Participant.EmployeeStatus': participantEmployeeStatus,
        'Participant.IsTaxCertificationVerified': participantIsTaxCertificationVerified,
        'Participant.EmployeeType': participantEmployeeType,
        'Participant.CostCentre': participantCostCentre,
        'Participant.isTradePreClearanced': participantIsTradePreClearanced,
        'Participant.IsBlackout': participantIsBlackout,
        'Participant.HomeStateAbbreviation': participantHomeStateAbbreviation,
        'Participant.WorkStateAbbreviation': participantWorkStateAbbreviation,
        'Participant.AccountId': participantAccountId,
        'Participant.IsEmailSend': participantIsEmailSend,
        'Participant.IsSection16': participantIsSection16,
        'Participant.IsRule144': participantIsRule144,
        'Participant.FullName': participantFullName,
        'Participant.TerminationRuleSetId': participantTerminationRuleSetId,
        'Participant.SettlementTypeId': participantSettlementTypeId,
        'Participant.RSUAwards': participantRsuAwards,
        'Participant.OptionAwards': participantOptionAwards,
        'Participant.PSUAwards': participantPsuAwards,
        'Participant.TradePreClearanceRequests': participantTradePreClearanceRequests,
        'Participant.OptionExercises': participantOptionExercises,
        'Participant.PspParticipantId': participantPspParticipantId,
        'Participant.EsppPurchaseItems': participantEsppPurchaseItems,
        'Participant.ParticipantTerminations': participantParticipantTerminations,
        'Participant.TaxInputs': participantTaxInputs,
        'Participant.EsppParticipants': participantEsppParticipants,
        'Participant.Transactions': participantTransactions,
        'Participant.TADRSInstructions': participantTadrsInstructions,
        'Participant.TerminationRuleSet.Id': participantTerminationRuleSetId,
        'Participant.TerminationRuleSet.TenantId': participantTerminationRuleSetTenantId,
        'Participant.TerminationRuleSet.ExtraProperties':
          participantTerminationRuleSetExtraProperties,
        'Participant.TerminationRuleSet.ConcurrencyStamp':
          participantTerminationRuleSetConcurrencyStamp,
        'Participant.SettlementType.Id': participantSettlementTypeId,
        'Participant.SettlementType.SystemName': participantSettlementTypeSystemName,
        'Participant.SettlementType.DisplayName': participantSettlementTypeDisplayName,
        'Participant.SettlementType.IsCashSellType': participantSettlementTypeIsCashSellType,
        'Participant.SettlementType.ExtraProperties': participantSettlementTypeExtraProperties,
        'Participant.SettlementType.ConcurrencyStamp': participantSettlementTypeConcurrencyStamp,
        'Participant.ExtraProperties': participantExtraProperties,
        'Participant.ConcurrencyStamp': participantConcurrencyStamp,
        GrantId: grantId,
        'Grant.TenantId': grantTenantId,
        'Grant.CompanyId': grantCompanyId,
        'Grant.UniqueGrantNo': grantUniqueGrantNo,
        'Grant.PlanId': grantPlanId,
        'Grant.PoolId': grantPoolId,
        'Grant.PlanTypeId': grantPlanTypeId,
        'Grant.Name': grantName,
        'Grant.IssueDate': grantIssueDate,
        'Grant.IsEnabled': grantIsEnabled,
        'Grant.ApprovedDate': grantApprovedDate,
        'Grant.VestingTemplateId': grantVestingTemplateId,
        'Grant.PerformanceRuleId': grantPerformanceRuleId,
        'Grant.ApprovalRequired': grantApprovalRequired,
        'Grant.GrantAgreementDocumentId': grantGrantAgreementDocumentId,
        'Grant.GrantNoticeDocumentId': grantGrantNoticeDocumentId,
        'Grant.AgreementStatement': grantAgreementStatement,
        'Grant.AgreementStatementStatus': grantAgreementStatementStatus,
        'Grant.TermsAndConditionDocumentId': grantTermsAndConditionDocumentId,
        'Grant.TermsAndConditionTextId': grantTermsAndConditionTextId,
        'Grant.TerminationRuleSetId': grantTerminationRuleSetId,
        'Grant.SettlementTypeId': grantSettlementTypeId,
        'Grant.Plan.TenantId': grantPlanTenantId,
        'Grant.Plan.UniquePlanNo': grantPlanUniquePlanNo,
        'Grant.Plan.Name': grantPlanName,
        'Grant.Plan.CompanyId': grantPlanCompanyId,
        'Grant.Plan.NumberOfSharesAuthorized': grantPlanNumberOfSharesAuthorized,
        'Grant.Plan.NumberOfSharesAvailable': grantPlanNumberOfSharesAvailable,
        'Grant.Plan.EligibleShareClass': grantPlanEligibleShareClass,
        'Grant.Plan.Description': grantPlanDescription,
        'Grant.Plan.PlanApprovalStatus': grantPlanPlanApprovalStatus,
        'Grant.Plan.IsEnabled': grantPlanIsEnabled,
        'Grant.Plan.PlanEffectiveDate': grantPlanPlanEffectiveDate,
        'Grant.Plan.BoardApprovalDate': grantPlanBoardApprovalDate,
        'Grant.Plan.ShareHolderApprovalDate': grantPlanShareHolderApprovalDate,
        'Grant.Plan.PlanTerm': grantPlanPlanTerm,
        'Grant.Plan.EvergreenPlan': grantPlanEvergreenPlan,
        'Grant.Plan.EvergreenCriteria': grantPlanEvergreenCriteria,
        'Grant.Plan.DeathExpirationOption': grantPlanDeathExpirationOption,
        'Grant.Plan.DisablityExpirationOption': grantPlanDisablityExpirationOption,
        'Grant.Plan.RetirementExpirationOption': grantPlanRetirementExpirationOption,
        'Grant.Plan.VolutaryTerminationOption': grantPlanVolutaryTerminationOption,
        'Grant.Plan.InvolutaryTerminationOption': grantPlanInvolutaryTerminationOption,
        'Grant.Plan.DividendEligibility': grantPlanDividendEligibility,
        'Grant.Plan.OptionExpirationDate': grantPlanOptionExpirationDate,
        'Grant.Plan.NumberOfSharesUnAvailable': grantPlanNumberOfSharesUnAvailable,
        'Grant.Plan.PlanExpiryDate': grantPlanPlanExpiryDate,
        'Grant.Plan.WithACause': grantPlanWithACause,
        'Grant.Plan.TerminationRuleSetId': grantPlanTerminationRuleSetId,
        'Grant.Plan.PoolId': grantPlanPoolId,
        'Grant.Plan.Pool.TenantId': grantPlanPoolTenantId,
        'Grant.Plan.Pool.CompanyId': grantPlanPoolCompanyId,
        'Grant.Plan.Pool.PoolName': grantPlanPoolPoolName,
        'Grant.Plan.Pool.NumberOfSharesAuthorised': grantPlanPoolNumberOfSharesAuthorised,
        'Grant.Plan.Pool.NumberOfSharesAvailable': grantPlanPoolNumberOfSharesAvailable,
        'Grant.Plan.Pool.NumberOfSharesUnAvailable': grantPlanPoolNumberOfSharesUnAvailable,
        'Grant.Plan.Pool.HasExternalPoolRefrence': grantPlanPoolHasExternalPoolRefrence,
        'Grant.Plan.Pool.Description': grantPlanPoolDescription,
        'Grant.Plan.Pool.ExternalPoolName': grantPlanPoolExternalPoolName,
        'Grant.Plan.Pool.ExternalPoolReferenceId': grantPlanPoolExternalPoolReferenceId,
        'Grant.Plan.Pool.Transactions': grantPlanPoolTransactions,
        'Grant.Plan.Pool.RSUAwards': grantPlanPoolRsuAwards,
        'Grant.Plan.Pool.PSUAwards': grantPlanPoolPsuAwards,
        'Grant.Plan.Pool.OptionAwards': grantPlanPoolOptionAwards,
        'Grant.Plan.Pool.Grants': grantPlanPoolGrants,
        'Grant.Plan.Pool.Plans': grantPlanPoolPlans,
        'Grant.Plan.Pool.IsDeleted': grantPlanPoolIsDeleted,
        'Grant.Plan.Pool.DeleterId': grantPlanPoolDeleterId,
        'Grant.Plan.Pool.DeletionTime': grantPlanPoolDeletionTime,
        'Grant.Plan.Pool.LastModificationTime': grantPlanPoolLastModificationTime,
        'Grant.Plan.Pool.LastModifierId': grantPlanPoolLastModifierId,
        'Grant.Plan.Pool.CreationTime': grantPlanPoolCreationTime,
        'Grant.Plan.Pool.CreatorId': grantPlanPoolCreatorId,
        'Grant.Plan.Pool.ExtraProperties': grantPlanPoolExtraProperties,
        'Grant.Plan.Pool.ConcurrencyStamp': grantPlanPoolConcurrencyStamp,
        'Grant.Plan.Pool.Id': grantPlanPoolId,
        'Grant.Plan.AllowEditPlanRelatedDocuments': grantPlanAllowEditPlanRelatedDocuments,
        'Grant.Plan.PlanDocuments': grantPlanPlanDocuments,
        'Grant.Plan.RSUAwards': grantPlanRsuAwards,
        'Grant.Plan.PSUAwards': grantPlanPsuAwards,
        'Grant.Plan.Grants': grantPlanGrants,
        'Grant.Plan.OptionAwards': grantPlanOptionAwards,
        'Grant.Plan.TradePreClearanceRequests': grantPlanTradePreClearanceRequests,
        'Grant.Plan.EsppOfferingPeriods': grantPlanEsppOfferingPeriods,
        'Grant.Plan.PlanApprovals': grantPlanPlanApprovals,
        'Grant.Plan.PlanPlanTypeCategories': grantPlanPlanPlanTypeCategories,
        'Grant.Plan.TerminationRuleSet.Id': grantPlanTerminationRuleSetId,
        'Grant.Plan.TerminationRuleSet.TenantId': grantPlanTerminationRuleSetTenantId,
        'Grant.Plan.TerminationRuleSet.ExtraProperties': grantPlanTerminationRuleSetExtraProperties,
        'Grant.Plan.TerminationRuleSet.ConcurrencyStamp':
          grantPlanTerminationRuleSetConcurrencyStamp,
        'Grant.Plan.IsDeleted': grantPlanIsDeleted,
        'Grant.Plan.DeleterId': grantPlanDeleterId,
        'Grant.Plan.DeletionTime': grantPlanDeletionTime,
        'Grant.Plan.LastModificationTime': grantPlanLastModificationTime,
        'Grant.Plan.LastModifierId': grantPlanLastModifierId,
        'Grant.Plan.CreationTime': grantPlanCreationTime,
        'Grant.Plan.CreatorId': grantPlanCreatorId,
        'Grant.Plan.ExtraProperties': grantPlanExtraProperties,
        'Grant.Plan.ConcurrencyStamp': grantPlanConcurrencyStamp,
        'Grant.Plan.Id': grantPlanId,
        'Grant.Pool.TenantId': grantPoolTenantId,
        'Grant.Pool.CompanyId': grantPoolCompanyId,
        'Grant.Pool.PoolName': grantPoolPoolName,
        'Grant.Pool.NumberOfSharesAuthorised': grantPoolNumberOfSharesAuthorised,
        'Grant.Pool.NumberOfSharesAvailable': grantPoolNumberOfSharesAvailable,
        'Grant.Pool.NumberOfSharesUnAvailable': grantPoolNumberOfSharesUnAvailable,
        'Grant.Pool.HasExternalPoolRefrence': grantPoolHasExternalPoolRefrence,
        'Grant.Pool.Description': grantPoolDescription,
        'Grant.Pool.ExternalPoolName': grantPoolExternalPoolName,
        'Grant.Pool.ExternalPoolReferenceId': grantPoolExternalPoolReferenceId,
        'Grant.Pool.Transactions': grantPoolTransactions,
        'Grant.Pool.RSUAwards': grantPoolRsuAwards,
        'Grant.Pool.PSUAwards': grantPoolPsuAwards,
        'Grant.Pool.OptionAwards': grantPoolOptionAwards,
        'Grant.Pool.Grants': grantPoolGrants,
        'Grant.Pool.Plans': grantPoolPlans,
        'Grant.Pool.IsDeleted': grantPoolIsDeleted,
        'Grant.Pool.DeleterId': grantPoolDeleterId,
        'Grant.Pool.DeletionTime': grantPoolDeletionTime,
        'Grant.Pool.LastModificationTime': grantPoolLastModificationTime,
        'Grant.Pool.LastModifierId': grantPoolLastModifierId,
        'Grant.Pool.CreationTime': grantPoolCreationTime,
        'Grant.Pool.CreatorId': grantPoolCreatorId,
        'Grant.Pool.ExtraProperties': grantPoolExtraProperties,
        'Grant.Pool.ConcurrencyStamp': grantPoolConcurrencyStamp,
        'Grant.Pool.Id': grantPoolId,
        'Grant.PlanType.Id': grantPlanTypeId,
        'Grant.PlanType.Name': grantPlanTypeName,
        'Grant.PlanType.IsEnabled': grantPlanTypeIsEnabled,
        'Grant.PlanType.PlanTypeCategoryId': grantPlanTypePlanTypeCategoryId,
        'Grant.PlanType.PlanTypeCategory.Id': grantPlanTypePlanTypeCategoryId,
        'Grant.PlanType.PlanTypeCategory.Name': grantPlanTypePlanTypeCategoryName,
        'Grant.PlanType.PlanTypeCategory.IsEnabled': grantPlanTypePlanTypeCategoryIsEnabled,
        'Grant.PlanType.PlanTypeCategory.ElectionWindowConfigurations':
          grantPlanTypePlanTypeCategoryElectionWindowConfigurations,
        'Grant.PlanType.PlanTypeCategory.DefaultSettlementConfigurations':
          grantPlanTypePlanTypeCategoryDefaultSettlementConfigurations,
        'Grant.PlanType.PlanTypeCategory.PlanPlanTypeCategories':
          grantPlanTypePlanTypeCategoryPlanPlanTypeCategories,
        'Grant.PlanType.PlanTypeCategory.ExtraProperties':
          grantPlanTypePlanTypeCategoryExtraProperties,
        'Grant.PlanType.PlanTypeCategory.ConcurrencyStamp':
          grantPlanTypePlanTypeCategoryConcurrencyStamp,
        'Grant.PlanType.OptionAwards': grantPlanTypeOptionAwards,
        'Grant.PlanType.ExtraProperties': grantPlanTypeExtraProperties,
        'Grant.PlanType.ConcurrencyStamp': grantPlanTypeConcurrencyStamp,
        'Grant.Company.Id': grantCompanyId,
        'Grant.Company.TenantId': grantCompanyTenantId,
        'Grant.Company.Name': grantCompanyName,
        'Grant.Company.IsEnabled': grantCompanyIsEnabled,
        'Grant.Company.CreatorId': grantCompanyCreatorId,
        'Grant.Company.CreationTime': grantCompanyCreationTime,
        'Grant.Company.LastModifierId': grantCompanyLastModifierId,
        'Grant.Company.LastModificationTime': grantCompanyLastModificationTime,
        'Grant.Company.IsDeleted': grantCompanyIsDeleted,
        'Grant.Company.DeleterId': grantCompanyDeleterId,
        'Grant.Company.DeletionTime': grantCompanyDeletionTime,
        'Grant.Company.Ticker': grantCompanyTicker,
        'Grant.Company.IsoCalculationSortingTypeId': grantCompanyIsoCalculationSortingTypeId,
        'Grant.Company.IsoCalculationSortingType.Id': grantCompanyIsoCalculationSortingTypeId,
        'Grant.Company.IsoCalculationSortingType.SystemName':
          grantCompanyIsoCalculationSortingTypeSystemName,
        'Grant.Company.IsoCalculationSortingType.DisplayName':
          grantCompanyIsoCalculationSortingTypeDisplayName,
        'Grant.Company.IsoCalculationSortingType.ExtraProperties':
          grantCompanyIsoCalculationSortingTypeExtraProperties,
        'Grant.Company.IsoCalculationSortingType.ConcurrencyStamp':
          grantCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'Grant.Company.IsEmailEnableToParticipant': grantCompanyIsEmailEnableToParticipant,
        'Grant.Company.CommissionId': grantCompanyCommissionId,
        'Grant.Company.DtcParticipantId': grantCompanyDtcParticipantId,
        'Grant.Company.IntendedShareRegistrationTypeId':
          grantCompanyIntendedShareRegistrationTypeId,
        'Grant.Company.IntendedShareRegistrationType.SystemName':
          grantCompanyIntendedShareRegistrationTypeSystemName,
        'Grant.Company.IntendedShareRegistrationType.DisplayName':
          grantCompanyIntendedShareRegistrationTypeDisplayName,
        'Grant.Company.IntendedShareRegistrationType.LastModificationTime':
          grantCompanyIntendedShareRegistrationTypeLastModificationTime,
        'Grant.Company.IntendedShareRegistrationType.LastModifierId':
          grantCompanyIntendedShareRegistrationTypeLastModifierId,
        'Grant.Company.IntendedShareRegistrationType.CreationTime':
          grantCompanyIntendedShareRegistrationTypeCreationTime,
        'Grant.Company.IntendedShareRegistrationType.CreatorId':
          grantCompanyIntendedShareRegistrationTypeCreatorId,
        'Grant.Company.IntendedShareRegistrationType.ExtraProperties':
          grantCompanyIntendedShareRegistrationTypeExtraProperties,
        'Grant.Company.IntendedShareRegistrationType.ConcurrencyStamp':
          grantCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'Grant.Company.IntendedShareRegistrationType.Id':
          grantCompanyIntendedShareRegistrationTypeId,
        'Grant.Company.TransactionAcquisitionTypeId': grantCompanyTransactionAcquisitionTypeId,
        'Grant.Company.TransactionAcquisitionType.SystemName':
          grantCompanyTransactionAcquisitionTypeSystemName,
        'Grant.Company.TransactionAcquisitionType.DisplayName':
          grantCompanyTransactionAcquisitionTypeDisplayName,
        'Grant.Company.TransactionAcquisitionType.LastModificationTime':
          grantCompanyTransactionAcquisitionTypeLastModificationTime,
        'Grant.Company.TransactionAcquisitionType.LastModifierId':
          grantCompanyTransactionAcquisitionTypeLastModifierId,
        'Grant.Company.TransactionAcquisitionType.CreationTime':
          grantCompanyTransactionAcquisitionTypeCreationTime,
        'Grant.Company.TransactionAcquisitionType.CreatorId':
          grantCompanyTransactionAcquisitionTypeCreatorId,
        'Grant.Company.TransactionAcquisitionType.ExtraProperties':
          grantCompanyTransactionAcquisitionTypeExtraProperties,
        'Grant.Company.TransactionAcquisitionType.ConcurrencyStamp':
          grantCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'Grant.Company.TransactionAcquisitionType.Id': grantCompanyTransactionAcquisitionTypeId,
        'Grant.Company.PriceThreshold': grantCompanyPriceThreshold,
        'Grant.Company.IsPartBRequired': grantCompanyIsPartBRequired,
        'Grant.Company.IsPartCRequired': grantCompanyIsPartCRequired,
        'Grant.Company.Commission.OwningCompanyId': grantCompanyCommissionOwningCompanyId,
        'Grant.Company.Commission.OwningCompany.Id': grantCompanyCommissionOwningCompanyId,
        'Grant.Company.Commission.OwningCompany.TenantId':
          grantCompanyCommissionOwningCompanyTenantId,
        'Grant.Company.Commission.OwningCompany.Name': grantCompanyCommissionOwningCompanyName,
        'Grant.Company.Commission.OwningCompany.IsEnabled':
          grantCompanyCommissionOwningCompanyIsEnabled,
        'Grant.Company.Commission.OwningCompany.CreatorId':
          grantCompanyCommissionOwningCompanyCreatorId,
        'Grant.Company.Commission.OwningCompany.CreationTime':
          grantCompanyCommissionOwningCompanyCreationTime,
        'Grant.Company.Commission.OwningCompany.LastModifierId':
          grantCompanyCommissionOwningCompanyLastModifierId,
        'Grant.Company.Commission.OwningCompany.LastModificationTime':
          grantCompanyCommissionOwningCompanyLastModificationTime,
        'Grant.Company.Commission.OwningCompany.IsDeleted':
          grantCompanyCommissionOwningCompanyIsDeleted,
        'Grant.Company.Commission.OwningCompany.DeleterId':
          grantCompanyCommissionOwningCompanyDeleterId,
        'Grant.Company.Commission.OwningCompany.DeletionTime':
          grantCompanyCommissionOwningCompanyDeletionTime,
        'Grant.Company.Commission.OwningCompany.Ticker': grantCompanyCommissionOwningCompanyTicker,
        'Grant.Company.Commission.OwningCompany.IsoCalculationSortingTypeId':
          grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeId,
        'Grant.Company.Commission.OwningCompany.IsoCalculationSortingType.Id':
          grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeId,
        'Grant.Company.Commission.OwningCompany.IsoCalculationSortingType.SystemName':
          grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName,
        'Grant.Company.Commission.OwningCompany.IsoCalculationSortingType.DisplayName':
          grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName,
        'Grant.Company.Commission.OwningCompany.IsoCalculationSortingType.ExtraProperties':
          grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties,
        'Grant.Company.Commission.OwningCompany.IsoCalculationSortingType.ConcurrencyStamp':
          grantCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'Grant.Company.Commission.OwningCompany.IsEmailEnableToParticipant':
          grantCompanyCommissionOwningCompanyIsEmailEnableToParticipant,
        'Grant.Company.Commission.OwningCompany.CommissionId':
          grantCompanyCommissionOwningCompanyCommissionId,
        'Grant.Company.Commission.OwningCompany.DtcParticipantId':
          grantCompanyCommissionOwningCompanyDtcParticipantId,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationTypeId':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.SystemName':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.DisplayName':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.LastModificationTime':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.LastModifierId':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.CreationTime':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.CreatorId':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.ExtraProperties':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.ConcurrencyStamp':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'Grant.Company.Commission.OwningCompany.IntendedShareRegistrationType.Id':
          grantCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionTypeId':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeId,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.SystemName':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.DisplayName':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.LastModificationTime':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.LastModifierId':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.CreationTime':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.CreatorId':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.ExtraProperties':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.ConcurrencyStamp':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'Grant.Company.Commission.OwningCompany.TransactionAcquisitionType.Id':
          grantCompanyCommissionOwningCompanyTransactionAcquisitionTypeId,
        'Grant.Company.Commission.OwningCompany.PriceThreshold':
          grantCompanyCommissionOwningCompanyPriceThreshold,
        'Grant.Company.Commission.OwningCompany.IsPartBRequired':
          grantCompanyCommissionOwningCompanyIsPartBRequired,
        'Grant.Company.Commission.OwningCompany.IsPartCRequired':
          grantCompanyCommissionOwningCompanyIsPartCRequired,
        'Grant.Company.Commission.OwningCompany.Commission':
          grantCompanyCommissionOwningCompanyCommission,
        'Grant.Company.Commission.OwningCompany.CustomerApprovalProcesses':
          grantCompanyCommissionOwningCompanyCustomerApprovalProcesses,
        'Grant.Company.Commission.OwningCompany.VestingTemplates':
          grantCompanyCommissionOwningCompanyVestingTemplates,
        'Grant.Company.Commission.OwningCompany.RSUAward':
          grantCompanyCommissionOwningCompanyRsuAward,
        'Grant.Company.Commission.OwningCompany.OwnedCommissions':
          grantCompanyCommissionOwningCompanyOwnedCommissions,
        'Grant.Company.Commission.OwningCompany.BrokeredCommissions':
          grantCompanyCommissionOwningCompanyBrokeredCommissions,
        'Grant.Company.Commission.OwningCompany.CommissionSchedules':
          grantCompanyCommissionOwningCompanyCommissionSchedules,
        'Grant.Company.Commission.OwningCompany.RSUAwardVestingDate':
          grantCompanyCommissionOwningCompanyRsuAwardVestingDate,
        'Grant.Company.Commission.OwningCompany.ElectionWindowConfigurations':
          grantCompanyCommissionOwningCompanyElectionWindowConfigurations,
        'Grant.Company.Commission.OwningCompany.OptionAwards':
          grantCompanyCommissionOwningCompanyOptionAwards,
        'Grant.Company.Commission.OwningCompany.TradePreClearanceRequests':
          grantCompanyCommissionOwningCompanyTradePreClearanceRequests,
        'Grant.Company.Commission.OwningCompany.TradePreClearanceParticipantAwards':
          grantCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards,
        'Grant.Company.Commission.OwningCompany.PSUAward':
          grantCompanyCommissionOwningCompanyPsuAward,
        'Grant.Company.Commission.OwningCompany.PSUAwardVestingDate':
          grantCompanyCommissionOwningCompanyPsuAwardVestingDate,
        'Grant.Company.Commission.OwningCompany.ExtraProperties':
          grantCompanyCommissionOwningCompanyExtraProperties,
        'Grant.Company.Commission.OwningCompany.ConcurrencyStamp':
          grantCompanyCommissionOwningCompanyConcurrencyStamp,
        'Grant.Company.Commission.BrokerCompanyId': grantCompanyCommissionBrokerCompanyId,
        'Grant.Company.Commission.BrokerCompany.Id': grantCompanyCommissionBrokerCompanyId,
        'Grant.Company.Commission.BrokerCompany.TenantId':
          grantCompanyCommissionBrokerCompanyTenantId,
        'Grant.Company.Commission.BrokerCompany.Name': grantCompanyCommissionBrokerCompanyName,
        'Grant.Company.Commission.BrokerCompany.IsEnabled':
          grantCompanyCommissionBrokerCompanyIsEnabled,
        'Grant.Company.Commission.BrokerCompany.CreatorId':
          grantCompanyCommissionBrokerCompanyCreatorId,
        'Grant.Company.Commission.BrokerCompany.CreationTime':
          grantCompanyCommissionBrokerCompanyCreationTime,
        'Grant.Company.Commission.BrokerCompany.LastModifierId':
          grantCompanyCommissionBrokerCompanyLastModifierId,
        'Grant.Company.Commission.BrokerCompany.LastModificationTime':
          grantCompanyCommissionBrokerCompanyLastModificationTime,
        'Grant.Company.Commission.BrokerCompany.IsDeleted':
          grantCompanyCommissionBrokerCompanyIsDeleted,
        'Grant.Company.Commission.BrokerCompany.DeleterId':
          grantCompanyCommissionBrokerCompanyDeleterId,
        'Grant.Company.Commission.BrokerCompany.DeletionTime':
          grantCompanyCommissionBrokerCompanyDeletionTime,
        'Grant.Company.Commission.BrokerCompany.Ticker': grantCompanyCommissionBrokerCompanyTicker,
        'Grant.Company.Commission.BrokerCompany.IsoCalculationSortingTypeId':
          grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId,
        'Grant.Company.Commission.BrokerCompany.IsoCalculationSortingType.Id':
          grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId,
        'Grant.Company.Commission.BrokerCompany.IsoCalculationSortingType.SystemName':
          grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName,
        'Grant.Company.Commission.BrokerCompany.IsoCalculationSortingType.DisplayName':
          grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName,
        'Grant.Company.Commission.BrokerCompany.IsoCalculationSortingType.ExtraProperties':
          grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties,
        'Grant.Company.Commission.BrokerCompany.IsoCalculationSortingType.ConcurrencyStamp':
          grantCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'Grant.Company.Commission.BrokerCompany.IsEmailEnableToParticipant':
          grantCompanyCommissionBrokerCompanyIsEmailEnableToParticipant,
        'Grant.Company.Commission.BrokerCompany.CommissionId':
          grantCompanyCommissionBrokerCompanyCommissionId,
        'Grant.Company.Commission.BrokerCompany.DtcParticipantId':
          grantCompanyCommissionBrokerCompanyDtcParticipantId,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationTypeId':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.SystemName':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.DisplayName':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.LastModificationTime':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.LastModifierId':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.CreationTime':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.CreatorId':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.ExtraProperties':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.ConcurrencyStamp':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'Grant.Company.Commission.BrokerCompany.IntendedShareRegistrationType.Id':
          grantCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionTypeId':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.SystemName':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.DisplayName':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.LastModificationTime':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.LastModifierId':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.CreationTime':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.CreatorId':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.ExtraProperties':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.ConcurrencyStamp':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'Grant.Company.Commission.BrokerCompany.TransactionAcquisitionType.Id':
          grantCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId,
        'Grant.Company.Commission.BrokerCompany.PriceThreshold':
          grantCompanyCommissionBrokerCompanyPriceThreshold,
        'Grant.Company.Commission.BrokerCompany.IsPartBRequired':
          grantCompanyCommissionBrokerCompanyIsPartBRequired,
        'Grant.Company.Commission.BrokerCompany.IsPartCRequired':
          grantCompanyCommissionBrokerCompanyIsPartCRequired,
        'Grant.Company.Commission.BrokerCompany.Commission':
          grantCompanyCommissionBrokerCompanyCommission,
        'Grant.Company.Commission.BrokerCompany.CustomerApprovalProcesses':
          grantCompanyCommissionBrokerCompanyCustomerApprovalProcesses,
        'Grant.Company.Commission.BrokerCompany.VestingTemplates':
          grantCompanyCommissionBrokerCompanyVestingTemplates,
        'Grant.Company.Commission.BrokerCompany.RSUAward':
          grantCompanyCommissionBrokerCompanyRsuAward,
        'Grant.Company.Commission.BrokerCompany.OwnedCommissions':
          grantCompanyCommissionBrokerCompanyOwnedCommissions,
        'Grant.Company.Commission.BrokerCompany.BrokeredCommissions':
          grantCompanyCommissionBrokerCompanyBrokeredCommissions,
        'Grant.Company.Commission.BrokerCompany.CommissionSchedules':
          grantCompanyCommissionBrokerCompanyCommissionSchedules,
        'Grant.Company.Commission.BrokerCompany.RSUAwardVestingDate':
          grantCompanyCommissionBrokerCompanyRsuAwardVestingDate,
        'Grant.Company.Commission.BrokerCompany.ElectionWindowConfigurations':
          grantCompanyCommissionBrokerCompanyElectionWindowConfigurations,
        'Grant.Company.Commission.BrokerCompany.OptionAwards':
          grantCompanyCommissionBrokerCompanyOptionAwards,
        'Grant.Company.Commission.BrokerCompany.TradePreClearanceRequests':
          grantCompanyCommissionBrokerCompanyTradePreClearanceRequests,
        'Grant.Company.Commission.BrokerCompany.TradePreClearanceParticipantAwards':
          grantCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards,
        'Grant.Company.Commission.BrokerCompany.PSUAward':
          grantCompanyCommissionBrokerCompanyPsuAward,
        'Grant.Company.Commission.BrokerCompany.PSUAwardVestingDate':
          grantCompanyCommissionBrokerCompanyPsuAwardVestingDate,
        'Grant.Company.Commission.BrokerCompany.ExtraProperties':
          grantCompanyCommissionBrokerCompanyExtraProperties,
        'Grant.Company.Commission.BrokerCompany.ConcurrencyStamp':
          grantCompanyCommissionBrokerCompanyConcurrencyStamp,
        'Grant.Company.Commission.Name': grantCompanyCommissionName,
        'Grant.Company.Commission.Description': grantCompanyCommissionDescription,
        'Grant.Company.Commission.BaseRate': grantCompanyCommissionBaseRate,
        'Grant.Company.Commission.MaxAmount': grantCompanyCommissionMaxAmount,
        'Grant.Company.Commission.CommissionSchedules': grantCompanyCommissionCommissionSchedules,
        'Grant.Company.Commission.Company': grantCompanyCommissionCompany,
        'Grant.Company.Commission.IsDeleted': grantCompanyCommissionIsDeleted,
        'Grant.Company.Commission.DeleterId': grantCompanyCommissionDeleterId,
        'Grant.Company.Commission.DeletionTime': grantCompanyCommissionDeletionTime,
        'Grant.Company.Commission.LastModificationTime': grantCompanyCommissionLastModificationTime,
        'Grant.Company.Commission.LastModifierId': grantCompanyCommissionLastModifierId,
        'Grant.Company.Commission.CreationTime': grantCompanyCommissionCreationTime,
        'Grant.Company.Commission.CreatorId': grantCompanyCommissionCreatorId,
        'Grant.Company.Commission.Id': grantCompanyCommissionId,
        'Grant.Company.CustomerApprovalProcesses': grantCompanyCustomerApprovalProcesses,
        'Grant.Company.VestingTemplates': grantCompanyVestingTemplates,
        'Grant.Company.RSUAward': grantCompanyRsuAward,
        'Grant.Company.OwnedCommissions': grantCompanyOwnedCommissions,
        'Grant.Company.BrokeredCommissions': grantCompanyBrokeredCommissions,
        'Grant.Company.CommissionSchedules': grantCompanyCommissionSchedules,
        'Grant.Company.RSUAwardVestingDate': grantCompanyRsuAwardVestingDate,
        'Grant.Company.ElectionWindowConfigurations': grantCompanyElectionWindowConfigurations,
        'Grant.Company.OptionAwards': grantCompanyOptionAwards,
        'Grant.Company.TradePreClearanceRequests': grantCompanyTradePreClearanceRequests,
        'Grant.Company.TradePreClearanceParticipantAwards':
          grantCompanyTradePreClearanceParticipantAwards,
        'Grant.Company.PSUAward': grantCompanyPsuAward,
        'Grant.Company.PSUAwardVestingDate': grantCompanyPsuAwardVestingDate,
        'Grant.Company.ExtraProperties': grantCompanyExtraProperties,
        'Grant.Company.ConcurrencyStamp': grantCompanyConcurrencyStamp,
        'Grant.VestingTemplate.TenantId': grantVestingTemplateTenantId,
        'Grant.VestingTemplate.CompanyId': grantVestingTemplateCompanyId,
        'Grant.VestingTemplate.Name': grantVestingTemplateName,
        'Grant.VestingTemplate.Summary': grantVestingTemplateSummary,
        'Grant.VestingTemplate.VestingTypeId': grantVestingTemplateVestingTypeId,
        'Grant.VestingTemplate.LengthInMonths': grantVestingTemplateLengthInMonths,
        'Grant.VestingTemplate.AmountOneInPercentage': grantVestingTemplateAmountOneInPercentage,
        'Grant.VestingTemplate.VestsAfterInMonths': grantVestingTemplateVestsAfterInMonths,
        'Grant.VestingTemplate.AmountTwoInPercentage': grantVestingTemplateAmountTwoInPercentage,
        'Grant.VestingTemplate.VestsInMonths': grantVestingTemplateVestsInMonths,
        'Grant.VestingTemplate.IntervalInMonths': grantVestingTemplateIntervalInMonths,
        'Grant.VestingTemplate.IsEnabled': grantVestingTemplateIsEnabled,
        'Grant.VestingTemplate.IsDefaultVestingTemplate':
          grantVestingTemplateIsDefaultVestingTemplate,
        'Grant.VestingTemplate.PeriodStartDate': grantVestingTemplatePeriodStartDate,
        'Grant.VestingTemplate.RoundingTypeId': grantVestingTemplateRoundingTypeId,
        'Grant.VestingTemplate.FractionalDecimalDigit': grantVestingTemplateFractionalDecimalDigit,
        'Grant.VestingTemplate.VestAtEndOfMonth': grantVestingTemplateVestAtEndOfMonth,
        'Grant.VestingTemplate.SpecificVestingInstruction':
          grantVestingTemplateSpecificVestingInstruction,
        'Grant.VestingTemplate.LoadingTypeId': grantVestingTemplateLoadingTypeId,
        'Grant.VestingTemplate.EndOfTheMonthTypeId': grantVestingTemplateEndOfTheMonthTypeId,
        'Grant.VestingTemplate.Company.Id': grantVestingTemplateCompanyId,
        'Grant.VestingTemplate.Company.TenantId': grantVestingTemplateCompanyTenantId,
        'Grant.VestingTemplate.Company.Name': grantVestingTemplateCompanyName,
        'Grant.VestingTemplate.Company.IsEnabled': grantVestingTemplateCompanyIsEnabled,
        'Grant.VestingTemplate.Company.CreatorId': grantVestingTemplateCompanyCreatorId,
        'Grant.VestingTemplate.Company.CreationTime': grantVestingTemplateCompanyCreationTime,
        'Grant.VestingTemplate.Company.LastModifierId': grantVestingTemplateCompanyLastModifierId,
        'Grant.VestingTemplate.Company.LastModificationTime':
          grantVestingTemplateCompanyLastModificationTime,
        'Grant.VestingTemplate.Company.IsDeleted': grantVestingTemplateCompanyIsDeleted,
        'Grant.VestingTemplate.Company.DeleterId': grantVestingTemplateCompanyDeleterId,
        'Grant.VestingTemplate.Company.DeletionTime': grantVestingTemplateCompanyDeletionTime,
        'Grant.VestingTemplate.Company.Ticker': grantVestingTemplateCompanyTicker,
        'Grant.VestingTemplate.Company.IsoCalculationSortingTypeId':
          grantVestingTemplateCompanyIsoCalculationSortingTypeId,
        'Grant.VestingTemplate.Company.IsoCalculationSortingType.Id':
          grantVestingTemplateCompanyIsoCalculationSortingTypeId,
        'Grant.VestingTemplate.Company.IsoCalculationSortingType.SystemName':
          grantVestingTemplateCompanyIsoCalculationSortingTypeSystemName,
        'Grant.VestingTemplate.Company.IsoCalculationSortingType.DisplayName':
          grantVestingTemplateCompanyIsoCalculationSortingTypeDisplayName,
        'Grant.VestingTemplate.Company.IsoCalculationSortingType.ExtraProperties':
          grantVestingTemplateCompanyIsoCalculationSortingTypeExtraProperties,
        'Grant.VestingTemplate.Company.IsoCalculationSortingType.ConcurrencyStamp':
          grantVestingTemplateCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.IsEmailEnableToParticipant':
          grantVestingTemplateCompanyIsEmailEnableToParticipant,
        'Grant.VestingTemplate.Company.CommissionId': grantVestingTemplateCompanyCommissionId,
        'Grant.VestingTemplate.Company.DtcParticipantId':
          grantVestingTemplateCompanyDtcParticipantId,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationTypeId':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeId,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.SystemName':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeSystemName,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.DisplayName':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeDisplayName,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.LastModificationTime':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeLastModificationTime,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.LastModifierId':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeLastModifierId,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.CreationTime':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeCreationTime,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.CreatorId':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeCreatorId,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.ExtraProperties':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeExtraProperties,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.ConcurrencyStamp':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.IntendedShareRegistrationType.Id':
          grantVestingTemplateCompanyIntendedShareRegistrationTypeId,
        'Grant.VestingTemplate.Company.TransactionAcquisitionTypeId':
          grantVestingTemplateCompanyTransactionAcquisitionTypeId,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.SystemName':
          grantVestingTemplateCompanyTransactionAcquisitionTypeSystemName,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.DisplayName':
          grantVestingTemplateCompanyTransactionAcquisitionTypeDisplayName,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.LastModificationTime':
          grantVestingTemplateCompanyTransactionAcquisitionTypeLastModificationTime,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.LastModifierId':
          grantVestingTemplateCompanyTransactionAcquisitionTypeLastModifierId,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.CreationTime':
          grantVestingTemplateCompanyTransactionAcquisitionTypeCreationTime,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.CreatorId':
          grantVestingTemplateCompanyTransactionAcquisitionTypeCreatorId,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.ExtraProperties':
          grantVestingTemplateCompanyTransactionAcquisitionTypeExtraProperties,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.ConcurrencyStamp':
          grantVestingTemplateCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.TransactionAcquisitionType.Id':
          grantVestingTemplateCompanyTransactionAcquisitionTypeId,
        'Grant.VestingTemplate.Company.PriceThreshold': grantVestingTemplateCompanyPriceThreshold,
        'Grant.VestingTemplate.Company.IsPartBRequired': grantVestingTemplateCompanyIsPartBRequired,
        'Grant.VestingTemplate.Company.IsPartCRequired': grantVestingTemplateCompanyIsPartCRequired,
        'Grant.VestingTemplate.Company.Commission.OwningCompanyId':
          grantVestingTemplateCompanyCommissionOwningCompanyId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.Id':
          grantVestingTemplateCompanyCommissionOwningCompanyId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TenantId':
          grantVestingTemplateCompanyCommissionOwningCompanyTenantId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.Name':
          grantVestingTemplateCompanyCommissionOwningCompanyName,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsEnabled':
          grantVestingTemplateCompanyCommissionOwningCompanyIsEnabled,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.CreatorId':
          grantVestingTemplateCompanyCommissionOwningCompanyCreatorId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.CreationTime':
          grantVestingTemplateCompanyCommissionOwningCompanyCreationTime,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.LastModifierId':
          grantVestingTemplateCompanyCommissionOwningCompanyLastModifierId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.LastModificationTime':
          grantVestingTemplateCompanyCommissionOwningCompanyLastModificationTime,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsDeleted':
          grantVestingTemplateCompanyCommissionOwningCompanyIsDeleted,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.DeleterId':
          grantVestingTemplateCompanyCommissionOwningCompanyDeleterId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.DeletionTime':
          grantVestingTemplateCompanyCommissionOwningCompanyDeletionTime,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.Ticker':
          grantVestingTemplateCompanyCommissionOwningCompanyTicker,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingTypeId':
          grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.Id':
          grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.SystemName':
          grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.DisplayName':
          grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.ExtraProperties':
          grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.ConcurrencyStamp':
          grantVestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsEmailEnableToParticipant':
          grantVestingTemplateCompanyCommissionOwningCompanyIsEmailEnableToParticipant,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.CommissionId':
          grantVestingTemplateCompanyCommissionOwningCompanyCommissionId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.DtcParticipantId':
          grantVestingTemplateCompanyCommissionOwningCompanyDtcParticipantId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationTypeId':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.SystemName':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.DisplayName':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.LastModificationTime':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.LastModifierId':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.CreationTime':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.CreatorId':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.ExtraProperties':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.ConcurrencyStamp':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.Id':
          grantVestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionTypeId':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.SystemName':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.DisplayName':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.LastModificationTime':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.LastModifierId':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.CreationTime':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.CreatorId':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.ExtraProperties':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.ConcurrencyStamp':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.Id':
          grantVestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.PriceThreshold':
          grantVestingTemplateCompanyCommissionOwningCompanyPriceThreshold,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsPartBRequired':
          grantVestingTemplateCompanyCommissionOwningCompanyIsPartBRequired,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.IsPartCRequired':
          grantVestingTemplateCompanyCommissionOwningCompanyIsPartCRequired,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.Commission':
          grantVestingTemplateCompanyCommissionOwningCompanyCommission,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.CustomerApprovalProcesses':
          grantVestingTemplateCompanyCommissionOwningCompanyCustomerApprovalProcesses,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.VestingTemplates':
          grantVestingTemplateCompanyCommissionOwningCompanyVestingTemplates,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.RSUAward':
          grantVestingTemplateCompanyCommissionOwningCompanyRsuAward,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.OwnedCommissions':
          grantVestingTemplateCompanyCommissionOwningCompanyOwnedCommissions,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.BrokeredCommissions':
          grantVestingTemplateCompanyCommissionOwningCompanyBrokeredCommissions,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.CommissionSchedules':
          grantVestingTemplateCompanyCommissionOwningCompanyCommissionSchedules,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.RSUAwardVestingDate':
          grantVestingTemplateCompanyCommissionOwningCompanyRsuAwardVestingDate,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.ElectionWindowConfigurations':
          grantVestingTemplateCompanyCommissionOwningCompanyElectionWindowConfigurations,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.OptionAwards':
          grantVestingTemplateCompanyCommissionOwningCompanyOptionAwards,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TradePreClearanceRequests':
          grantVestingTemplateCompanyCommissionOwningCompanyTradePreClearanceRequests,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.TradePreClearanceParticipantAwards':
          grantVestingTemplateCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.PSUAward':
          grantVestingTemplateCompanyCommissionOwningCompanyPsuAward,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.PSUAwardVestingDate':
          grantVestingTemplateCompanyCommissionOwningCompanyPsuAwardVestingDate,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.ExtraProperties':
          grantVestingTemplateCompanyCommissionOwningCompanyExtraProperties,
        'Grant.VestingTemplate.Company.Commission.OwningCompany.ConcurrencyStamp':
          grantVestingTemplateCompanyCommissionOwningCompanyConcurrencyStamp,
        'Grant.VestingTemplate.Company.Commission.BrokerCompanyId':
          grantVestingTemplateCompanyCommissionBrokerCompanyId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.Id':
          grantVestingTemplateCompanyCommissionBrokerCompanyId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TenantId':
          grantVestingTemplateCompanyCommissionBrokerCompanyTenantId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.Name':
          grantVestingTemplateCompanyCommissionBrokerCompanyName,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsEnabled':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsEnabled,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.CreatorId':
          grantVestingTemplateCompanyCommissionBrokerCompanyCreatorId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.CreationTime':
          grantVestingTemplateCompanyCommissionBrokerCompanyCreationTime,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.LastModifierId':
          grantVestingTemplateCompanyCommissionBrokerCompanyLastModifierId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.LastModificationTime':
          grantVestingTemplateCompanyCommissionBrokerCompanyLastModificationTime,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsDeleted':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsDeleted,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.DeleterId':
          grantVestingTemplateCompanyCommissionBrokerCompanyDeleterId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.DeletionTime':
          grantVestingTemplateCompanyCommissionBrokerCompanyDeletionTime,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.Ticker':
          grantVestingTemplateCompanyCommissionBrokerCompanyTicker,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingTypeId':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.Id':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.SystemName':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.DisplayName':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.ExtraProperties':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.ConcurrencyStamp':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsEmailEnableToParticipant':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsEmailEnableToParticipant,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.CommissionId':
          grantVestingTemplateCompanyCommissionBrokerCompanyCommissionId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.DtcParticipantId':
          grantVestingTemplateCompanyCommissionBrokerCompanyDtcParticipantId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationTypeId':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.SystemName':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.DisplayName':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.LastModificationTime':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.LastModifierId':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.CreationTime':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.CreatorId':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.ExtraProperties':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.ConcurrencyStamp':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.Id':
          grantVestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionTypeId':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.SystemName':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.DisplayName':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.LastModificationTime':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.LastModifierId':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.CreationTime':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.CreatorId':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.ExtraProperties':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.ConcurrencyStamp':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.Id':
          grantVestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.PriceThreshold':
          grantVestingTemplateCompanyCommissionBrokerCompanyPriceThreshold,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsPartBRequired':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsPartBRequired,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.IsPartCRequired':
          grantVestingTemplateCompanyCommissionBrokerCompanyIsPartCRequired,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.Commission':
          grantVestingTemplateCompanyCommissionBrokerCompanyCommission,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.CustomerApprovalProcesses':
          grantVestingTemplateCompanyCommissionBrokerCompanyCustomerApprovalProcesses,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.VestingTemplates':
          grantVestingTemplateCompanyCommissionBrokerCompanyVestingTemplates,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.RSUAward':
          grantVestingTemplateCompanyCommissionBrokerCompanyRsuAward,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.OwnedCommissions':
          grantVestingTemplateCompanyCommissionBrokerCompanyOwnedCommissions,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.BrokeredCommissions':
          grantVestingTemplateCompanyCommissionBrokerCompanyBrokeredCommissions,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.CommissionSchedules':
          grantVestingTemplateCompanyCommissionBrokerCompanyCommissionSchedules,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.RSUAwardVestingDate':
          grantVestingTemplateCompanyCommissionBrokerCompanyRsuAwardVestingDate,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.ElectionWindowConfigurations':
          grantVestingTemplateCompanyCommissionBrokerCompanyElectionWindowConfigurations,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.OptionAwards':
          grantVestingTemplateCompanyCommissionBrokerCompanyOptionAwards,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TradePreClearanceRequests':
          grantVestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceRequests,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.TradePreClearanceParticipantAwards':
          grantVestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.PSUAward':
          grantVestingTemplateCompanyCommissionBrokerCompanyPsuAward,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.PSUAwardVestingDate':
          grantVestingTemplateCompanyCommissionBrokerCompanyPsuAwardVestingDate,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.ExtraProperties':
          grantVestingTemplateCompanyCommissionBrokerCompanyExtraProperties,
        'Grant.VestingTemplate.Company.Commission.BrokerCompany.ConcurrencyStamp':
          grantVestingTemplateCompanyCommissionBrokerCompanyConcurrencyStamp,
        'Grant.VestingTemplate.Company.Commission.Name': grantVestingTemplateCompanyCommissionName,
        'Grant.VestingTemplate.Company.Commission.Description':
          grantVestingTemplateCompanyCommissionDescription,
        'Grant.VestingTemplate.Company.Commission.BaseRate':
          grantVestingTemplateCompanyCommissionBaseRate,
        'Grant.VestingTemplate.Company.Commission.MaxAmount':
          grantVestingTemplateCompanyCommissionMaxAmount,
        'Grant.VestingTemplate.Company.Commission.CommissionSchedules':
          grantVestingTemplateCompanyCommissionCommissionSchedules,
        'Grant.VestingTemplate.Company.Commission.Company':
          grantVestingTemplateCompanyCommissionCompany,
        'Grant.VestingTemplate.Company.Commission.IsDeleted':
          grantVestingTemplateCompanyCommissionIsDeleted,
        'Grant.VestingTemplate.Company.Commission.DeleterId':
          grantVestingTemplateCompanyCommissionDeleterId,
        'Grant.VestingTemplate.Company.Commission.DeletionTime':
          grantVestingTemplateCompanyCommissionDeletionTime,
        'Grant.VestingTemplate.Company.Commission.LastModificationTime':
          grantVestingTemplateCompanyCommissionLastModificationTime,
        'Grant.VestingTemplate.Company.Commission.LastModifierId':
          grantVestingTemplateCompanyCommissionLastModifierId,
        'Grant.VestingTemplate.Company.Commission.CreationTime':
          grantVestingTemplateCompanyCommissionCreationTime,
        'Grant.VestingTemplate.Company.Commission.CreatorId':
          grantVestingTemplateCompanyCommissionCreatorId,
        'Grant.VestingTemplate.Company.Commission.Id': grantVestingTemplateCompanyCommissionId,
        'Grant.VestingTemplate.Company.CustomerApprovalProcesses':
          grantVestingTemplateCompanyCustomerApprovalProcesses,
        'Grant.VestingTemplate.Company.VestingTemplates':
          grantVestingTemplateCompanyVestingTemplates,
        'Grant.VestingTemplate.Company.RSUAward': grantVestingTemplateCompanyRsuAward,
        'Grant.VestingTemplate.Company.OwnedCommissions':
          grantVestingTemplateCompanyOwnedCommissions,
        'Grant.VestingTemplate.Company.BrokeredCommissions':
          grantVestingTemplateCompanyBrokeredCommissions,
        'Grant.VestingTemplate.Company.CommissionSchedules':
          grantVestingTemplateCompanyCommissionSchedules,
        'Grant.VestingTemplate.Company.RSUAwardVestingDate':
          grantVestingTemplateCompanyRsuAwardVestingDate,
        'Grant.VestingTemplate.Company.ElectionWindowConfigurations':
          grantVestingTemplateCompanyElectionWindowConfigurations,
        'Grant.VestingTemplate.Company.OptionAwards': grantVestingTemplateCompanyOptionAwards,
        'Grant.VestingTemplate.Company.TradePreClearanceRequests':
          grantVestingTemplateCompanyTradePreClearanceRequests,
        'Grant.VestingTemplate.Company.TradePreClearanceParticipantAwards':
          grantVestingTemplateCompanyTradePreClearanceParticipantAwards,
        'Grant.VestingTemplate.Company.PSUAward': grantVestingTemplateCompanyPsuAward,
        'Grant.VestingTemplate.Company.PSUAwardVestingDate':
          grantVestingTemplateCompanyPsuAwardVestingDate,
        'Grant.VestingTemplate.Company.ExtraProperties': grantVestingTemplateCompanyExtraProperties,
        'Grant.VestingTemplate.Company.ConcurrencyStamp':
          grantVestingTemplateCompanyConcurrencyStamp,
        'Grant.VestingTemplate.VestingType.Name': grantVestingTemplateVestingTypeName,
        'Grant.VestingTemplate.VestingType.IsCliffVesting':
          grantVestingTemplateVestingTypeIsCliffVesting,
        'Grant.VestingTemplate.VestingType.IsStepVesting':
          grantVestingTemplateVestingTypeIsStepVesting,
        'Grant.VestingTemplate.VestingType.IsHybridVesting':
          grantVestingTemplateVestingTypeIsHybridVesting,
        'Grant.VestingTemplate.VestingType.IsCustomVesting':
          grantVestingTemplateVestingTypeIsCustomVesting,
        'Grant.VestingTemplate.VestingType.IsSpecificVesting':
          grantVestingTemplateVestingTypeIsSpecificVesting,
        'Grant.VestingTemplate.VestingType.IsCustomVestingTranche':
          grantVestingTemplateVestingTypeIsCustomVestingTranche,
        'Grant.VestingTemplate.VestingType.IsEnabled': grantVestingTemplateVestingTypeIsEnabled,
        'Grant.VestingTemplate.VestingType.VestingTemplates':
          grantVestingTemplateVestingTypeVestingTemplates,
        'Grant.VestingTemplate.VestingType.DefaultVestingTemplates':
          grantVestingTemplateVestingTypeDefaultVestingTemplates,
        'Grant.VestingTemplate.VestingType.IsDeleted': grantVestingTemplateVestingTypeIsDeleted,
        'Grant.VestingTemplate.VestingType.DeleterId': grantVestingTemplateVestingTypeDeleterId,
        'Grant.VestingTemplate.VestingType.DeletionTime':
          grantVestingTemplateVestingTypeDeletionTime,
        'Grant.VestingTemplate.VestingType.LastModificationTime':
          grantVestingTemplateVestingTypeLastModificationTime,
        'Grant.VestingTemplate.VestingType.LastModifierId':
          grantVestingTemplateVestingTypeLastModifierId,
        'Grant.VestingTemplate.VestingType.CreationTime':
          grantVestingTemplateVestingTypeCreationTime,
        'Grant.VestingTemplate.VestingType.CreatorId': grantVestingTemplateVestingTypeCreatorId,
        'Grant.VestingTemplate.VestingType.ExtraProperties':
          grantVestingTemplateVestingTypeExtraProperties,
        'Grant.VestingTemplate.VestingType.ConcurrencyStamp':
          grantVestingTemplateVestingTypeConcurrencyStamp,
        'Grant.VestingTemplate.VestingType.Id': grantVestingTemplateVestingTypeId,
        'Grant.VestingTemplate.RoundingType.Id': grantVestingTemplateRoundingTypeId,
        'Grant.VestingTemplate.RoundingType.DisplayName':
          grantVestingTemplateRoundingTypeDisplayName,
        'Grant.VestingTemplate.RoundingType.SystemName': grantVestingTemplateRoundingTypeSystemName,
        'Grant.VestingTemplate.RoundingType.VestingTemplates':
          grantVestingTemplateRoundingTypeVestingTemplates,
        'Grant.VestingTemplate.RoundingType.DefaultVestingTemplates':
          grantVestingTemplateRoundingTypeDefaultVestingTemplates,
        'Grant.VestingTemplate.RoundingType.ExtraProperties':
          grantVestingTemplateRoundingTypeExtraProperties,
        'Grant.VestingTemplate.RoundingType.ConcurrencyStamp':
          grantVestingTemplateRoundingTypeConcurrencyStamp,
        'Grant.VestingTemplate.RSUAwards': grantVestingTemplateRsuAwards,
        'Grant.VestingTemplate.Grants': grantVestingTemplateGrants,
        'Grant.VestingTemplate.OptionAwards': grantVestingTemplateOptionAwards,
        'Grant.VestingTemplate.PSUAwards': grantVestingTemplatePsuAwards,
        'Grant.VestingTemplate.LoadingType.SystemName': grantVestingTemplateLoadingTypeSystemName,
        'Grant.VestingTemplate.LoadingType.DisplayName': grantVestingTemplateLoadingTypeDisplayName,
        'Grant.VestingTemplate.LoadingType.LastModificationTime':
          grantVestingTemplateLoadingTypeLastModificationTime,
        'Grant.VestingTemplate.LoadingType.LastModifierId':
          grantVestingTemplateLoadingTypeLastModifierId,
        'Grant.VestingTemplate.LoadingType.CreationTime':
          grantVestingTemplateLoadingTypeCreationTime,
        'Grant.VestingTemplate.LoadingType.CreatorId': grantVestingTemplateLoadingTypeCreatorId,
        'Grant.VestingTemplate.LoadingType.ExtraProperties':
          grantVestingTemplateLoadingTypeExtraProperties,
        'Grant.VestingTemplate.LoadingType.ConcurrencyStamp':
          grantVestingTemplateLoadingTypeConcurrencyStamp,
        'Grant.VestingTemplate.LoadingType.Id': grantVestingTemplateLoadingTypeId,
        'Grant.VestingTemplate.EndOfTheMonthType.SystemName':
          grantVestingTemplateEndOfTheMonthTypeSystemName,
        'Grant.VestingTemplate.EndOfTheMonthType.DisplayName':
          grantVestingTemplateEndOfTheMonthTypeDisplayName,
        'Grant.VestingTemplate.EndOfTheMonthType.LastModificationTime':
          grantVestingTemplateEndOfTheMonthTypeLastModificationTime,
        'Grant.VestingTemplate.EndOfTheMonthType.LastModifierId':
          grantVestingTemplateEndOfTheMonthTypeLastModifierId,
        'Grant.VestingTemplate.EndOfTheMonthType.CreationTime':
          grantVestingTemplateEndOfTheMonthTypeCreationTime,
        'Grant.VestingTemplate.EndOfTheMonthType.CreatorId':
          grantVestingTemplateEndOfTheMonthTypeCreatorId,
        'Grant.VestingTemplate.EndOfTheMonthType.ExtraProperties':
          grantVestingTemplateEndOfTheMonthTypeExtraProperties,
        'Grant.VestingTemplate.EndOfTheMonthType.ConcurrencyStamp':
          grantVestingTemplateEndOfTheMonthTypeConcurrencyStamp,
        'Grant.VestingTemplate.EndOfTheMonthType.Id': grantVestingTemplateEndOfTheMonthTypeId,
        'Grant.VestingTemplate.IsDeleted': grantVestingTemplateIsDeleted,
        'Grant.VestingTemplate.DeleterId': grantVestingTemplateDeleterId,
        'Grant.VestingTemplate.DeletionTime': grantVestingTemplateDeletionTime,
        'Grant.VestingTemplate.LastModificationTime': grantVestingTemplateLastModificationTime,
        'Grant.VestingTemplate.LastModifierId': grantVestingTemplateLastModifierId,
        'Grant.VestingTemplate.CreationTime': grantVestingTemplateCreationTime,
        'Grant.VestingTemplate.CreatorId': grantVestingTemplateCreatorId,
        'Grant.VestingTemplate.ExtraProperties': grantVestingTemplateExtraProperties,
        'Grant.VestingTemplate.ConcurrencyStamp': grantVestingTemplateConcurrencyStamp,
        'Grant.VestingTemplate.Id': grantVestingTemplateId,
        'Grant.PerformanceRule.TenantId': grantPerformanceRuleTenantId,
        'Grant.PerformanceRule.RuleName': grantPerformanceRuleRuleName,
        'Grant.PerformanceRule.CompanyId': grantPerformanceRuleCompanyId,
        'Grant.PerformanceRule.RuleTypeId': grantPerformanceRuleRuleTypeId,
        'Grant.PerformanceRule.MinimumPercentage': grantPerformanceRuleMinimumPercentage,
        'Grant.PerformanceRule.MaximumPercentage': grantPerformanceRuleMaximumPercentage,
        'Grant.PerformanceRule.RuleDescription': grantPerformanceRuleRuleDescription,
        'Grant.PerformanceRule.RuleSummary': grantPerformanceRuleRuleSummary,
        'Grant.PerformanceRule.IsAvailable': grantPerformanceRuleIsAvailable,
        'Grant.PerformanceRule.ShowRuleDisplayToParticipant':
          grantPerformanceRuleShowRuleDisplayToParticipant,
        'Grant.PerformanceRule.ShowPerformanceTrackingToParticipant':
          grantPerformanceRuleShowPerformanceTrackingToParticipant,
        'Grant.PerformanceRule.EvaluationPeriodStartDate':
          grantPerformanceRuleEvaluationPeriodStartDate,
        'Grant.PerformanceRule.EvaluationPeriodEndDate':
          grantPerformanceRuleEvaluationPeriodEndDate,
        'Grant.PerformanceRule.ApprovalStatusId': grantPerformanceRuleApprovalStatusId,
        'Grant.PerformanceRule.AvailableStatusId': grantPerformanceRuleAvailableStatusId,
        'Grant.PerformanceRule.EarnedStatusId': grantPerformanceRuleEarnedStatusId,
        'Grant.PerformanceRule.RuleType.Id': grantPerformanceRuleRuleTypeId,
        'Grant.PerformanceRule.RuleType.SystemName': grantPerformanceRuleRuleTypeSystemName,
        'Grant.PerformanceRule.RuleType.DisplayName': grantPerformanceRuleRuleTypeDisplayName,
        'Grant.PerformanceRule.RuleType.PerformanceRules':
          grantPerformanceRuleRuleTypePerformanceRules,
        'Grant.PerformanceRule.RuleType.ExtraProperties':
          grantPerformanceRuleRuleTypeExtraProperties,
        'Grant.PerformanceRule.RuleType.ConcurrencyStamp':
          grantPerformanceRuleRuleTypeConcurrencyStamp,
        'Grant.PerformanceRule.ApprovalStatus.Id': grantPerformanceRuleApprovalStatusId,
        'Grant.PerformanceRule.ApprovalStatus.SystemName':
          grantPerformanceRuleApprovalStatusSystemName,
        'Grant.PerformanceRule.ApprovalStatus.DisplayName':
          grantPerformanceRuleApprovalStatusDisplayName,
        'Grant.PerformanceRule.ApprovalStatus.PerformanceRules':
          grantPerformanceRuleApprovalStatusPerformanceRules,
        'Grant.PerformanceRule.ApprovalStatus.ExtraProperties':
          grantPerformanceRuleApprovalStatusExtraProperties,
        'Grant.PerformanceRule.ApprovalStatus.ConcurrencyStamp':
          grantPerformanceRuleApprovalStatusConcurrencyStamp,
        'Grant.PerformanceRule.EarnedStatus.Id': grantPerformanceRuleEarnedStatusId,
        'Grant.PerformanceRule.EarnedStatus.SystemName': grantPerformanceRuleEarnedStatusSystemName,
        'Grant.PerformanceRule.EarnedStatus.DisplayName':
          grantPerformanceRuleEarnedStatusDisplayName,
        'Grant.PerformanceRule.EarnedStatus.PerformanceRules':
          grantPerformanceRuleEarnedStatusPerformanceRules,
        'Grant.PerformanceRule.EarnedStatus.ExtraProperties':
          grantPerformanceRuleEarnedStatusExtraProperties,
        'Grant.PerformanceRule.EarnedStatus.ConcurrencyStamp':
          grantPerformanceRuleEarnedStatusConcurrencyStamp,
        'Grant.PerformanceRule.AvailableStatus.Id': grantPerformanceRuleAvailableStatusId,
        'Grant.PerformanceRule.AvailableStatus.SystemName':
          grantPerformanceRuleAvailableStatusSystemName,
        'Grant.PerformanceRule.AvailableStatus.DisplayName':
          grantPerformanceRuleAvailableStatusDisplayName,
        'Grant.PerformanceRule.AvailableStatus.PerformanceRules':
          grantPerformanceRuleAvailableStatusPerformanceRules,
        'Grant.PerformanceRule.AvailableStatus.ExtraProperties':
          grantPerformanceRuleAvailableStatusExtraProperties,
        'Grant.PerformanceRule.AvailableStatus.ConcurrencyStamp':
          grantPerformanceRuleAvailableStatusConcurrencyStamp,
        'Grant.PerformanceRule.PerformanceEvaluations': grantPerformanceRulePerformanceEvaluations,
        'Grant.PerformanceRule.EstimatePerformanceTracking':
          grantPerformanceRuleEstimatePerformanceTracking,
        'Grant.PerformanceRule.Grants': grantPerformanceRuleGrants,
        'Grant.PerformanceRule.PerformanceRuleApprovals':
          grantPerformanceRulePerformanceRuleApprovals,
        'Grant.PerformanceRule.IsDeleted': grantPerformanceRuleIsDeleted,
        'Grant.PerformanceRule.DeleterId': grantPerformanceRuleDeleterId,
        'Grant.PerformanceRule.DeletionTime': grantPerformanceRuleDeletionTime,
        'Grant.PerformanceRule.LastModificationTime': grantPerformanceRuleLastModificationTime,
        'Grant.PerformanceRule.LastModifierId': grantPerformanceRuleLastModifierId,
        'Grant.PerformanceRule.CreationTime': grantPerformanceRuleCreationTime,
        'Grant.PerformanceRule.CreatorId': grantPerformanceRuleCreatorId,
        'Grant.PerformanceRule.ExtraProperties': grantPerformanceRuleExtraProperties,
        'Grant.PerformanceRule.ConcurrencyStamp': grantPerformanceRuleConcurrencyStamp,
        'Grant.PerformanceRule.Id': grantPerformanceRuleId,
        'Grant.RSUAwards': grantRsuAwards,
        'Grant.GrantDocuments': grantGrantDocuments,
        'Grant.PSUAwards': grantPsuAwards,
        'Grant.GrantAgreementDocument.TenantId': grantGrantAgreementDocumentTenantId,
        'Grant.GrantAgreementDocument.PlanId': grantGrantAgreementDocumentPlanId,
        'Grant.GrantAgreementDocument.GrantDocumentName':
          grantGrantAgreementDocumentGrantDocumentName,
        'Grant.GrantAgreementDocument.Description': grantGrantAgreementDocumentDescription,
        'Grant.GrantAgreementDocument.GrantDocumentType':
          grantGrantAgreementDocumentGrantDocumentType,
        'Grant.GrantAgreementDocument.GrantTermsAndConditionText':
          grantGrantAgreementDocumentGrantTermsAndConditionText,
        'Grant.GrantAgreementDocument.TnCDocumentEsppOfferingPeriods':
          grantGrantAgreementDocumentTnCDocumentEsppOfferingPeriods,
        'Grant.GrantAgreementDocument.NoticeDocumentEsppOfferingPeriods':
          grantGrantAgreementDocumentNoticeDocumentEsppOfferingPeriods,
        'Grant.GrantAgreementDocument.AgreementDocumentEsppOfferingPeriods':
          grantGrantAgreementDocumentAgreementDocumentEsppOfferingPeriods,
        'Grant.GrantAgreementDocument.TnCDocumentTextEsppOfferingPeriods':
          grantGrantAgreementDocumentTnCDocumentTextEsppOfferingPeriods,
        'Grant.GrantAgreementDocument.GrantAgreementDocuments':
          grantGrantAgreementDocumentGrantAgreementDocuments,
        'Grant.GrantAgreementDocument.GrantNoticeDocuments':
          grantGrantAgreementDocumentGrantNoticeDocuments,
        'Grant.GrantAgreementDocument.GrantTermsAndConditionDocuments':
          grantGrantAgreementDocumentGrantTermsAndConditionDocuments,
        'Grant.GrantAgreementDocument.GrantTermsAndConditionTexts':
          grantGrantAgreementDocumentGrantTermsAndConditionTexts,
        'Grant.GrantAgreementDocument.PlanGrantDocumentDetails':
          grantGrantAgreementDocumentPlanGrantDocumentDetails,
        'Grant.GrantAgreementDocument.IsDeleted': grantGrantAgreementDocumentIsDeleted,
        'Grant.GrantAgreementDocument.DeleterId': grantGrantAgreementDocumentDeleterId,
        'Grant.GrantAgreementDocument.DeletionTime': grantGrantAgreementDocumentDeletionTime,
        'Grant.GrantAgreementDocument.LastModificationTime':
          grantGrantAgreementDocumentLastModificationTime,
        'Grant.GrantAgreementDocument.LastModifierId': grantGrantAgreementDocumentLastModifierId,
        'Grant.GrantAgreementDocument.CreationTime': grantGrantAgreementDocumentCreationTime,
        'Grant.GrantAgreementDocument.CreatorId': grantGrantAgreementDocumentCreatorId,
        'Grant.GrantAgreementDocument.ExtraProperties': grantGrantAgreementDocumentExtraProperties,
        'Grant.GrantAgreementDocument.ConcurrencyStamp':
          grantGrantAgreementDocumentConcurrencyStamp,
        'Grant.GrantAgreementDocument.Id': grantGrantAgreementDocumentId,
        'Grant.GrantNoticeDocument.TenantId': grantGrantNoticeDocumentTenantId,
        'Grant.GrantNoticeDocument.PlanId': grantGrantNoticeDocumentPlanId,
        'Grant.GrantNoticeDocument.GrantDocumentName': grantGrantNoticeDocumentGrantDocumentName,
        'Grant.GrantNoticeDocument.Description': grantGrantNoticeDocumentDescription,
        'Grant.GrantNoticeDocument.GrantDocumentType': grantGrantNoticeDocumentGrantDocumentType,
        'Grant.GrantNoticeDocument.GrantTermsAndConditionText':
          grantGrantNoticeDocumentGrantTermsAndConditionText,
        'Grant.GrantNoticeDocument.TnCDocumentEsppOfferingPeriods':
          grantGrantNoticeDocumentTnCDocumentEsppOfferingPeriods,
        'Grant.GrantNoticeDocument.NoticeDocumentEsppOfferingPeriods':
          grantGrantNoticeDocumentNoticeDocumentEsppOfferingPeriods,
        'Grant.GrantNoticeDocument.AgreementDocumentEsppOfferingPeriods':
          grantGrantNoticeDocumentAgreementDocumentEsppOfferingPeriods,
        'Grant.GrantNoticeDocument.TnCDocumentTextEsppOfferingPeriods':
          grantGrantNoticeDocumentTnCDocumentTextEsppOfferingPeriods,
        'Grant.GrantNoticeDocument.GrantAgreementDocuments':
          grantGrantNoticeDocumentGrantAgreementDocuments,
        'Grant.GrantNoticeDocument.GrantNoticeDocuments':
          grantGrantNoticeDocumentGrantNoticeDocuments,
        'Grant.GrantNoticeDocument.GrantTermsAndConditionDocuments':
          grantGrantNoticeDocumentGrantTermsAndConditionDocuments,
        'Grant.GrantNoticeDocument.GrantTermsAndConditionTexts':
          grantGrantNoticeDocumentGrantTermsAndConditionTexts,
        'Grant.GrantNoticeDocument.PlanGrantDocumentDetails':
          grantGrantNoticeDocumentPlanGrantDocumentDetails,
        'Grant.GrantNoticeDocument.IsDeleted': grantGrantNoticeDocumentIsDeleted,
        'Grant.GrantNoticeDocument.DeleterId': grantGrantNoticeDocumentDeleterId,
        'Grant.GrantNoticeDocument.DeletionTime': grantGrantNoticeDocumentDeletionTime,
        'Grant.GrantNoticeDocument.LastModificationTime':
          grantGrantNoticeDocumentLastModificationTime,
        'Grant.GrantNoticeDocument.LastModifierId': grantGrantNoticeDocumentLastModifierId,
        'Grant.GrantNoticeDocument.CreationTime': grantGrantNoticeDocumentCreationTime,
        'Grant.GrantNoticeDocument.CreatorId': grantGrantNoticeDocumentCreatorId,
        'Grant.GrantNoticeDocument.ExtraProperties': grantGrantNoticeDocumentExtraProperties,
        'Grant.GrantNoticeDocument.ConcurrencyStamp': grantGrantNoticeDocumentConcurrencyStamp,
        'Grant.GrantNoticeDocument.Id': grantGrantNoticeDocumentId,
        'Grant.TermsAndConditionDocument.TenantId': grantTermsAndConditionDocumentTenantId,
        'Grant.TermsAndConditionDocument.PlanId': grantTermsAndConditionDocumentPlanId,
        'Grant.TermsAndConditionDocument.GrantDocumentName':
          grantTermsAndConditionDocumentGrantDocumentName,
        'Grant.TermsAndConditionDocument.Description': grantTermsAndConditionDocumentDescription,
        'Grant.TermsAndConditionDocument.GrantDocumentType':
          grantTermsAndConditionDocumentGrantDocumentType,
        'Grant.TermsAndConditionDocument.GrantTermsAndConditionText':
          grantTermsAndConditionDocumentGrantTermsAndConditionText,
        'Grant.TermsAndConditionDocument.TnCDocumentEsppOfferingPeriods':
          grantTermsAndConditionDocumentTnCDocumentEsppOfferingPeriods,
        'Grant.TermsAndConditionDocument.NoticeDocumentEsppOfferingPeriods':
          grantTermsAndConditionDocumentNoticeDocumentEsppOfferingPeriods,
        'Grant.TermsAndConditionDocument.AgreementDocumentEsppOfferingPeriods':
          grantTermsAndConditionDocumentAgreementDocumentEsppOfferingPeriods,
        'Grant.TermsAndConditionDocument.TnCDocumentTextEsppOfferingPeriods':
          grantTermsAndConditionDocumentTnCDocumentTextEsppOfferingPeriods,
        'Grant.TermsAndConditionDocument.GrantAgreementDocuments':
          grantTermsAndConditionDocumentGrantAgreementDocuments,
        'Grant.TermsAndConditionDocument.GrantNoticeDocuments':
          grantTermsAndConditionDocumentGrantNoticeDocuments,
        'Grant.TermsAndConditionDocument.GrantTermsAndConditionDocuments':
          grantTermsAndConditionDocumentGrantTermsAndConditionDocuments,
        'Grant.TermsAndConditionDocument.GrantTermsAndConditionTexts':
          grantTermsAndConditionDocumentGrantTermsAndConditionTexts,
        'Grant.TermsAndConditionDocument.PlanGrantDocumentDetails':
          grantTermsAndConditionDocumentPlanGrantDocumentDetails,
        'Grant.TermsAndConditionDocument.IsDeleted': grantTermsAndConditionDocumentIsDeleted,
        'Grant.TermsAndConditionDocument.DeleterId': grantTermsAndConditionDocumentDeleterId,
        'Grant.TermsAndConditionDocument.DeletionTime': grantTermsAndConditionDocumentDeletionTime,
        'Grant.TermsAndConditionDocument.LastModificationTime':
          grantTermsAndConditionDocumentLastModificationTime,
        'Grant.TermsAndConditionDocument.LastModifierId':
          grantTermsAndConditionDocumentLastModifierId,
        'Grant.TermsAndConditionDocument.CreationTime': grantTermsAndConditionDocumentCreationTime,
        'Grant.TermsAndConditionDocument.CreatorId': grantTermsAndConditionDocumentCreatorId,
        'Grant.TermsAndConditionDocument.ExtraProperties':
          grantTermsAndConditionDocumentExtraProperties,
        'Grant.TermsAndConditionDocument.ConcurrencyStamp':
          grantTermsAndConditionDocumentConcurrencyStamp,
        'Grant.TermsAndConditionDocument.Id': grantTermsAndConditionDocumentId,
        'Grant.TermsAndConditionText.TenantId': grantTermsAndConditionTextTenantId,
        'Grant.TermsAndConditionText.PlanId': grantTermsAndConditionTextPlanId,
        'Grant.TermsAndConditionText.GrantDocumentName':
          grantTermsAndConditionTextGrantDocumentName,
        'Grant.TermsAndConditionText.Description': grantTermsAndConditionTextDescription,
        'Grant.TermsAndConditionText.GrantDocumentType':
          grantTermsAndConditionTextGrantDocumentType,
        'Grant.TermsAndConditionText.GrantTermsAndConditionText':
          grantTermsAndConditionTextGrantTermsAndConditionText,
        'Grant.TermsAndConditionText.TnCDocumentEsppOfferingPeriods':
          grantTermsAndConditionTextTnCDocumentEsppOfferingPeriods,
        'Grant.TermsAndConditionText.NoticeDocumentEsppOfferingPeriods':
          grantTermsAndConditionTextNoticeDocumentEsppOfferingPeriods,
        'Grant.TermsAndConditionText.AgreementDocumentEsppOfferingPeriods':
          grantTermsAndConditionTextAgreementDocumentEsppOfferingPeriods,
        'Grant.TermsAndConditionText.TnCDocumentTextEsppOfferingPeriods':
          grantTermsAndConditionTextTnCDocumentTextEsppOfferingPeriods,
        'Grant.TermsAndConditionText.GrantAgreementDocuments':
          grantTermsAndConditionTextGrantAgreementDocuments,
        'Grant.TermsAndConditionText.GrantNoticeDocuments':
          grantTermsAndConditionTextGrantNoticeDocuments,
        'Grant.TermsAndConditionText.GrantTermsAndConditionDocuments':
          grantTermsAndConditionTextGrantTermsAndConditionDocuments,
        'Grant.TermsAndConditionText.GrantTermsAndConditionTexts':
          grantTermsAndConditionTextGrantTermsAndConditionTexts,
        'Grant.TermsAndConditionText.PlanGrantDocumentDetails':
          grantTermsAndConditionTextPlanGrantDocumentDetails,
        'Grant.TermsAndConditionText.IsDeleted': grantTermsAndConditionTextIsDeleted,
        'Grant.TermsAndConditionText.DeleterId': grantTermsAndConditionTextDeleterId,
        'Grant.TermsAndConditionText.DeletionTime': grantTermsAndConditionTextDeletionTime,
        'Grant.TermsAndConditionText.LastModificationTime':
          grantTermsAndConditionTextLastModificationTime,
        'Grant.TermsAndConditionText.LastModifierId': grantTermsAndConditionTextLastModifierId,
        'Grant.TermsAndConditionText.CreationTime': grantTermsAndConditionTextCreationTime,
        'Grant.TermsAndConditionText.CreatorId': grantTermsAndConditionTextCreatorId,
        'Grant.TermsAndConditionText.ExtraProperties': grantTermsAndConditionTextExtraProperties,
        'Grant.TermsAndConditionText.ConcurrencyStamp': grantTermsAndConditionTextConcurrencyStamp,
        'Grant.TermsAndConditionText.Id': grantTermsAndConditionTextId,
        'Grant.GrantTermsAndConditions': grantGrantTermsAndConditions,
        'Grant.OptionAwards': grantOptionAwards,
        'Grant.TerminationRuleSet.Id': grantTerminationRuleSetId,
        'Grant.TerminationRuleSet.TenantId': grantTerminationRuleSetTenantId,
        'Grant.TerminationRuleSet.ExtraProperties': grantTerminationRuleSetExtraProperties,
        'Grant.TerminationRuleSet.ConcurrencyStamp': grantTerminationRuleSetConcurrencyStamp,
        'Grant.SettlementType.Id': grantSettlementTypeId,
        'Grant.SettlementType.SystemName': grantSettlementTypeSystemName,
        'Grant.SettlementType.DisplayName': grantSettlementTypeDisplayName,
        'Grant.SettlementType.IsCashSellType': grantSettlementTypeIsCashSellType,
        'Grant.SettlementType.ExtraProperties': grantSettlementTypeExtraProperties,
        'Grant.SettlementType.ConcurrencyStamp': grantSettlementTypeConcurrencyStamp,
        'Grant.IsDeleted': grantIsDeleted,
        'Grant.DeleterId': grantDeleterId,
        'Grant.DeletionTime': grantDeletionTime,
        'Grant.LastModificationTime': grantLastModificationTime,
        'Grant.LastModifierId': grantLastModifierId,
        'Grant.CreationTime': grantCreationTime,
        'Grant.CreatorId': grantCreatorId,
        'Grant.Id': grantId,
        VestingStartDate: vestingStartDate,
        GrantIssueDate: grantIssueDate,
        VestingTemplateId: vestingTemplateId,
        'VestingTemplate.TenantId': vestingTemplateTenantId,
        'VestingTemplate.CompanyId': vestingTemplateCompanyId,
        'VestingTemplate.Name': vestingTemplateName,
        'VestingTemplate.Summary': vestingTemplateSummary,
        'VestingTemplate.VestingTypeId': vestingTemplateVestingTypeId,
        'VestingTemplate.LengthInMonths': vestingTemplateLengthInMonths,
        'VestingTemplate.AmountOneInPercentage': vestingTemplateAmountOneInPercentage,
        'VestingTemplate.VestsAfterInMonths': vestingTemplateVestsAfterInMonths,
        'VestingTemplate.AmountTwoInPercentage': vestingTemplateAmountTwoInPercentage,
        'VestingTemplate.VestsInMonths': vestingTemplateVestsInMonths,
        'VestingTemplate.IntervalInMonths': vestingTemplateIntervalInMonths,
        'VestingTemplate.IsEnabled': vestingTemplateIsEnabled,
        'VestingTemplate.IsDefaultVestingTemplate': vestingTemplateIsDefaultVestingTemplate,
        'VestingTemplate.PeriodStartDate': vestingTemplatePeriodStartDate,
        'VestingTemplate.RoundingTypeId': vestingTemplateRoundingTypeId,
        'VestingTemplate.FractionalDecimalDigit': vestingTemplateFractionalDecimalDigit,
        'VestingTemplate.VestAtEndOfMonth': vestingTemplateVestAtEndOfMonth,
        'VestingTemplate.SpecificVestingInstruction': vestingTemplateSpecificVestingInstruction,
        'VestingTemplate.LoadingTypeId': vestingTemplateLoadingTypeId,
        'VestingTemplate.EndOfTheMonthTypeId': vestingTemplateEndOfTheMonthTypeId,
        'VestingTemplate.Company.Id': vestingTemplateCompanyId,
        'VestingTemplate.Company.TenantId': vestingTemplateCompanyTenantId,
        'VestingTemplate.Company.Name': vestingTemplateCompanyName,
        'VestingTemplate.Company.IsEnabled': vestingTemplateCompanyIsEnabled,
        'VestingTemplate.Company.CreatorId': vestingTemplateCompanyCreatorId,
        'VestingTemplate.Company.CreationTime': vestingTemplateCompanyCreationTime,
        'VestingTemplate.Company.LastModifierId': vestingTemplateCompanyLastModifierId,
        'VestingTemplate.Company.LastModificationTime': vestingTemplateCompanyLastModificationTime,
        'VestingTemplate.Company.IsDeleted': vestingTemplateCompanyIsDeleted,
        'VestingTemplate.Company.DeleterId': vestingTemplateCompanyDeleterId,
        'VestingTemplate.Company.DeletionTime': vestingTemplateCompanyDeletionTime,
        'VestingTemplate.Company.Ticker': vestingTemplateCompanyTicker,
        'VestingTemplate.Company.IsoCalculationSortingTypeId':
          vestingTemplateCompanyIsoCalculationSortingTypeId,
        'VestingTemplate.Company.IsoCalculationSortingType.Id':
          vestingTemplateCompanyIsoCalculationSortingTypeId,
        'VestingTemplate.Company.IsoCalculationSortingType.SystemName':
          vestingTemplateCompanyIsoCalculationSortingTypeSystemName,
        'VestingTemplate.Company.IsoCalculationSortingType.DisplayName':
          vestingTemplateCompanyIsoCalculationSortingTypeDisplayName,
        'VestingTemplate.Company.IsoCalculationSortingType.ExtraProperties':
          vestingTemplateCompanyIsoCalculationSortingTypeExtraProperties,
        'VestingTemplate.Company.IsoCalculationSortingType.ConcurrencyStamp':
          vestingTemplateCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'VestingTemplate.Company.IsEmailEnableToParticipant':
          vestingTemplateCompanyIsEmailEnableToParticipant,
        'VestingTemplate.Company.CommissionId': vestingTemplateCompanyCommissionId,
        'VestingTemplate.Company.DtcParticipantId': vestingTemplateCompanyDtcParticipantId,
        'VestingTemplate.Company.IntendedShareRegistrationTypeId':
          vestingTemplateCompanyIntendedShareRegistrationTypeId,
        'VestingTemplate.Company.IntendedShareRegistrationType.SystemName':
          vestingTemplateCompanyIntendedShareRegistrationTypeSystemName,
        'VestingTemplate.Company.IntendedShareRegistrationType.DisplayName':
          vestingTemplateCompanyIntendedShareRegistrationTypeDisplayName,
        'VestingTemplate.Company.IntendedShareRegistrationType.LastModificationTime':
          vestingTemplateCompanyIntendedShareRegistrationTypeLastModificationTime,
        'VestingTemplate.Company.IntendedShareRegistrationType.LastModifierId':
          vestingTemplateCompanyIntendedShareRegistrationTypeLastModifierId,
        'VestingTemplate.Company.IntendedShareRegistrationType.CreationTime':
          vestingTemplateCompanyIntendedShareRegistrationTypeCreationTime,
        'VestingTemplate.Company.IntendedShareRegistrationType.CreatorId':
          vestingTemplateCompanyIntendedShareRegistrationTypeCreatorId,
        'VestingTemplate.Company.IntendedShareRegistrationType.ExtraProperties':
          vestingTemplateCompanyIntendedShareRegistrationTypeExtraProperties,
        'VestingTemplate.Company.IntendedShareRegistrationType.ConcurrencyStamp':
          vestingTemplateCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'VestingTemplate.Company.IntendedShareRegistrationType.Id':
          vestingTemplateCompanyIntendedShareRegistrationTypeId,
        'VestingTemplate.Company.TransactionAcquisitionTypeId':
          vestingTemplateCompanyTransactionAcquisitionTypeId,
        'VestingTemplate.Company.TransactionAcquisitionType.SystemName':
          vestingTemplateCompanyTransactionAcquisitionTypeSystemName,
        'VestingTemplate.Company.TransactionAcquisitionType.DisplayName':
          vestingTemplateCompanyTransactionAcquisitionTypeDisplayName,
        'VestingTemplate.Company.TransactionAcquisitionType.LastModificationTime':
          vestingTemplateCompanyTransactionAcquisitionTypeLastModificationTime,
        'VestingTemplate.Company.TransactionAcquisitionType.LastModifierId':
          vestingTemplateCompanyTransactionAcquisitionTypeLastModifierId,
        'VestingTemplate.Company.TransactionAcquisitionType.CreationTime':
          vestingTemplateCompanyTransactionAcquisitionTypeCreationTime,
        'VestingTemplate.Company.TransactionAcquisitionType.CreatorId':
          vestingTemplateCompanyTransactionAcquisitionTypeCreatorId,
        'VestingTemplate.Company.TransactionAcquisitionType.ExtraProperties':
          vestingTemplateCompanyTransactionAcquisitionTypeExtraProperties,
        'VestingTemplate.Company.TransactionAcquisitionType.ConcurrencyStamp':
          vestingTemplateCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'VestingTemplate.Company.TransactionAcquisitionType.Id':
          vestingTemplateCompanyTransactionAcquisitionTypeId,
        'VestingTemplate.Company.PriceThreshold': vestingTemplateCompanyPriceThreshold,
        'VestingTemplate.Company.IsPartBRequired': vestingTemplateCompanyIsPartBRequired,
        'VestingTemplate.Company.IsPartCRequired': vestingTemplateCompanyIsPartCRequired,
        'VestingTemplate.Company.Commission.OwningCompanyId':
          vestingTemplateCompanyCommissionOwningCompanyId,
        'VestingTemplate.Company.Commission.OwningCompany.Id':
          vestingTemplateCompanyCommissionOwningCompanyId,
        'VestingTemplate.Company.Commission.OwningCompany.TenantId':
          vestingTemplateCompanyCommissionOwningCompanyTenantId,
        'VestingTemplate.Company.Commission.OwningCompany.Name':
          vestingTemplateCompanyCommissionOwningCompanyName,
        'VestingTemplate.Company.Commission.OwningCompany.IsEnabled':
          vestingTemplateCompanyCommissionOwningCompanyIsEnabled,
        'VestingTemplate.Company.Commission.OwningCompany.CreatorId':
          vestingTemplateCompanyCommissionOwningCompanyCreatorId,
        'VestingTemplate.Company.Commission.OwningCompany.CreationTime':
          vestingTemplateCompanyCommissionOwningCompanyCreationTime,
        'VestingTemplate.Company.Commission.OwningCompany.LastModifierId':
          vestingTemplateCompanyCommissionOwningCompanyLastModifierId,
        'VestingTemplate.Company.Commission.OwningCompany.LastModificationTime':
          vestingTemplateCompanyCommissionOwningCompanyLastModificationTime,
        'VestingTemplate.Company.Commission.OwningCompany.IsDeleted':
          vestingTemplateCompanyCommissionOwningCompanyIsDeleted,
        'VestingTemplate.Company.Commission.OwningCompany.DeleterId':
          vestingTemplateCompanyCommissionOwningCompanyDeleterId,
        'VestingTemplate.Company.Commission.OwningCompany.DeletionTime':
          vestingTemplateCompanyCommissionOwningCompanyDeletionTime,
        'VestingTemplate.Company.Commission.OwningCompany.Ticker':
          vestingTemplateCompanyCommissionOwningCompanyTicker,
        'VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingTypeId':
          vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId,
        'VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.Id':
          vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeId,
        'VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.SystemName':
          vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeSystemName,
        'VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.DisplayName':
          vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeDisplayName,
        'VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.ExtraProperties':
          vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeExtraProperties,
        'VestingTemplate.Company.Commission.OwningCompany.IsoCalculationSortingType.ConcurrencyStamp':
          vestingTemplateCompanyCommissionOwningCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'VestingTemplate.Company.Commission.OwningCompany.IsEmailEnableToParticipant':
          vestingTemplateCompanyCommissionOwningCompanyIsEmailEnableToParticipant,
        'VestingTemplate.Company.Commission.OwningCompany.CommissionId':
          vestingTemplateCompanyCommissionOwningCompanyCommissionId,
        'VestingTemplate.Company.Commission.OwningCompany.DtcParticipantId':
          vestingTemplateCompanyCommissionOwningCompanyDtcParticipantId,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationTypeId':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.SystemName':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeSystemName,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.DisplayName':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeDisplayName,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.LastModificationTime':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModificationTime,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.LastModifierId':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeLastModifierId,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.CreationTime':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreationTime,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.CreatorId':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeCreatorId,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.ExtraProperties':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeExtraProperties,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.ConcurrencyStamp':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'VestingTemplate.Company.Commission.OwningCompany.IntendedShareRegistrationType.Id':
          vestingTemplateCompanyCommissionOwningCompanyIntendedShareRegistrationTypeId,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionTypeId':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.SystemName':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeSystemName,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.DisplayName':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeDisplayName,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.LastModificationTime':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModificationTime,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.LastModifierId':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeLastModifierId,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.CreationTime':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreationTime,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.CreatorId':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeCreatorId,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.ExtraProperties':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeExtraProperties,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.ConcurrencyStamp':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'VestingTemplate.Company.Commission.OwningCompany.TransactionAcquisitionType.Id':
          vestingTemplateCompanyCommissionOwningCompanyTransactionAcquisitionTypeId,
        'VestingTemplate.Company.Commission.OwningCompany.PriceThreshold':
          vestingTemplateCompanyCommissionOwningCompanyPriceThreshold,
        'VestingTemplate.Company.Commission.OwningCompany.IsPartBRequired':
          vestingTemplateCompanyCommissionOwningCompanyIsPartBRequired,
        'VestingTemplate.Company.Commission.OwningCompany.IsPartCRequired':
          vestingTemplateCompanyCommissionOwningCompanyIsPartCRequired,
        'VestingTemplate.Company.Commission.OwningCompany.Commission':
          vestingTemplateCompanyCommissionOwningCompanyCommission,
        'VestingTemplate.Company.Commission.OwningCompany.CustomerApprovalProcesses':
          vestingTemplateCompanyCommissionOwningCompanyCustomerApprovalProcesses,
        'VestingTemplate.Company.Commission.OwningCompany.VestingTemplates':
          vestingTemplateCompanyCommissionOwningCompanyVestingTemplates,
        'VestingTemplate.Company.Commission.OwningCompany.RSUAward':
          vestingTemplateCompanyCommissionOwningCompanyRsuAward,
        'VestingTemplate.Company.Commission.OwningCompany.OwnedCommissions':
          vestingTemplateCompanyCommissionOwningCompanyOwnedCommissions,
        'VestingTemplate.Company.Commission.OwningCompany.BrokeredCommissions':
          vestingTemplateCompanyCommissionOwningCompanyBrokeredCommissions,
        'VestingTemplate.Company.Commission.OwningCompany.CommissionSchedules':
          vestingTemplateCompanyCommissionOwningCompanyCommissionSchedules,
        'VestingTemplate.Company.Commission.OwningCompany.RSUAwardVestingDate':
          vestingTemplateCompanyCommissionOwningCompanyRsuAwardVestingDate,
        'VestingTemplate.Company.Commission.OwningCompany.ElectionWindowConfigurations':
          vestingTemplateCompanyCommissionOwningCompanyElectionWindowConfigurations,
        'VestingTemplate.Company.Commission.OwningCompany.OptionAwards':
          vestingTemplateCompanyCommissionOwningCompanyOptionAwards,
        'VestingTemplate.Company.Commission.OwningCompany.TradePreClearanceRequests':
          vestingTemplateCompanyCommissionOwningCompanyTradePreClearanceRequests,
        'VestingTemplate.Company.Commission.OwningCompany.TradePreClearanceParticipantAwards':
          vestingTemplateCompanyCommissionOwningCompanyTradePreClearanceParticipantAwards,
        'VestingTemplate.Company.Commission.OwningCompany.PSUAward':
          vestingTemplateCompanyCommissionOwningCompanyPsuAward,
        'VestingTemplate.Company.Commission.OwningCompany.PSUAwardVestingDate':
          vestingTemplateCompanyCommissionOwningCompanyPsuAwardVestingDate,
        'VestingTemplate.Company.Commission.OwningCompany.ExtraProperties':
          vestingTemplateCompanyCommissionOwningCompanyExtraProperties,
        'VestingTemplate.Company.Commission.OwningCompany.ConcurrencyStamp':
          vestingTemplateCompanyCommissionOwningCompanyConcurrencyStamp,
        'VestingTemplate.Company.Commission.BrokerCompanyId':
          vestingTemplateCompanyCommissionBrokerCompanyId,
        'VestingTemplate.Company.Commission.BrokerCompany.Id':
          vestingTemplateCompanyCommissionBrokerCompanyId,
        'VestingTemplate.Company.Commission.BrokerCompany.TenantId':
          vestingTemplateCompanyCommissionBrokerCompanyTenantId,
        'VestingTemplate.Company.Commission.BrokerCompany.Name':
          vestingTemplateCompanyCommissionBrokerCompanyName,
        'VestingTemplate.Company.Commission.BrokerCompany.IsEnabled':
          vestingTemplateCompanyCommissionBrokerCompanyIsEnabled,
        'VestingTemplate.Company.Commission.BrokerCompany.CreatorId':
          vestingTemplateCompanyCommissionBrokerCompanyCreatorId,
        'VestingTemplate.Company.Commission.BrokerCompany.CreationTime':
          vestingTemplateCompanyCommissionBrokerCompanyCreationTime,
        'VestingTemplate.Company.Commission.BrokerCompany.LastModifierId':
          vestingTemplateCompanyCommissionBrokerCompanyLastModifierId,
        'VestingTemplate.Company.Commission.BrokerCompany.LastModificationTime':
          vestingTemplateCompanyCommissionBrokerCompanyLastModificationTime,
        'VestingTemplate.Company.Commission.BrokerCompany.IsDeleted':
          vestingTemplateCompanyCommissionBrokerCompanyIsDeleted,
        'VestingTemplate.Company.Commission.BrokerCompany.DeleterId':
          vestingTemplateCompanyCommissionBrokerCompanyDeleterId,
        'VestingTemplate.Company.Commission.BrokerCompany.DeletionTime':
          vestingTemplateCompanyCommissionBrokerCompanyDeletionTime,
        'VestingTemplate.Company.Commission.BrokerCompany.Ticker':
          vestingTemplateCompanyCommissionBrokerCompanyTicker,
        'VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingTypeId':
          vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId,
        'VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.Id':
          vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeId,
        'VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.SystemName':
          vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeSystemName,
        'VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.DisplayName':
          vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeDisplayName,
        'VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.ExtraProperties':
          vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeExtraProperties,
        'VestingTemplate.Company.Commission.BrokerCompany.IsoCalculationSortingType.ConcurrencyStamp':
          vestingTemplateCompanyCommissionBrokerCompanyIsoCalculationSortingTypeConcurrencyStamp,
        'VestingTemplate.Company.Commission.BrokerCompany.IsEmailEnableToParticipant':
          vestingTemplateCompanyCommissionBrokerCompanyIsEmailEnableToParticipant,
        'VestingTemplate.Company.Commission.BrokerCompany.CommissionId':
          vestingTemplateCompanyCommissionBrokerCompanyCommissionId,
        'VestingTemplate.Company.Commission.BrokerCompany.DtcParticipantId':
          vestingTemplateCompanyCommissionBrokerCompanyDtcParticipantId,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationTypeId':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.SystemName':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeSystemName,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.DisplayName':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeDisplayName,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.LastModificationTime':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModificationTime,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.LastModifierId':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeLastModifierId,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.CreationTime':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreationTime,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.CreatorId':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeCreatorId,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.ExtraProperties':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeExtraProperties,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.ConcurrencyStamp':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeConcurrencyStamp,
        'VestingTemplate.Company.Commission.BrokerCompany.IntendedShareRegistrationType.Id':
          vestingTemplateCompanyCommissionBrokerCompanyIntendedShareRegistrationTypeId,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionTypeId':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.SystemName':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeSystemName,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.DisplayName':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeDisplayName,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.LastModificationTime':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModificationTime,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.LastModifierId':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeLastModifierId,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.CreationTime':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreationTime,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.CreatorId':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeCreatorId,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.ExtraProperties':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeExtraProperties,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.ConcurrencyStamp':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeConcurrencyStamp,
        'VestingTemplate.Company.Commission.BrokerCompany.TransactionAcquisitionType.Id':
          vestingTemplateCompanyCommissionBrokerCompanyTransactionAcquisitionTypeId,
        'VestingTemplate.Company.Commission.BrokerCompany.PriceThreshold':
          vestingTemplateCompanyCommissionBrokerCompanyPriceThreshold,
        'VestingTemplate.Company.Commission.BrokerCompany.IsPartBRequired':
          vestingTemplateCompanyCommissionBrokerCompanyIsPartBRequired,
        'VestingTemplate.Company.Commission.BrokerCompany.IsPartCRequired':
          vestingTemplateCompanyCommissionBrokerCompanyIsPartCRequired,
        'VestingTemplate.Company.Commission.BrokerCompany.Commission':
          vestingTemplateCompanyCommissionBrokerCompanyCommission,
        'VestingTemplate.Company.Commission.BrokerCompany.CustomerApprovalProcesses':
          vestingTemplateCompanyCommissionBrokerCompanyCustomerApprovalProcesses,
        'VestingTemplate.Company.Commission.BrokerCompany.VestingTemplates':
          vestingTemplateCompanyCommissionBrokerCompanyVestingTemplates,
        'VestingTemplate.Company.Commission.BrokerCompany.RSUAward':
          vestingTemplateCompanyCommissionBrokerCompanyRsuAward,
        'VestingTemplate.Company.Commission.BrokerCompany.OwnedCommissions':
          vestingTemplateCompanyCommissionBrokerCompanyOwnedCommissions,
        'VestingTemplate.Company.Commission.BrokerCompany.BrokeredCommissions':
          vestingTemplateCompanyCommissionBrokerCompanyBrokeredCommissions,
        'VestingTemplate.Company.Commission.BrokerCompany.CommissionSchedules':
          vestingTemplateCompanyCommissionBrokerCompanyCommissionSchedules,
        'VestingTemplate.Company.Commission.BrokerCompany.RSUAwardVestingDate':
          vestingTemplateCompanyCommissionBrokerCompanyRsuAwardVestingDate,
        'VestingTemplate.Company.Commission.BrokerCompany.ElectionWindowConfigurations':
          vestingTemplateCompanyCommissionBrokerCompanyElectionWindowConfigurations,
        'VestingTemplate.Company.Commission.BrokerCompany.OptionAwards':
          vestingTemplateCompanyCommissionBrokerCompanyOptionAwards,
        'VestingTemplate.Company.Commission.BrokerCompany.TradePreClearanceRequests':
          vestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceRequests,
        'VestingTemplate.Company.Commission.BrokerCompany.TradePreClearanceParticipantAwards':
          vestingTemplateCompanyCommissionBrokerCompanyTradePreClearanceParticipantAwards,
        'VestingTemplate.Company.Commission.BrokerCompany.PSUAward':
          vestingTemplateCompanyCommissionBrokerCompanyPsuAward,
        'VestingTemplate.Company.Commission.BrokerCompany.PSUAwardVestingDate':
          vestingTemplateCompanyCommissionBrokerCompanyPsuAwardVestingDate,
        'VestingTemplate.Company.Commission.BrokerCompany.ExtraProperties':
          vestingTemplateCompanyCommissionBrokerCompanyExtraProperties,
        'VestingTemplate.Company.Commission.BrokerCompany.ConcurrencyStamp':
          vestingTemplateCompanyCommissionBrokerCompanyConcurrencyStamp,
        'VestingTemplate.Company.Commission.Name': vestingTemplateCompanyCommissionName,
        'VestingTemplate.Company.Commission.Description':
          vestingTemplateCompanyCommissionDescription,
        'VestingTemplate.Company.Commission.BaseRate': vestingTemplateCompanyCommissionBaseRate,
        'VestingTemplate.Company.Commission.MaxAmount': vestingTemplateCompanyCommissionMaxAmount,
        'VestingTemplate.Company.Commission.CommissionSchedules':
          vestingTemplateCompanyCommissionCommissionSchedules,
        'VestingTemplate.Company.Commission.Company': vestingTemplateCompanyCommissionCompany,
        'VestingTemplate.Company.Commission.IsDeleted': vestingTemplateCompanyCommissionIsDeleted,
        'VestingTemplate.Company.Commission.DeleterId': vestingTemplateCompanyCommissionDeleterId,
        'VestingTemplate.Company.Commission.DeletionTime':
          vestingTemplateCompanyCommissionDeletionTime,
        'VestingTemplate.Company.Commission.LastModificationTime':
          vestingTemplateCompanyCommissionLastModificationTime,
        'VestingTemplate.Company.Commission.LastModifierId':
          vestingTemplateCompanyCommissionLastModifierId,
        'VestingTemplate.Company.Commission.CreationTime':
          vestingTemplateCompanyCommissionCreationTime,
        'VestingTemplate.Company.Commission.CreatorId': vestingTemplateCompanyCommissionCreatorId,
        'VestingTemplate.Company.Commission.Id': vestingTemplateCompanyCommissionId,
        'VestingTemplate.Company.CustomerApprovalProcesses':
          vestingTemplateCompanyCustomerApprovalProcesses,
        'VestingTemplate.Company.VestingTemplates': vestingTemplateCompanyVestingTemplates,
        'VestingTemplate.Company.RSUAward': vestingTemplateCompanyRsuAward,
        'VestingTemplate.Company.OwnedCommissions': vestingTemplateCompanyOwnedCommissions,
        'VestingTemplate.Company.BrokeredCommissions': vestingTemplateCompanyBrokeredCommissions,
        'VestingTemplate.Company.CommissionSchedules': vestingTemplateCompanyCommissionSchedules,
        'VestingTemplate.Company.RSUAwardVestingDate': vestingTemplateCompanyRsuAwardVestingDate,
        'VestingTemplate.Company.ElectionWindowConfigurations':
          vestingTemplateCompanyElectionWindowConfigurations,
        'VestingTemplate.Company.OptionAwards': vestingTemplateCompanyOptionAwards,
        'VestingTemplate.Company.TradePreClearanceRequests':
          vestingTemplateCompanyTradePreClearanceRequests,
        'VestingTemplate.Company.TradePreClearanceParticipantAwards':
          vestingTemplateCompanyTradePreClearanceParticipantAwards,
        'VestingTemplate.Company.PSUAward': vestingTemplateCompanyPsuAward,
        'VestingTemplate.Company.PSUAwardVestingDate': vestingTemplateCompanyPsuAwardVestingDate,
        'VestingTemplate.Company.ExtraProperties': vestingTemplateCompanyExtraProperties,
        'VestingTemplate.Company.ConcurrencyStamp': vestingTemplateCompanyConcurrencyStamp,
        'VestingTemplate.VestingType.Name': vestingTemplateVestingTypeName,
        'VestingTemplate.VestingType.IsCliffVesting': vestingTemplateVestingTypeIsCliffVesting,
        'VestingTemplate.VestingType.IsStepVesting': vestingTemplateVestingTypeIsStepVesting,
        'VestingTemplate.VestingType.IsHybridVesting': vestingTemplateVestingTypeIsHybridVesting,
        'VestingTemplate.VestingType.IsCustomVesting': vestingTemplateVestingTypeIsCustomVesting,
        'VestingTemplate.VestingType.IsSpecificVesting':
          vestingTemplateVestingTypeIsSpecificVesting,
        'VestingTemplate.VestingType.IsCustomVestingTranche':
          vestingTemplateVestingTypeIsCustomVestingTranche,
        'VestingTemplate.VestingType.IsEnabled': vestingTemplateVestingTypeIsEnabled,
        'VestingTemplate.VestingType.VestingTemplates': vestingTemplateVestingTypeVestingTemplates,
        'VestingTemplate.VestingType.DefaultVestingTemplates':
          vestingTemplateVestingTypeDefaultVestingTemplates,
        'VestingTemplate.VestingType.IsDeleted': vestingTemplateVestingTypeIsDeleted,
        'VestingTemplate.VestingType.DeleterId': vestingTemplateVestingTypeDeleterId,
        'VestingTemplate.VestingType.DeletionTime': vestingTemplateVestingTypeDeletionTime,
        'VestingTemplate.VestingType.LastModificationTime':
          vestingTemplateVestingTypeLastModificationTime,
        'VestingTemplate.VestingType.LastModifierId': vestingTemplateVestingTypeLastModifierId,
        'VestingTemplate.VestingType.CreationTime': vestingTemplateVestingTypeCreationTime,
        'VestingTemplate.VestingType.CreatorId': vestingTemplateVestingTypeCreatorId,
        'VestingTemplate.VestingType.ExtraProperties': vestingTemplateVestingTypeExtraProperties,
        'VestingTemplate.VestingType.ConcurrencyStamp': vestingTemplateVestingTypeConcurrencyStamp,
        'VestingTemplate.VestingType.Id': vestingTemplateVestingTypeId,
        'VestingTemplate.RoundingType.Id': vestingTemplateRoundingTypeId,
        'VestingTemplate.RoundingType.DisplayName': vestingTemplateRoundingTypeDisplayName,
        'VestingTemplate.RoundingType.SystemName': vestingTemplateRoundingTypeSystemName,
        'VestingTemplate.RoundingType.VestingTemplates':
          vestingTemplateRoundingTypeVestingTemplates,
        'VestingTemplate.RoundingType.DefaultVestingTemplates':
          vestingTemplateRoundingTypeDefaultVestingTemplates,
        'VestingTemplate.RoundingType.ExtraProperties': vestingTemplateRoundingTypeExtraProperties,
        'VestingTemplate.RoundingType.ConcurrencyStamp':
          vestingTemplateRoundingTypeConcurrencyStamp,
        'VestingTemplate.RSUAwards': vestingTemplateRsuAwards,
        'VestingTemplate.Grants': vestingTemplateGrants,
        'VestingTemplate.OptionAwards': vestingTemplateOptionAwards,
        'VestingTemplate.PSUAwards': vestingTemplatePsuAwards,
        'VestingTemplate.LoadingType.SystemName': vestingTemplateLoadingTypeSystemName,
        'VestingTemplate.LoadingType.DisplayName': vestingTemplateLoadingTypeDisplayName,
        'VestingTemplate.LoadingType.LastModificationTime':
          vestingTemplateLoadingTypeLastModificationTime,
        'VestingTemplate.LoadingType.LastModifierId': vestingTemplateLoadingTypeLastModifierId,
        'VestingTemplate.LoadingType.CreationTime': vestingTemplateLoadingTypeCreationTime,
        'VestingTemplate.LoadingType.CreatorId': vestingTemplateLoadingTypeCreatorId,
        'VestingTemplate.LoadingType.ExtraProperties': vestingTemplateLoadingTypeExtraProperties,
        'VestingTemplate.LoadingType.ConcurrencyStamp': vestingTemplateLoadingTypeConcurrencyStamp,
        'VestingTemplate.LoadingType.Id': vestingTemplateLoadingTypeId,
        'VestingTemplate.EndOfTheMonthType.SystemName': vestingTemplateEndOfTheMonthTypeSystemName,
        'VestingTemplate.EndOfTheMonthType.DisplayName':
          vestingTemplateEndOfTheMonthTypeDisplayName,
        'VestingTemplate.EndOfTheMonthType.LastModificationTime':
          vestingTemplateEndOfTheMonthTypeLastModificationTime,
        'VestingTemplate.EndOfTheMonthType.LastModifierId':
          vestingTemplateEndOfTheMonthTypeLastModifierId,
        'VestingTemplate.EndOfTheMonthType.CreationTime':
          vestingTemplateEndOfTheMonthTypeCreationTime,
        'VestingTemplate.EndOfTheMonthType.CreatorId': vestingTemplateEndOfTheMonthTypeCreatorId,
        'VestingTemplate.EndOfTheMonthType.ExtraProperties':
          vestingTemplateEndOfTheMonthTypeExtraProperties,
        'VestingTemplate.EndOfTheMonthType.ConcurrencyStamp':
          vestingTemplateEndOfTheMonthTypeConcurrencyStamp,
        'VestingTemplate.EndOfTheMonthType.Id': vestingTemplateEndOfTheMonthTypeId,
        'VestingTemplate.IsDeleted': vestingTemplateIsDeleted,
        'VestingTemplate.DeleterId': vestingTemplateDeleterId,
        'VestingTemplate.DeletionTime': vestingTemplateDeletionTime,
        'VestingTemplate.LastModificationTime': vestingTemplateLastModificationTime,
        'VestingTemplate.LastModifierId': vestingTemplateLastModifierId,
        'VestingTemplate.CreationTime': vestingTemplateCreationTime,
        'VestingTemplate.CreatorId': vestingTemplateCreatorId,
        'VestingTemplate.ExtraProperties': vestingTemplateExtraProperties,
        'VestingTemplate.ConcurrencyStamp': vestingTemplateConcurrencyStamp,
        'VestingTemplate.Id': vestingTemplateId,
        PlanId: planId,
        'Plan.TenantId': planTenantId,
        'Plan.UniquePlanNo': planUniquePlanNo,
        'Plan.Name': planName,
        'Plan.CompanyId': planCompanyId,
        'Plan.NumberOfSharesAuthorized': planNumberOfSharesAuthorized,
        'Plan.NumberOfSharesAvailable': planNumberOfSharesAvailable,
        'Plan.EligibleShareClass': planEligibleShareClass,
        'Plan.Description': planDescription,
        'Plan.PlanApprovalStatus': planPlanApprovalStatus,
        'Plan.IsEnabled': planIsEnabled,
        'Plan.PlanEffectiveDate': planPlanEffectiveDate,
        'Plan.BoardApprovalDate': planBoardApprovalDate,
        'Plan.ShareHolderApprovalDate': planShareHolderApprovalDate,
        'Plan.PlanTerm': planPlanTerm,
        'Plan.EvergreenPlan': planEvergreenPlan,
        'Plan.EvergreenCriteria': planEvergreenCriteria,
        'Plan.DeathExpirationOption': planDeathExpirationOption,
        'Plan.DisablityExpirationOption': planDisablityExpirationOption,
        'Plan.RetirementExpirationOption': planRetirementExpirationOption,
        'Plan.VolutaryTerminationOption': planVolutaryTerminationOption,
        'Plan.InvolutaryTerminationOption': planInvolutaryTerminationOption,
        'Plan.DividendEligibility': planDividendEligibility,
        'Plan.OptionExpirationDate': planOptionExpirationDate,
        'Plan.NumberOfSharesUnAvailable': planNumberOfSharesUnAvailable,
        'Plan.PlanExpiryDate': planPlanExpiryDate,
        'Plan.WithACause': planWithACause,
        'Plan.TerminationRuleSetId': planTerminationRuleSetId,
        'Plan.PoolId': planPoolId,
        'Plan.Pool.TenantId': planPoolTenantId,
        'Plan.Pool.CompanyId': planPoolCompanyId,
        'Plan.Pool.PoolName': planPoolPoolName,
        'Plan.Pool.NumberOfSharesAuthorised': planPoolNumberOfSharesAuthorised,
        'Plan.Pool.NumberOfSharesAvailable': planPoolNumberOfSharesAvailable,
        'Plan.Pool.NumberOfSharesUnAvailable': planPoolNumberOfSharesUnAvailable,
        'Plan.Pool.HasExternalPoolRefrence': planPoolHasExternalPoolRefrence,
        'Plan.Pool.Description': planPoolDescription,
        'Plan.Pool.ExternalPoolName': planPoolExternalPoolName,
        'Plan.Pool.ExternalPoolReferenceId': planPoolExternalPoolReferenceId,
        'Plan.Pool.Transactions': planPoolTransactions,
        'Plan.Pool.RSUAwards': planPoolRsuAwards,
        'Plan.Pool.PSUAwards': planPoolPsuAwards,
        'Plan.Pool.OptionAwards': planPoolOptionAwards,
        'Plan.Pool.Grants': planPoolGrants,
        'Plan.Pool.Plans': planPoolPlans,
        'Plan.Pool.IsDeleted': planPoolIsDeleted,
        'Plan.Pool.DeleterId': planPoolDeleterId,
        'Plan.Pool.DeletionTime': planPoolDeletionTime,
        'Plan.Pool.LastModificationTime': planPoolLastModificationTime,
        'Plan.Pool.LastModifierId': planPoolLastModifierId,
        'Plan.Pool.CreationTime': planPoolCreationTime,
        'Plan.Pool.CreatorId': planPoolCreatorId,
        'Plan.Pool.ExtraProperties': planPoolExtraProperties,
        'Plan.Pool.ConcurrencyStamp': planPoolConcurrencyStamp,
        'Plan.Pool.Id': planPoolId,
        'Plan.AllowEditPlanRelatedDocuments': planAllowEditPlanRelatedDocuments,
        'Plan.PlanDocuments': planPlanDocuments,
        'Plan.RSUAwards': planRsuAwards,
        'Plan.PSUAwards': planPsuAwards,
        'Plan.Grants': planGrants,
        'Plan.OptionAwards': planOptionAwards,
        'Plan.TradePreClearanceRequests': planTradePreClearanceRequests,
        'Plan.EsppOfferingPeriods': planEsppOfferingPeriods,
        'Plan.PlanApprovals': planPlanApprovals,
        'Plan.PlanPlanTypeCategories': planPlanPlanTypeCategories,
        'Plan.TerminationRuleSet.Id': planTerminationRuleSetId,
        'Plan.TerminationRuleSet.TenantId': planTerminationRuleSetTenantId,
        'Plan.TerminationRuleSet.ExtraProperties': planTerminationRuleSetExtraProperties,
        'Plan.TerminationRuleSet.ConcurrencyStamp': planTerminationRuleSetConcurrencyStamp,
        'Plan.IsDeleted': planIsDeleted,
        'Plan.DeleterId': planDeleterId,
        'Plan.DeletionTime': planDeletionTime,
        'Plan.LastModificationTime': planLastModificationTime,
        'Plan.LastModifierId': planLastModifierId,
        'Plan.CreationTime': planCreationTime,
        'Plan.CreatorId': planCreatorId,
        'Plan.ExtraProperties': planExtraProperties,
        'Plan.ConcurrencyStamp': planConcurrencyStamp,
        'Plan.Id': planId,
        PoolId: poolId,
        'Pool.TenantId': poolTenantId,
        'Pool.CompanyId': poolCompanyId,
        'Pool.PoolName': poolPoolName,
        'Pool.NumberOfSharesAuthorised': poolNumberOfSharesAuthorised,
        'Pool.NumberOfSharesAvailable': poolNumberOfSharesAvailable,
        'Pool.NumberOfSharesUnAvailable': poolNumberOfSharesUnAvailable,
        'Pool.HasExternalPoolRefrence': poolHasExternalPoolRefrence,
        'Pool.Description': poolDescription,
        'Pool.ExternalPoolName': poolExternalPoolName,
        'Pool.ExternalPoolReferenceId': poolExternalPoolReferenceId,
        'Pool.Transactions': poolTransactions,
        'Pool.RSUAwards': poolRsuAwards,
        'Pool.PSUAwards': poolPsuAwards,
        'Pool.OptionAwards': poolOptionAwards,
        'Pool.Grants': poolGrants,
        'Pool.Plans': poolPlans,
        'Pool.IsDeleted': poolIsDeleted,
        'Pool.DeleterId': poolDeleterId,
        'Pool.DeletionTime': poolDeletionTime,
        'Pool.LastModificationTime': poolLastModificationTime,
        'Pool.LastModifierId': poolLastModifierId,
        'Pool.CreationTime': poolCreationTime,
        'Pool.CreatorId': poolCreatorId,
        'Pool.ExtraProperties': poolExtraProperties,
        'Pool.ConcurrencyStamp': poolConcurrencyStamp,
        'Pool.Id': poolId,
        GrantQuantity: grantQuantity,
        GrantNumber: grantNumber,
        GrantPrice: grantPrice,
        MarketValueAtGrant: marketValueAtGrant,
        ApprovalStatus: approvalStatus,
        IsEnabled: isEnabled,
        Remarks: remarks,
        Accepted: accepted,
        AcceptedAt: acceptedAt,
        AwardReleasedDate: awardReleasedDate,
        GrantReason: grantReason,
        Signature: signature,
        IsRSUAwardEmailNotificationSent: isRsuAwardEmailNotificationSent,
        IsRSUAwardReleased: isRsuAwardReleased,
        OldRsuAwardId: oldRsuAwardId,
        CancelledDate: cancelledDate,
        FileName: fileName,
        FairValue: fairValue,
        MethodTypeId: methodTypeId,
        AsOfDate: asOfDate,
        ResidualShare: residualShare,
        TargetOutStandingShare: targetOutStandingShare,
        TargetCancelledShare: targetCancelledShare,
        AdjustmentReason: adjustmentReason,
        TerminationRuleSetId: terminationRuleSetId,
        SettlementTypeId: settlementTypeId,
        RSUAwardApprovals: rsuAwardApprovals,
        RSUAwardVestingDates: rsuAwardVestingDates,
        RSUAwardEmailNotificationLogs: rsuAwardEmailNotificationLogs,
        TradePreClearanceParticipantAwards: tradePreClearanceParticipantAwards,
        FairValues: fairValues,
        ParticipantAwardTerminations: participantAwardTerminations,
        RSUAwardSignupTokens: rsuAwardSignupTokens,
        AwardDocuments: awardDocuments,
        'TerminationRuleSet.Id': terminationRuleSetId,
        'TerminationRuleSet.TenantId': terminationRuleSetTenantId,
        'TerminationRuleSet.ExtraProperties': terminationRuleSetExtraProperties,
        'TerminationRuleSet.ConcurrencyStamp': terminationRuleSetConcurrencyStamp,
        'SettlementType.Id': settlementTypeId,
        'SettlementType.SystemName': settlementTypeSystemName,
        'SettlementType.DisplayName': settlementTypeDisplayName,
        'SettlementType.IsCashSellType': settlementTypeIsCashSellType,
        'SettlementType.ExtraProperties': settlementTypeExtraProperties,
        'SettlementType.ConcurrencyStamp': settlementTypeConcurrencyStamp,
        IsDeleted: isDeleted,
        DeleterId: deleterId,
        DeletionTime: deletionTime,
        LastModificationTime: lastModificationTime,
        LastModifierId: lastModifierId,
        CreationTime: creationTime,
        CreatorId: creatorId,
        ExtraProperties: extraProperties,
        ConcurrencyStamp: concurrencyStamp,
        vestingTranches: vestingTranches,
        oldShare: oldShare,
        newShare: newShare,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param batchSize
   * @param requestBody
   * @returns boolean OK
   * @throws ApiError
   */
  public static postApiAwardApiAppRsuAwardImportUpsertRSuCustomVestingTranches(
    batchSize?: number,
    requestBody?: Array<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingTrancheDto>
  ): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/rsu-award-import/upsert-rSUCustom-vesting-tranches',
      query: {
        batchSize: batchSize,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
